function formatMoney(cents, currency, showCurrency, format = "amount", subunits = "100") {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString;
  let isISO = false;
  const isoCurrencyRegex = /^[A-Z]{3}$/;
  if (isoCurrencyRegex.test(currency)) {
    isISO = true;
  }
  if (currency && showCurrency && !isISO) {
    formatString = `${currency + `{{ ${format} }}`}`;
  } else if (currency && showCurrency && isISO) {
    formatString = `${`{{ ${format} }} ` + currency}`;
  } else if (showCurrency) {
    formatString = `\${{ ${format} }}`;
  } else {
    formatString = `{{ ${format} }}`;
  }
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return "0";
    }
    if (subunits === "1000") {
      precision = 3;
    }
    number = number / 100;
    const numberString = number.toFixed(precision);
    const parts = numberString.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return String(dollars + cents2);
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      const numberString = (cents / 100).toFixed(2);
      if (numberString.endsWith("00")) {
        value = formatWithDelimiters(cents, 0);
      } else {
        value = formatWithDelimiters(cents, 2);
      }
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
function initAnimationObserver() {
  const observerCallback = function(entries) {
    entries.forEach((entry) => {
      let element = document.getElementById(
        entry.target.dataset.id
      );
      if (entry.isIntersecting) {
        let replaceClasses = JSON.parse(
          entry.target.dataset.replace.replace(/'/g, '"')
        );
        let delay = entry.target.dataset.delay || "";
        let callback = entry.target.dataset.callback;
        let x = eval(callback);
        if (typeof x == "function") {
          x();
        }
        Object.keys(replaceClasses).forEach(function(key) {
          setTimeout(
            function() {
              if (element) {
                element.classList.remove(key);
                element.classList.add(replaceClasses[key]);
              } else {
                entry.target.classList.remove(key);
                entry.target.classList.add(replaceClasses[key]);
              }
            },
            parseInt(delay, 10)
          );
        });
      }
    });
  };
  const animationElements = document.querySelectorAll(".js\\:animation");
  const animationObserver = new IntersectionObserver(observerCallback);
  animationElements.forEach(function(target) {
    animationObserver.observe(target);
  });
}
const globals = {
  isOwnersClubMember: window.__initialData.isOwnersClubMember,
  // Audio related properties
  click_audio: window.__initialData.click_audio,
  success_audio: window.__initialData.success_audio,
  enable_audio: window.__initialData.enable_audio,
  audio_popup: window.__initialData.audio_popup,
  // Scroll related properties
  is_scrolled: window.__initialData.is_scrolled,
  // Boolean to toggle the dynamic header when scrolling up or down
  prev_scroll_pos: window.__initialData.prev_scroll_pos,
  // Calculates the scroll direction for the dynamic header
  scroll_up: window.__initialData.scroll_up,
  // Boolean to toggle the the "Back to top" button
  scroll_up_force: window.__initialData.scroll_up_force,
  // Boolean to force the "Back to top" to be hidden
  hide_header: window.__initialData.hide_header,
  // Boolean to hide header when opening other overlays
  reduce_product_zindex: window.__initialData.reduce_product_zindex,
  // Boolean to hide header when opening other overlays
  // Mouse position properties
  mouse_x: window.__initialData.mouse_x,
  // Mouse position X to position zoomed images
  mouse_y: window.__initialData.mouse_y,
  // Mouse position Y to position zoomed images
  // Menu related properties
  menu_drawer: window.__initialData.menu_drawer,
  // Boolean to toggle the menu drawer
  mobile_nav: window.__initialData.mobile_nav,
  // Boolean to toggle Mobile Navigation Drawer
  menu_nested: window.__initialData.menu_nested,
  // Boolean to toggle the nested menu drawer
  // Popup related properties
  age_popup: window.__initialData.age_popup,
  // Boolean to toggle the age popup
  filter_popup: window.__initialData.filter_popup,
  // Boolean to toggle the filter popup
  localization_popup: window.__initialData.localization_popup,
  // Boolean to toggle the localization popup
  // Geolocation related properties
  country: window.__initialData.country,
  // Alert related properties
  show_alert: window.__initialData.show_alert,
  // Boolean to toggle the alert
  error_title: window.__initialData.error_title,
  // String for alert title
  error_message: window.__initialData.error_message,
  // String for alert message
  // Product related properties
  recent_products: window.__initialData.recent_products,
  // Array of recently viewed products
  incomplete_fields: window.__initialData.incomplete_fields,
  // Boolean to check if product options are incomplete
  selectedImageIndex: window.__initialData.selectedImageIndex,
  // Index of the selected product image (used for fullscreen slider)
  // Cart related properties
  cart_drawer: window.__initialData.cart_drawer,
  // Boolean to toggle the cart drawer
  cart_modal: window.__initialData.cart_modal,
  // Boolean to toggle the cart modal
  cart_loading: window.__initialData.cart_loading,
  // Boolean to toggle the cart loading state
  cart_alert: window.__initialData.cart_alert,
  // Boolean to toggle the cart alert
  cart_delay: window.__initialData.cart_delay,
  // Set the delay for the cart alert to close
  cart_delay_width: window.__initialData.cart_delay_width,
  // Set the width for the cart alert progress bar
  cart_behavior: window.__initialData.cart_behavior,
  // Set to 'drawer' 'alert' or 'redirect'
  cart: window.__initialData.cart,
  // Object to store the cart data
  progress_bar_threshold: window.__initialData.progress_bar_threshold,
  // Set the threshold for the 'free shipping' progress bar
  // Search related properties
  search_loading: window.__initialData.search_loading,
  // Boolean to toggle the search loading state
  search_active: window.__initialData.search_active,
  // Boolean to toggle the search overlay
  search_items: window.__initialData.search_items,
  // Array of product search results
  search_items_pages: window.__initialData.search_items_pages,
  // Aray of page search results
  search_items_collections: window.__initialData.search_items_collections,
  // Array of collection search results
  search_items_articles: window.__initialData.search_items_articles,
  // Array of article search results
  search_items_queries: window.__initialData.search_items_queries,
  // Array of query search results
  // Collection and pagination related properties
  collection_loading: window.__initialData.collection_loading,
  // Boolean to toggle the collection loading state
  pagination_total_pages: window.__initialData.pagination_total_pages,
  // Total number of pages for the current collection
  pagination_current_page: window.__initialData.pagination_current_page,
  // Current page number in pagination
  pagination_section: window.__initialData.pagination_section,
  // Points to a {{ section.id }} to paginate
  // Filter related properties
  filter_min_price: window.__initialData.filter_min_price,
  // Value of the min price input
  filter_max_price: window.__initialData.filter_max_price,
  // Value of the max price input
  filter_min: window.__initialData.filter_min,
  // Min price for the current collection
  filter_max: window.__initialData.filter_max,
  // Max price for the current collection
  filter_min_thumb: window.__initialData.filter_min_thumb,
  // Sets position of min price thumb
  filter_max_thumb: window.__initialData.filter_max_thumb,
  // Sets position of max price thumb
  // Store related properties
  currency_symbol: window.__initialData.currency_symbol,
  button_loading: window.__initialData.button_loading
};
var flushPending = false;
var flushing = false;
var queue = [];
var lastFlushedIndex = -1;
function scheduler(callback2) {
  queueJob(callback2);
}
function queueJob(job) {
  if (!queue.includes(job))
    queue.push(job);
  queueFlush();
}
function dequeueJob(job) {
  let index = queue.indexOf(job);
  if (index !== -1 && index > lastFlushedIndex)
    queue.splice(index, 1);
}
function queueFlush() {
  if (!flushing && !flushPending) {
    flushPending = true;
    queueMicrotask(flushJobs);
  }
}
function flushJobs() {
  flushPending = false;
  flushing = true;
  for (let i = 0; i < queue.length; i++) {
    queue[i]();
    lastFlushedIndex = i;
  }
  queue.length = 0;
  lastFlushedIndex = -1;
  flushing = false;
}
var reactive;
var effect;
var release;
var raw;
var shouldSchedule = true;
function disableEffectScheduling(callback2) {
  shouldSchedule = false;
  callback2();
  shouldSchedule = true;
}
function setReactivityEngine(engine) {
  reactive = engine.reactive;
  release = engine.release;
  effect = (callback2) => engine.effect(callback2, { scheduler: (task) => {
    if (shouldSchedule) {
      scheduler(task);
    } else {
      task();
    }
  } });
  raw = engine.raw;
}
function overrideEffect(override) {
  effect = override;
}
function elementBoundEffect(el) {
  let cleanup2 = () => {
  };
  let wrappedEffect = (callback2) => {
    let effectReference = effect(callback2);
    if (!el._x_effects) {
      el._x_effects = /* @__PURE__ */ new Set();
      el._x_runEffects = () => {
        el._x_effects.forEach((i) => i());
      };
    }
    el._x_effects.add(effectReference);
    cleanup2 = () => {
      if (effectReference === void 0)
        return;
      el._x_effects.delete(effectReference);
      release(effectReference);
    };
    return effectReference;
  };
  return [wrappedEffect, () => {
    cleanup2();
  }];
}
function watch(getter, callback2) {
  let firstTime = true;
  let oldValue;
  let effectReference = effect(() => {
    let value = getter();
    JSON.stringify(value);
    if (!firstTime) {
      queueMicrotask(() => {
        callback2(value, oldValue);
        oldValue = value;
      });
    } else {
      oldValue = value;
    }
    firstTime = false;
  });
  return () => release(effectReference);
}
function dispatch(el, name, detail = {}) {
  el.dispatchEvent(
    new CustomEvent(name, {
      detail,
      bubbles: true,
      // Allows events to pass the shadow DOM barrier.
      composed: true,
      cancelable: true
    })
  );
}
function walk(el, callback2) {
  if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
    Array.from(el.children).forEach((el2) => walk(el2, callback2));
    return;
  }
  let skip = false;
  callback2(el, () => skip = true);
  if (skip)
    return;
  let node = el.firstElementChild;
  while (node) {
    walk(node, callback2);
    node = node.nextElementSibling;
  }
}
function warn(message, ...args) {
  console.warn(`Alpine Warning: ${message}`, ...args);
}
var started = false;
function start() {
  if (started)
    warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
  started = true;
  if (!document.body)
    warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
  dispatch(document, "alpine:init");
  dispatch(document, "alpine:initializing");
  startObservingMutations();
  onElAdded((el) => initTree(el, walk));
  onElRemoved((el) => destroyTree(el));
  onAttributesAdded((el, attrs) => {
    directives(el, attrs).forEach((handle) => handle());
  });
  let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
  Array.from(document.querySelectorAll(allSelectors().join(","))).filter(outNestedComponents).forEach((el) => {
    initTree(el);
  });
  dispatch(document, "alpine:initialized");
}
var rootSelectorCallbacks = [];
var initSelectorCallbacks = [];
function rootSelectors() {
  return rootSelectorCallbacks.map((fn) => fn());
}
function allSelectors() {
  return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
}
function addRootSelector(selectorCallback) {
  rootSelectorCallbacks.push(selectorCallback);
}
function addInitSelector(selectorCallback) {
  initSelectorCallbacks.push(selectorCallback);
}
function closestRoot(el, includeInitSelectors = false) {
  return findClosest(el, (element2) => {
    const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
    if (selectors.some((selector) => element2.matches(selector)))
      return true;
  });
}
function findClosest(el, callback2) {
  if (!el)
    return;
  if (callback2(el))
    return el;
  if (el._x_teleportBack)
    el = el._x_teleportBack;
  if (!el.parentElement)
    return;
  return findClosest(el.parentElement, callback2);
}
function isRoot(el) {
  return rootSelectors().some((selector) => el.matches(selector));
}
var initInterceptors = [];
function interceptInit(callback2) {
  initInterceptors.push(callback2);
}
function initTree(el, walker = walk, intercept = () => {
}) {
  deferHandlingDirectives(() => {
    walker(el, (el2, skip) => {
      intercept(el2, skip);
      initInterceptors.forEach((i) => i(el2, skip));
      directives(el2, el2.attributes).forEach((handle) => handle());
      el2._x_ignore && skip();
    });
  });
}
function destroyTree(root, walker = walk) {
  walker(root, (el) => {
    cleanupAttributes(el);
    cleanupElement(el);
  });
}
var onAttributeAddeds = [];
var onElRemoveds = [];
var onElAddeds = [];
function onElAdded(callback2) {
  onElAddeds.push(callback2);
}
function onElRemoved(el, callback2) {
  if (typeof callback2 === "function") {
    if (!el._x_cleanups)
      el._x_cleanups = [];
    el._x_cleanups.push(callback2);
  } else {
    callback2 = el;
    onElRemoveds.push(callback2);
  }
}
function onAttributesAdded(callback2) {
  onAttributeAddeds.push(callback2);
}
function onAttributeRemoved(el, name, callback2) {
  if (!el._x_attributeCleanups)
    el._x_attributeCleanups = {};
  if (!el._x_attributeCleanups[name])
    el._x_attributeCleanups[name] = [];
  el._x_attributeCleanups[name].push(callback2);
}
function cleanupAttributes(el, names) {
  if (!el._x_attributeCleanups)
    return;
  Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
    if (names === void 0 || names.includes(name)) {
      value.forEach((i) => i());
      delete el._x_attributeCleanups[name];
    }
  });
}
function cleanupElement(el) {
  if (el._x_cleanups) {
    while (el._x_cleanups.length)
      el._x_cleanups.pop()();
  }
}
var observer = new MutationObserver(onMutate);
var currentlyObserving = false;
function startObservingMutations() {
  observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
  currentlyObserving = true;
}
function stopObservingMutations() {
  flushObserver();
  observer.disconnect();
  currentlyObserving = false;
}
var queuedMutations = [];
function flushObserver() {
  let records = observer.takeRecords();
  queuedMutations.push(() => records.length > 0 && onMutate(records));
  let queueLengthWhenTriggered = queuedMutations.length;
  queueMicrotask(() => {
    if (queuedMutations.length === queueLengthWhenTriggered) {
      while (queuedMutations.length > 0)
        queuedMutations.shift()();
    }
  });
}
function mutateDom(callback2) {
  if (!currentlyObserving)
    return callback2();
  stopObservingMutations();
  let result = callback2();
  startObservingMutations();
  return result;
}
var isCollecting = false;
var deferredMutations = [];
function deferMutations() {
  isCollecting = true;
}
function flushAndStopDeferringMutations() {
  isCollecting = false;
  onMutate(deferredMutations);
  deferredMutations = [];
}
function onMutate(mutations) {
  if (isCollecting) {
    deferredMutations = deferredMutations.concat(mutations);
    return;
  }
  let addedNodes = /* @__PURE__ */ new Set();
  let removedNodes = /* @__PURE__ */ new Set();
  let addedAttributes = /* @__PURE__ */ new Map();
  let removedAttributes = /* @__PURE__ */ new Map();
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].target._x_ignoreMutationObserver)
      continue;
    if (mutations[i].type === "childList") {
      mutations[i].addedNodes.forEach((node) => node.nodeType === 1 && addedNodes.add(node));
      mutations[i].removedNodes.forEach((node) => node.nodeType === 1 && removedNodes.add(node));
    }
    if (mutations[i].type === "attributes") {
      let el = mutations[i].target;
      let name = mutations[i].attributeName;
      let oldValue = mutations[i].oldValue;
      let add2 = () => {
        if (!addedAttributes.has(el))
          addedAttributes.set(el, []);
        addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
      };
      let remove = () => {
        if (!removedAttributes.has(el))
          removedAttributes.set(el, []);
        removedAttributes.get(el).push(name);
      };
      if (el.hasAttribute(name) && oldValue === null) {
        add2();
      } else if (el.hasAttribute(name)) {
        remove();
        add2();
      } else {
        remove();
      }
    }
  }
  removedAttributes.forEach((attrs, el) => {
    cleanupAttributes(el, attrs);
  });
  addedAttributes.forEach((attrs, el) => {
    onAttributeAddeds.forEach((i) => i(el, attrs));
  });
  for (let node of removedNodes) {
    if (addedNodes.has(node))
      continue;
    onElRemoveds.forEach((i) => i(node));
    destroyTree(node);
  }
  addedNodes.forEach((node) => {
    node._x_ignoreSelf = true;
    node._x_ignore = true;
  });
  for (let node of addedNodes) {
    if (removedNodes.has(node))
      continue;
    if (!node.isConnected)
      continue;
    delete node._x_ignoreSelf;
    delete node._x_ignore;
    onElAddeds.forEach((i) => i(node));
    node._x_ignore = true;
    node._x_ignoreSelf = true;
  }
  addedNodes.forEach((node) => {
    delete node._x_ignoreSelf;
    delete node._x_ignore;
  });
  addedNodes = null;
  removedNodes = null;
  addedAttributes = null;
  removedAttributes = null;
}
function scope(node) {
  return mergeProxies(closestDataStack(node));
}
function addScopeToNode(node, data2, referenceNode) {
  node._x_dataStack = [data2, ...closestDataStack(referenceNode || node)];
  return () => {
    node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
  };
}
function closestDataStack(node) {
  if (node._x_dataStack)
    return node._x_dataStack;
  if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
    return closestDataStack(node.host);
  }
  if (!node.parentNode) {
    return [];
  }
  return closestDataStack(node.parentNode);
}
function mergeProxies(objects) {
  return new Proxy({ objects }, mergeProxyTrap);
}
var mergeProxyTrap = {
  ownKeys({ objects }) {
    return Array.from(
      new Set(objects.flatMap((i) => Object.keys(i)))
    );
  },
  has({ objects }, name) {
    if (name == Symbol.unscopables)
      return false;
    return objects.some(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name)
    );
  },
  get({ objects }, name, thisProxy) {
    if (name == "toJSON")
      return collapseProxies;
    return Reflect.get(
      objects.find(
        (obj) => Reflect.has(obj, name)
      ) || {},
      name,
      thisProxy
    );
  },
  set({ objects }, name, value, thisProxy) {
    const target = objects.find(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name)
    ) || objects[objects.length - 1];
    const descriptor = Object.getOwnPropertyDescriptor(target, name);
    if ((descriptor == null ? void 0 : descriptor.set) && (descriptor == null ? void 0 : descriptor.get))
      return Reflect.set(target, name, value, thisProxy);
    return Reflect.set(target, name, value);
  }
};
function collapseProxies() {
  let keys = Reflect.ownKeys(this);
  return keys.reduce((acc, key) => {
    acc[key] = Reflect.get(this, key);
    return acc;
  }, {});
}
function initInterceptors2(data2) {
  let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
  let recurse = (obj, basePath = "") => {
    Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
      if (enumerable === false || value === void 0)
        return;
      if (typeof value === "object" && value !== null && value.__v_skip)
        return;
      let path = basePath === "" ? key : `${basePath}.${key}`;
      if (typeof value === "object" && value !== null && value._x_interceptor) {
        obj[key] = value.initialize(data2, path, key);
      } else {
        if (isObject2(value) && value !== obj && !(value instanceof Element)) {
          recurse(value, path);
        }
      }
    });
  };
  return recurse(data2);
}
function interceptor(callback2, mutateObj = () => {
}) {
  let obj = {
    initialValue: void 0,
    _x_interceptor: true,
    initialize(data2, path, key) {
      return callback2(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key);
    }
  };
  mutateObj(obj);
  return (initialValue) => {
    if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
      let initialize = obj.initialize.bind(obj);
      obj.initialize = (data2, path, key) => {
        let innerValue = initialValue.initialize(data2, path, key);
        obj.initialValue = innerValue;
        return initialize(data2, path, key);
      };
    } else {
      obj.initialValue = initialValue;
    }
    return obj;
  };
}
function get(obj, path) {
  return path.split(".").reduce((carry, segment) => carry[segment], obj);
}
function set(obj, path, value) {
  if (typeof path === "string")
    path = path.split(".");
  if (path.length === 1)
    obj[path[0]] = value;
  else if (path.length === 0)
    throw error;
  else {
    if (obj[path[0]])
      return set(obj[path[0]], path.slice(1), value);
    else {
      obj[path[0]] = {};
      return set(obj[path[0]], path.slice(1), value);
    }
  }
}
var magics = {};
function magic(name, callback2) {
  magics[name] = callback2;
}
function injectMagics(obj, el) {
  Object.entries(magics).forEach(([name, callback2]) => {
    let memoizedUtilities = null;
    function getUtilities() {
      if (memoizedUtilities) {
        return memoizedUtilities;
      } else {
        let [utilities, cleanup2] = getElementBoundUtilities(el);
        memoizedUtilities = { interceptor, ...utilities };
        onElRemoved(el, cleanup2);
        return memoizedUtilities;
      }
    }
    Object.defineProperty(obj, `$${name}`, {
      get() {
        return callback2(el, getUtilities());
      },
      enumerable: false
    });
  });
  return obj;
}
function tryCatch(el, expression, callback2, ...args) {
  try {
    return callback2(...args);
  } catch (e) {
    handleError(e, el, expression);
  }
}
function handleError(error2, el, expression = void 0) {
  error2 = Object.assign(
    error2 ?? { message: "No error message given." },
    { el, expression }
  );
  console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
  setTimeout(() => {
    throw error2;
  }, 0);
}
var shouldAutoEvaluateFunctions = true;
function dontAutoEvaluateFunctions(callback2) {
  let cache = shouldAutoEvaluateFunctions;
  shouldAutoEvaluateFunctions = false;
  let result = callback2();
  shouldAutoEvaluateFunctions = cache;
  return result;
}
function evaluate(el, expression, extras = {}) {
  let result;
  evaluateLater(el, expression)((value) => result = value, extras);
  return result;
}
function evaluateLater(...args) {
  return theEvaluatorFunction(...args);
}
var theEvaluatorFunction = normalEvaluator;
function setEvaluator(newEvaluator) {
  theEvaluatorFunction = newEvaluator;
}
function normalEvaluator(el, expression) {
  let overriddenMagics = {};
  injectMagics(overriddenMagics, el);
  let dataStack = [overriddenMagics, ...closestDataStack(el)];
  let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
  return tryCatch.bind(null, el, expression, evaluator);
}
function generateEvaluatorFromFunction(dataStack, func) {
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
    runIfTypeOfFunction(receiver, result);
  };
}
var evaluatorMemo = {};
function generateFunctionFromString(expression, el) {
  if (evaluatorMemo[expression]) {
    return evaluatorMemo[expression];
  }
  let AsyncFunction = Object.getPrototypeOf(async function() {
  }).constructor;
  let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
  const safeAsyncFunction = () => {
    try {
      let func2 = new AsyncFunction(
        ["__self", "scope"],
        `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
      );
      Object.defineProperty(func2, "name", {
        value: `[Alpine] ${expression}`
      });
      return func2;
    } catch (error2) {
      handleError(error2, el, expression);
      return Promise.resolve();
    }
  };
  let func = safeAsyncFunction();
  evaluatorMemo[expression] = func;
  return func;
}
function generateEvaluatorFromString(dataStack, expression, el) {
  let func = generateFunctionFromString(expression, el);
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    func.result = void 0;
    func.finished = false;
    let completeScope = mergeProxies([scope2, ...dataStack]);
    if (typeof func === "function") {
      let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
      if (func.finished) {
        runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
        func.result = void 0;
      } else {
        promise.then((result) => {
          runIfTypeOfFunction(receiver, result, completeScope, params, el);
        }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
      }
    }
  };
}
function runIfTypeOfFunction(receiver, value, scope2, params, el) {
  if (shouldAutoEvaluateFunctions && typeof value === "function") {
    let result = value.apply(scope2, params);
    if (result instanceof Promise) {
      result.then((i) => runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2) => handleError(error2, el, value));
    } else {
      receiver(result);
    }
  } else if (typeof value === "object" && value instanceof Promise) {
    value.then((i) => receiver(i));
  } else {
    receiver(value);
  }
}
var prefixAsString = "x-";
function prefix(subject = "") {
  return prefixAsString + subject;
}
function setPrefix(newPrefix) {
  prefixAsString = newPrefix;
}
var directiveHandlers = {};
function directive(name, callback2) {
  directiveHandlers[name] = callback2;
  return {
    before(directive2) {
      if (!directiveHandlers[directive2]) {
        console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
        return;
      }
      const pos = directiveOrder.indexOf(directive2);
      directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
    }
  };
}
function directives(el, attributes, originalAttributeOverride) {
  attributes = Array.from(attributes);
  if (el._x_virtualDirectives) {
    let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(vAttributes);
    vAttributes = vAttributes.map((attribute) => {
      if (staticAttributes.find((attr) => attr.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    attributes = attributes.concat(vAttributes);
  }
  let transformedAttributeMap = {};
  let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
  return directives2.map((directive2) => {
    return getDirectiveHandler(el, directive2);
  });
}
function attributesOnly(attributes) {
  return Array.from(attributes).map(toTransformedAttributes()).filter((attr) => !outNonAlpineAttributes(attr));
}
var isDeferringHandlers = false;
var directiveHandlerStacks = /* @__PURE__ */ new Map();
var currentHandlerStackKey = Symbol();
function deferHandlingDirectives(callback2) {
  isDeferringHandlers = true;
  let key = Symbol();
  currentHandlerStackKey = key;
  directiveHandlerStacks.set(key, []);
  let flushHandlers = () => {
    while (directiveHandlerStacks.get(key).length)
      directiveHandlerStacks.get(key).shift()();
    directiveHandlerStacks.delete(key);
  };
  let stopDeferring = () => {
    isDeferringHandlers = false;
    flushHandlers();
  };
  callback2(flushHandlers);
  stopDeferring();
}
function getElementBoundUtilities(el) {
  let cleanups = [];
  let cleanup2 = (callback2) => cleanups.push(callback2);
  let [effect3, cleanupEffect] = elementBoundEffect(el);
  cleanups.push(cleanupEffect);
  let utilities = {
    Alpine: alpine_default,
    effect: effect3,
    cleanup: cleanup2,
    evaluateLater: evaluateLater.bind(evaluateLater, el),
    evaluate: evaluate.bind(evaluate, el)
  };
  let doCleanup = () => cleanups.forEach((i) => i());
  return [utilities, doCleanup];
}
function getDirectiveHandler(el, directive2) {
  let noop = () => {
  };
  let handler4 = directiveHandlers[directive2.type] || noop;
  let [utilities, cleanup2] = getElementBoundUtilities(el);
  onAttributeRemoved(el, directive2.original, cleanup2);
  let fullHandler = () => {
    if (el._x_ignore || el._x_ignoreSelf)
      return;
    handler4.inline && handler4.inline(el, directive2, utilities);
    handler4 = handler4.bind(handler4, el, directive2, utilities);
    isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler4) : handler4();
  };
  fullHandler.runCleanups = cleanup2;
  return fullHandler;
}
var startingWith = (subject, replacement) => ({ name, value }) => {
  if (name.startsWith(subject))
    name = name.replace(subject, replacement);
  return { name, value };
};
var into = (i) => i;
function toTransformedAttributes(callback2 = () => {
}) {
  return ({ name, value }) => {
    let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform) => {
      return transform(carry);
    }, { name, value });
    if (newName !== name)
      callback2(newName, name);
    return { name: newName, value: newValue };
  };
}
var attributeTransformers = [];
function mapAttributes(callback2) {
  attributeTransformers.push(callback2);
}
function outNonAlpineAttributes({ name }) {
  return alpineAttributeRegex().test(name);
}
var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
  return ({ name, value }) => {
    let typeMatch = name.match(alpineAttributeRegex());
    let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
    let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
    let original = originalAttributeOverride || transformedAttributeMap[name] || name;
    return {
      type: typeMatch ? typeMatch[1] : null,
      value: valueMatch ? valueMatch[1] : null,
      modifiers: modifiers.map((i) => i.replace(".", "")),
      expression: value,
      original
    };
  };
}
var DEFAULT = "DEFAULT";
var directiveOrder = [
  "ignore",
  "ref",
  "data",
  "id",
  "anchor",
  "bind",
  "init",
  "for",
  "model",
  "modelable",
  "transition",
  "show",
  "if",
  DEFAULT,
  "teleport"
];
function byPriority(a, b) {
  let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
  let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
  return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
}
var tickStack = [];
var isHolding = false;
function nextTick(callback2 = () => {
}) {
  queueMicrotask(() => {
    isHolding || setTimeout(() => {
      releaseNextTicks();
    });
  });
  return new Promise((res) => {
    tickStack.push(() => {
      callback2();
      res();
    });
  });
}
function releaseNextTicks() {
  isHolding = false;
  while (tickStack.length)
    tickStack.shift()();
}
function holdNextTicks() {
  isHolding = true;
}
function setClasses(el, value) {
  if (Array.isArray(value)) {
    return setClassesFromString(el, value.join(" "));
  } else if (typeof value === "object" && value !== null) {
    return setClassesFromObject(el, value);
  } else if (typeof value === "function") {
    return setClasses(el, value());
  }
  return setClassesFromString(el, value);
}
function setClassesFromString(el, classString) {
  let missingClasses = (classString2) => classString2.split(" ").filter((i) => !el.classList.contains(i)).filter(Boolean);
  let addClassesAndReturnUndo = (classes) => {
    el.classList.add(...classes);
    return () => {
      el.classList.remove(...classes);
    };
  };
  classString = classString === true ? classString = "" : classString || "";
  return addClassesAndReturnUndo(missingClasses(classString));
}
function setClassesFromObject(el, classObject) {
  let split = (classString) => classString.split(" ").filter(Boolean);
  let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
  let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
  let added = [];
  let removed = [];
  forRemove.forEach((i) => {
    if (el.classList.contains(i)) {
      el.classList.remove(i);
      removed.push(i);
    }
  });
  forAdd.forEach((i) => {
    if (!el.classList.contains(i)) {
      el.classList.add(i);
      added.push(i);
    }
  });
  return () => {
    removed.forEach((i) => el.classList.add(i));
    added.forEach((i) => el.classList.remove(i));
  };
}
function setStyles(el, value) {
  if (typeof value === "object" && value !== null) {
    return setStylesFromObject(el, value);
  }
  return setStylesFromString(el, value);
}
function setStylesFromObject(el, value) {
  let previousStyles = {};
  Object.entries(value).forEach(([key, value2]) => {
    previousStyles[key] = el.style[key];
    if (!key.startsWith("--")) {
      key = kebabCase(key);
    }
    el.style.setProperty(key, value2);
  });
  setTimeout(() => {
    if (el.style.length === 0) {
      el.removeAttribute("style");
    }
  });
  return () => {
    setStyles(el, previousStyles);
  };
}
function setStylesFromString(el, value) {
  let cache = el.getAttribute("style", value);
  el.setAttribute("style", value);
  return () => {
    el.setAttribute("style", cache || "");
  };
}
function kebabCase(subject) {
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function once(callback2, fallback = () => {
}) {
  let called = false;
  return function() {
    if (!called) {
      called = true;
      callback2.apply(this, arguments);
    } else {
      fallback.apply(this, arguments);
    }
  };
}
directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "function")
    expression = evaluate2(expression);
  if (expression === false)
    return;
  if (!expression || typeof expression === "boolean") {
    registerTransitionsFromHelper(el, modifiers, value);
  } else {
    registerTransitionsFromClassString(el, expression, value);
  }
});
function registerTransitionsFromClassString(el, classString, stage) {
  registerTransitionObject(el, setClasses, "");
  let directiveStorageMap = {
    "enter": (classes) => {
      el._x_transition.enter.during = classes;
    },
    "enter-start": (classes) => {
      el._x_transition.enter.start = classes;
    },
    "enter-end": (classes) => {
      el._x_transition.enter.end = classes;
    },
    "leave": (classes) => {
      el._x_transition.leave.during = classes;
    },
    "leave-start": (classes) => {
      el._x_transition.leave.start = classes;
    },
    "leave-end": (classes) => {
      el._x_transition.leave.end = classes;
    }
  };
  directiveStorageMap[stage](classString);
}
function registerTransitionsFromHelper(el, modifiers, stage) {
  registerTransitionObject(el, setStyles);
  let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
  let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
  let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
  if (modifiers.includes("in") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index < modifiers.indexOf("out"));
  }
  if (modifiers.includes("out") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index > modifiers.indexOf("out"));
  }
  let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
  let wantsOpacity = wantsAll || modifiers.includes("opacity");
  let wantsScale = wantsAll || modifiers.includes("scale");
  let opacityValue = wantsOpacity ? 0 : 1;
  let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
  let delay3 = modifierValue(modifiers, "delay", 0) / 1e3;
  let origin = modifierValue(modifiers, "origin", "center");
  let property = "opacity, transform";
  let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
  let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
  let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
  if (transitioningIn) {
    el._x_transition.enter.during = {
      transformOrigin: origin,
      transitionDelay: `${delay3}s`,
      transitionProperty: property,
      transitionDuration: `${durationIn}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.enter.start = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
    el._x_transition.enter.end = {
      opacity: 1,
      transform: `scale(1)`
    };
  }
  if (transitioningOut) {
    el._x_transition.leave.during = {
      transformOrigin: origin,
      transitionDelay: `${delay3}s`,
      transitionProperty: property,
      transitionDuration: `${durationOut}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.leave.start = {
      opacity: 1,
      transform: `scale(1)`
    };
    el._x_transition.leave.end = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
  }
}
function registerTransitionObject(el, setFunction, defaultValue = {}) {
  if (!el._x_transition)
    el._x_transition = {
      enter: { during: defaultValue, start: defaultValue, end: defaultValue },
      leave: { during: defaultValue, start: defaultValue, end: defaultValue },
      in(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.enter.during,
          start: this.enter.start,
          end: this.enter.end
        }, before, after);
      },
      out(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.leave.during,
          start: this.leave.start,
          end: this.leave.end
        }, before, after);
      }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
  const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let clickAwayCompatibleShow = () => nextTick2(show);
  if (value) {
    if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
      el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
    } else {
      el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
    }
    return;
  }
  el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
    el._x_transition.out(() => {
    }, () => resolve(hide));
    el._x_transitioning && el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
  }) : Promise.resolve(hide);
  queueMicrotask(() => {
    let closest = closestHide(el);
    if (closest) {
      if (!closest._x_hideChildren)
        closest._x_hideChildren = [];
      closest._x_hideChildren.push(el);
    } else {
      nextTick2(() => {
        let hideAfterChildren = (el2) => {
          let carry = Promise.all([
            el2._x_hidePromise,
            ...(el2._x_hideChildren || []).map(hideAfterChildren)
          ]).then(([i]) => i());
          delete el2._x_hidePromise;
          delete el2._x_hideChildren;
          return carry;
        };
        hideAfterChildren(el).catch((e) => {
          if (!e.isFromCancelledTransition)
            throw e;
        });
      });
    }
  });
};
function closestHide(el) {
  let parent = el.parentNode;
  if (!parent)
    return;
  return parent._x_hidePromise ? parent : closestHide(parent);
}
function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
}, after = () => {
}) {
  if (el._x_transitioning)
    el._x_transitioning.cancel();
  if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
    before();
    after();
    return;
  }
  let undoStart, undoDuring, undoEnd;
  performTransition(el, {
    start() {
      undoStart = setFunction(el, start2);
    },
    during() {
      undoDuring = setFunction(el, during);
    },
    before,
    end() {
      undoStart();
      undoEnd = setFunction(el, end);
    },
    after,
    cleanup() {
      undoDuring();
      undoEnd();
    }
  });
}
function performTransition(el, stages) {
  let interrupted, reachedBefore, reachedEnd;
  let finish = once(() => {
    mutateDom(() => {
      interrupted = true;
      if (!reachedBefore)
        stages.before();
      if (!reachedEnd) {
        stages.end();
        releaseNextTicks();
      }
      stages.after();
      if (el.isConnected)
        stages.cleanup();
      delete el._x_transitioning;
    });
  });
  el._x_transitioning = {
    beforeCancels: [],
    beforeCancel(callback2) {
      this.beforeCancels.push(callback2);
    },
    cancel: once(function() {
      while (this.beforeCancels.length) {
        this.beforeCancels.shift()();
      }
      finish();
    }),
    finish
  };
  mutateDom(() => {
    stages.start();
    stages.during();
  });
  holdNextTicks();
  requestAnimationFrame(() => {
    if (interrupted)
      return;
    let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
    let delay3 = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
    if (duration === 0)
      duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
    mutateDom(() => {
      stages.before();
    });
    reachedBefore = true;
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      mutateDom(() => {
        stages.end();
      });
      releaseNextTicks();
      setTimeout(el._x_transitioning.finish, duration + delay3);
      reachedEnd = true;
    });
  });
}
function modifierValue(modifiers, key, fallback) {
  if (modifiers.indexOf(key) === -1)
    return fallback;
  const rawValue = modifiers[modifiers.indexOf(key) + 1];
  if (!rawValue)
    return fallback;
  if (key === "scale") {
    if (isNaN(rawValue))
      return fallback;
  }
  if (key === "duration" || key === "delay") {
    let match = rawValue.match(/([0-9]+)ms/);
    if (match)
      return match[1];
  }
  if (key === "origin") {
    if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
      return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
    }
  }
  return rawValue;
}
var isCloning = false;
function skipDuringClone(callback2, fallback = () => {
}) {
  return (...args) => isCloning ? fallback(...args) : callback2(...args);
}
function onlyDuringClone(callback2) {
  return (...args) => isCloning && callback2(...args);
}
var interceptors = [];
function interceptClone(callback2) {
  interceptors.push(callback2);
}
function cloneNode(from, to) {
  interceptors.forEach((i) => i(from, to));
  isCloning = true;
  dontRegisterReactiveSideEffects(() => {
    initTree(to, (el, callback2) => {
      callback2(el, () => {
      });
    });
  });
  isCloning = false;
}
var isCloningLegacy = false;
function clone(oldEl, newEl) {
  if (!newEl._x_dataStack)
    newEl._x_dataStack = oldEl._x_dataStack;
  isCloning = true;
  isCloningLegacy = true;
  dontRegisterReactiveSideEffects(() => {
    cloneTree(newEl);
  });
  isCloning = false;
  isCloningLegacy = false;
}
function cloneTree(el) {
  let hasRunThroughFirstEl = false;
  let shallowWalker = (el2, callback2) => {
    walk(el2, (el3, skip) => {
      if (hasRunThroughFirstEl && isRoot(el3))
        return skip();
      hasRunThroughFirstEl = true;
      callback2(el3, skip);
    });
  };
  initTree(el, shallowWalker);
}
function dontRegisterReactiveSideEffects(callback2) {
  let cache = effect;
  overrideEffect((callback22, el) => {
    let storedEffect = cache(callback22);
    release(storedEffect);
    return () => {
    };
  });
  callback2();
  overrideEffect(cache);
}
function bind(el, name, value, modifiers = []) {
  if (!el._x_bindings)
    el._x_bindings = reactive({});
  el._x_bindings[name] = value;
  name = modifiers.includes("camel") ? camelCase(name) : name;
  switch (name) {
    case "value":
      bindInputValue(el, value);
      break;
    case "style":
      bindStyles(el, value);
      break;
    case "class":
      bindClasses(el, value);
      break;
    case "selected":
    case "checked":
      bindAttributeAndProperty(el, name, value);
      break;
    default:
      bindAttribute(el, name, value);
      break;
  }
}
function bindInputValue(el, value) {
  if (el.type === "radio") {
    if (el.attributes.value === void 0) {
      el.value = value;
    }
    if (window.fromModel) {
      if (typeof value === "boolean") {
        el.checked = safeParseBoolean(el.value) === value;
      } else {
        el.checked = checkedAttrLooseCompare(el.value, value);
      }
    }
  } else if (el.type === "checkbox") {
    if (Number.isInteger(value)) {
      el.value = value;
    } else if (!Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
      el.value = String(value);
    } else {
      if (Array.isArray(value)) {
        el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
      } else {
        el.checked = !!value;
      }
    }
  } else if (el.tagName === "SELECT") {
    updateSelect(el, value);
  } else {
    if (el.value === value)
      return;
    el.value = value === void 0 ? "" : value;
  }
}
function bindClasses(el, value) {
  if (el._x_undoAddedClasses)
    el._x_undoAddedClasses();
  el._x_undoAddedClasses = setClasses(el, value);
}
function bindStyles(el, value) {
  if (el._x_undoAddedStyles)
    el._x_undoAddedStyles();
  el._x_undoAddedStyles = setStyles(el, value);
}
function bindAttributeAndProperty(el, name, value) {
  bindAttribute(el, name, value);
  setPropertyIfChanged(el, name, value);
}
function bindAttribute(el, name, value) {
  if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
    el.removeAttribute(name);
  } else {
    if (isBooleanAttr(name))
      value = name;
    setIfChanged(el, name, value);
  }
}
function setIfChanged(el, attrName, value) {
  if (el.getAttribute(attrName) != value) {
    el.setAttribute(attrName, value);
  }
}
function setPropertyIfChanged(el, propName, value) {
  if (el[propName] !== value) {
    el[propName] = value;
  }
}
function updateSelect(el, value) {
  const arrayWrappedValue = [].concat(value).map((value2) => {
    return value2 + "";
  });
  Array.from(el.options).forEach((option) => {
    option.selected = arrayWrappedValue.includes(option.value);
  });
}
function camelCase(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function checkedAttrLooseCompare(valueA, valueB) {
  return valueA == valueB;
}
function safeParseBoolean(rawValue) {
  if ([1, "1", "true", "on", "yes", true].includes(rawValue)) {
    return true;
  }
  if ([0, "0", "false", "off", "no", false].includes(rawValue)) {
    return false;
  }
  return rawValue ? Boolean(rawValue) : null;
}
function isBooleanAttr(attrName) {
  const booleanAttributes = [
    "disabled",
    "checked",
    "required",
    "readonly",
    "open",
    "selected",
    "autofocus",
    "itemscope",
    "multiple",
    "novalidate",
    "allowfullscreen",
    "allowpaymentrequest",
    "formnovalidate",
    "autoplay",
    "controls",
    "loop",
    "muted",
    "playsinline",
    "default",
    "ismap",
    "reversed",
    "async",
    "defer",
    "nomodule"
  ];
  return booleanAttributes.includes(attrName);
}
function attributeShouldntBePreservedIfFalsy(name) {
  return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
}
function getBinding(el, name, fallback) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  return getAttributeBinding(el, name, fallback);
}
function extractProp(el, name, fallback, extract = true) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
    let binding = el._x_inlineBindings[name];
    binding.extract = extract;
    return dontAutoEvaluateFunctions(() => {
      return evaluate(el, binding.expression);
    });
  }
  return getAttributeBinding(el, name, fallback);
}
function getAttributeBinding(el, name, fallback) {
  let attr = el.getAttribute(name);
  if (attr === null)
    return typeof fallback === "function" ? fallback() : fallback;
  if (attr === "")
    return true;
  if (isBooleanAttr(name)) {
    return !![name, "true"].includes(attr);
  }
  return attr;
}
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function throttle(func, limit) {
  let inThrottle;
  return function() {
    let context = this, args = arguments;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
  let firstRun = true;
  let outerHash;
  let reference = effect(() => {
    let outer = outerGet();
    let inner = innerGet();
    if (firstRun) {
      innerSet(cloneIfObject(outer));
      firstRun = false;
    } else {
      let outerHashLatest = JSON.stringify(outer);
      let innerHashLatest = JSON.stringify(inner);
      if (outerHashLatest !== outerHash) {
        innerSet(cloneIfObject(outer));
      } else if (outerHashLatest !== innerHashLatest) {
        outerSet(cloneIfObject(inner));
      } else
        ;
    }
    outerHash = JSON.stringify(outerGet());
    JSON.stringify(innerGet());
  });
  return () => {
    release(reference);
  };
}
function cloneIfObject(value) {
  return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
function plugin(callback2) {
  let callbacks = Array.isArray(callback2) ? callback2 : [callback2];
  callbacks.forEach((i) => i(alpine_default));
}
var stores = {};
var isReactive = false;
function store(name, value) {
  if (!isReactive) {
    stores = reactive(stores);
    isReactive = true;
  }
  if (value === void 0) {
    return stores[name];
  }
  stores[name] = value;
  if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
    stores[name].init();
  }
  initInterceptors2(stores[name]);
}
function getStores() {
  return stores;
}
var binds = {};
function bind2(name, bindings) {
  let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
  if (name instanceof Element) {
    return applyBindingsObject(name, getBindings());
  } else {
    binds[name] = getBindings;
  }
  return () => {
  };
}
function injectBindingProviders(obj) {
  Object.entries(binds).forEach(([name, callback2]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback2(...args);
        };
      }
    });
  });
  return obj;
}
function applyBindingsObject(el, obj, original) {
  let cleanupRunners = [];
  while (cleanupRunners.length)
    cleanupRunners.pop()();
  let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
  let staticAttributes = attributesOnly(attributes);
  attributes = attributes.map((attribute) => {
    if (staticAttributes.find((attr) => attr.name === attribute.name)) {
      return {
        name: `x-bind:${attribute.name}`,
        value: `"${attribute.value}"`
      };
    }
    return attribute;
  });
  directives(el, attributes, original).map((handle) => {
    cleanupRunners.push(handle.runCleanups);
    handle();
  });
  return () => {
    while (cleanupRunners.length)
      cleanupRunners.pop()();
  };
}
var datas = {};
function data(name, callback2) {
  datas[name] = callback2;
}
function injectDataProviders(obj, context) {
  Object.entries(datas).forEach(([name, callback2]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback2.bind(context)(...args);
        };
      },
      enumerable: false
    });
  });
  return obj;
}
var Alpine = {
  get reactive() {
    return reactive;
  },
  get release() {
    return release;
  },
  get effect() {
    return effect;
  },
  get raw() {
    return raw;
  },
  version: "3.13.8",
  flushAndStopDeferringMutations,
  dontAutoEvaluateFunctions,
  disableEffectScheduling,
  startObservingMutations,
  stopObservingMutations,
  setReactivityEngine,
  onAttributeRemoved,
  onAttributesAdded,
  closestDataStack,
  skipDuringClone,
  onlyDuringClone,
  addRootSelector,
  addInitSelector,
  interceptClone,
  addScopeToNode,
  deferMutations,
  mapAttributes,
  evaluateLater,
  interceptInit,
  setEvaluator,
  mergeProxies,
  extractProp,
  findClosest,
  onElRemoved,
  closestRoot,
  destroyTree,
  interceptor,
  // INTERNAL: not public API and is subject to change without major release.
  transition,
  // INTERNAL
  setStyles,
  // INTERNAL
  mutateDom,
  directive,
  entangle,
  throttle,
  debounce,
  evaluate,
  initTree,
  nextTick,
  prefixed: prefix,
  prefix: setPrefix,
  plugin,
  magic,
  store,
  start,
  clone,
  // INTERNAL
  cloneNode,
  // INTERNAL
  bound: getBinding,
  $data: scope,
  watch,
  walk,
  data,
  bind: bind2
};
var alpine_default = Alpine;
function makeMap(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
var EMPTY_OBJ = Object.freeze({});
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = (val, key) => hasOwnProperty.call(val, key);
var isArray = Array.isArray;
var isMap = (val) => toTypeString(val) === "[object Map]";
var isString = (val) => typeof val === "string";
var isSymbol = (val) => typeof val === "symbol";
var isObject = (val) => val !== null && typeof val === "object";
var objectToString = Object.prototype.toString;
var toTypeString = (value) => objectToString.call(value);
var toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
var targetMap = /* @__PURE__ */ new WeakMap();
var effectStack = [];
var activeEffect;
var ITERATE_KEY = Symbol("iterate");
var MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function isEffect(fn) {
  return fn && fn._isEffect === true;
}
function effect2(fn, options = EMPTY_OBJ) {
  if (isEffect(fn)) {
    fn = fn.raw;
  }
  const effect3 = createReactiveEffect(fn, options);
  if (!options.lazy) {
    effect3();
  }
  return effect3;
}
function stop(effect3) {
  if (effect3.active) {
    cleanup(effect3);
    if (effect3.options.onStop) {
      effect3.options.onStop();
    }
    effect3.active = false;
  }
}
var uid = 0;
function createReactiveEffect(fn, options) {
  const effect3 = function reactiveEffect() {
    if (!effect3.active) {
      return fn();
    }
    if (!effectStack.includes(effect3)) {
      cleanup(effect3);
      try {
        enableTracking();
        effectStack.push(effect3);
        activeEffect = effect3;
        return fn();
      } finally {
        effectStack.pop();
        resetTracking();
        activeEffect = effectStack[effectStack.length - 1];
      }
    }
  };
  effect3.id = uid++;
  effect3.allowRecurse = !!options.allowRecurse;
  effect3._isEffect = true;
  effect3.active = true;
  effect3.raw = fn;
  effect3.deps = [];
  effect3.options = options;
  return effect3;
}
function cleanup(effect3) {
  const { deps } = effect3;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect3);
    }
    deps.length = 0;
  }
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function enableTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = true;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (!shouldTrack || activeEffect === void 0) {
    return;
  }
  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
  }
  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, dep = /* @__PURE__ */ new Set());
  }
  if (!dep.has(activeEffect)) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
    if (activeEffect.options.onTrack) {
      activeEffect.options.onTrack({
        effect: activeEffect,
        target,
        type,
        key
      });
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  const effects = /* @__PURE__ */ new Set();
  const add2 = (effectsToAdd) => {
    if (effectsToAdd) {
      effectsToAdd.forEach((effect3) => {
        if (effect3 !== activeEffect || effect3.allowRecurse) {
          effects.add(effect3);
        }
      });
    }
  };
  if (type === "clear") {
    depsMap.forEach(add2);
  } else if (key === "length" && isArray(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        add2(dep);
      }
    });
  } else {
    if (key !== void 0) {
      add2(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          add2(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap(target)) {
          add2(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  const run = (effect3) => {
    if (effect3.options.onTrigger) {
      effect3.options.onTrigger({
        effect: effect3,
        target,
        key,
        type,
        newValue,
        oldValue,
        oldTarget
      });
    }
    if (effect3.options.scheduler) {
      effect3.options.scheduler(effect3);
    } else {
      effect3();
    }
  };
  effects.forEach(run);
}
var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
var get2 = /* @__PURE__ */ createGetter();
var readonlyGet = /* @__PURE__ */ createGetter(true);
var arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i = 0, l = this.length; i < l; i++) {
        track(arr, "get", i + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly = false, shallow = false) {
  return function get3(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject(res)) {
      return isReadonly ? readonly(res) : reactive2(res);
    }
    return res;
  };
}
var set2 = /* @__PURE__ */ createSetter();
function createSetter(shallow = false) {
  return function set3(target, key, value, receiver) {
    let oldValue = target[key];
    if (!shallow) {
      value = toRaw(value);
      oldValue = toRaw(oldValue);
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn(target, key);
  const oldValue = target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys$1(target) {
  track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
var mutableHandlers = {
  get: get2,
  set: set2,
  deleteProperty,
  has,
  ownKeys: ownKeys$1
};
var readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    {
      console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  },
  deleteProperty(target, key) {
    {
      console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  }
};
var toReactive = (value) => isObject(value) ? reactive2(value) : value;
var toReadonly = (value) => isObject(value) ? readonly(value) : value;
var toShallow = (value) => value;
var getProto = (v) => Reflect.getPrototypeOf(v);
function get$1(target, key, isReadonly = false, isShallow = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "get", key);
  }
  !isReadonly && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly = false) {
  const target = this[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "has", key);
  }
  !isReadonly && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value, oldValue);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3 ? get3.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const oldTarget = isMap(target) ? new Map(target) : new Set(target);
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0, oldTarget);
  }
  return result;
}
function createForEach(isReadonly, isShallow) {
  return function forEach(callback2, thisArg) {
    const observed = this;
    const target = observed[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback2.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly, isShallow) {
  return function(...args) {
    const target = this[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
    }
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
var [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly, shallow) {
  const instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
var mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
var readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
  }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value[
    "__v_skip"
    /* SKIP */
  ] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive2(target) {
  if (target && target[
    "__v_isReadonly"
    /* IS_READONLY */
  ]) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject(target)) {
    {
      console.warn(`value cannot be made reactive: ${String(target)}`);
    }
    return target;
  }
  if (target[
    "__v_raw"
    /* RAW */
  ] && !(isReadonly && target[
    "__v_isReactive"
    /* IS_REACTIVE */
  ])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function toRaw(observed) {
  return observed && toRaw(observed[
    "__v_raw"
    /* RAW */
  ]) || observed;
}
function isRef(r) {
  return Boolean(r && r.__v_isRef === true);
}
magic("nextTick", () => nextTick);
magic("dispatch", (el) => dispatch.bind(dispatch, el));
magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => (key, callback2) => {
  let evaluate2 = evaluateLater2(key);
  let getter = () => {
    let value;
    evaluate2((i) => value = i);
    return value;
  };
  let unwatch = watch(getter, callback2);
  cleanup2(unwatch);
});
magic("store", getStores);
magic("data", (el) => scope(el));
magic("root", (el) => closestRoot(el));
magic("refs", (el) => {
  if (el._x_refs_proxy)
    return el._x_refs_proxy;
  el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
  return el._x_refs_proxy;
});
function getArrayOfRefObject(el) {
  let refObjects = [];
  findClosest(el, (i) => {
    if (i._x_refs)
      refObjects.push(i._x_refs);
  });
  return refObjects;
}
var globalIdMemo = {};
function findAndIncrementId(name) {
  if (!globalIdMemo[name])
    globalIdMemo[name] = 0;
  return ++globalIdMemo[name];
}
function closestIdRoot(el, name) {
  return findClosest(el, (element2) => {
    if (element2._x_ids && element2._x_ids[name])
      return true;
  });
}
function setIdRoot(el, name) {
  if (!el._x_ids)
    el._x_ids = {};
  if (!el._x_ids[name])
    el._x_ids[name] = findAndIncrementId(name);
}
magic("id", (el, { cleanup: cleanup2 }) => (name, key = null) => {
  let cacheKey = `${name}${key ? `-${key}` : ""}`;
  return cacheIdByNameOnElement(el, cacheKey, cleanup2, () => {
    let root = closestIdRoot(el, name);
    let id = root ? root._x_ids[name] : findAndIncrementId(name);
    return key ? `${name}-${id}-${key}` : `${name}-${id}`;
  });
});
interceptClone((from, to) => {
  if (from._x_id) {
    to._x_id = from._x_id;
  }
});
function cacheIdByNameOnElement(el, cacheKey, cleanup2, callback2) {
  if (!el._x_id)
    el._x_id = {};
  if (el._x_id[cacheKey])
    return el._x_id[cacheKey];
  let output = callback2();
  el._x_id[cacheKey] = output;
  cleanup2(() => {
    delete el._x_id[cacheKey];
  });
  return output;
}
magic("el", (el) => el);
warnMissingPluginMagic("Focus", "focus", "focus");
warnMissingPluginMagic("Persist", "persist", "persist");
function warnMissingPluginMagic(name, magicName, slug) {
  magic(magicName, (el) => warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
  let func = evaluateLater2(expression);
  let innerGet = () => {
    let result;
    func((i) => result = i);
    return result;
  };
  let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
  let innerSet = (val) => evaluateInnerSet(() => {
  }, { scope: { "__placeholder": val } });
  let initialValue = innerGet();
  innerSet(initialValue);
  queueMicrotask(() => {
    if (!el._x_model)
      return;
    el._x_removeModelListeners["default"]();
    let outerGet = el._x_model.get;
    let outerSet = el._x_model.set;
    let releaseEntanglement = entangle(
      {
        get() {
          return outerGet();
        },
        set(value) {
          outerSet(value);
        }
      },
      {
        get() {
          return innerGet();
        },
        set(value) {
          innerSet(value);
        }
      }
    );
    cleanup2(releaseEntanglement);
  });
});
directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-teleport can only be used on a <template> tag", el);
  let target = getTarget(expression);
  let clone2 = el.content.cloneNode(true).firstElementChild;
  el._x_teleport = clone2;
  clone2._x_teleportBack = el;
  el.setAttribute("data-teleport-template", true);
  clone2.setAttribute("data-teleport-target", true);
  if (el._x_forwardEvents) {
    el._x_forwardEvents.forEach((eventName) => {
      clone2.addEventListener(eventName, (e) => {
        e.stopPropagation();
        el.dispatchEvent(new e.constructor(e.type, e));
      });
    });
  }
  addScopeToNode(clone2, {}, el);
  let placeInDom = (clone3, target2, modifiers2) => {
    if (modifiers2.includes("prepend")) {
      target2.parentNode.insertBefore(clone3, target2);
    } else if (modifiers2.includes("append")) {
      target2.parentNode.insertBefore(clone3, target2.nextSibling);
    } else {
      target2.appendChild(clone3);
    }
  };
  mutateDom(() => {
    placeInDom(clone2, target, modifiers);
    initTree(clone2);
    clone2._x_ignore = true;
  });
  el._x_teleportPutBack = () => {
    let target2 = getTarget(expression);
    mutateDom(() => {
      placeInDom(el._x_teleport, target2, modifiers);
    });
  };
  cleanup2(() => clone2.remove());
});
var teleportContainerDuringClone = document.createElement("div");
function getTarget(expression) {
  let target = skipDuringClone(() => {
    return document.querySelector(expression);
  }, () => {
    return teleportContainerDuringClone;
  })();
  if (!target)
    warn(`Cannot find x-teleport element for selector: "${expression}"`);
  return target;
}
var handler = () => {
};
handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
  modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
  cleanup2(() => {
    modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
  });
};
directive("ignore", handler);
directive("effect", skipDuringClone((el, { expression }, { effect: effect3 }) => {
  effect3(evaluateLater(el, expression));
}));
function on(el, event, modifiers, callback2) {
  let listenerTarget = el;
  let handler4 = (e) => callback2(e);
  let options = {};
  let wrapHandler = (callback22, wrapper) => (e) => wrapper(callback22, e);
  if (modifiers.includes("dot"))
    event = dotSyntax(event);
  if (modifiers.includes("camel"))
    event = camelCase2(event);
  if (modifiers.includes("passive"))
    options.passive = true;
  if (modifiers.includes("capture"))
    options.capture = true;
  if (modifiers.includes("window"))
    listenerTarget = window;
  if (modifiers.includes("document"))
    listenerTarget = document;
  if (modifiers.includes("debounce")) {
    let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = debounce(handler4, wait);
  }
  if (modifiers.includes("throttle")) {
    let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = throttle(handler4, wait);
  }
  if (modifiers.includes("prevent"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.preventDefault();
      next(e);
    });
  if (modifiers.includes("stop"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.stopPropagation();
      next(e);
    });
  if (modifiers.includes("self"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.target === el && next(e);
    });
  if (modifiers.includes("away") || modifiers.includes("outside")) {
    listenerTarget = document;
    handler4 = wrapHandler(handler4, (next, e) => {
      if (el.contains(e.target))
        return;
      if (e.target.isConnected === false)
        return;
      if (el.offsetWidth < 1 && el.offsetHeight < 1)
        return;
      if (el._x_isShown === false)
        return;
      next(e);
    });
  }
  if (modifiers.includes("once")) {
    handler4 = wrapHandler(handler4, (next, e) => {
      next(e);
      listenerTarget.removeEventListener(event, handler4, options);
    });
  }
  handler4 = wrapHandler(handler4, (next, e) => {
    if (isKeyEvent(event)) {
      if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
        return;
      }
    }
    next(e);
  });
  listenerTarget.addEventListener(event, handler4, options);
  return () => {
    listenerTarget.removeEventListener(event, handler4, options);
  };
}
function dotSyntax(subject) {
  return subject.replace(/-/g, ".");
}
function camelCase2(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function isNumeric(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function kebabCase2(subject) {
  if ([" ", "_"].includes(
    subject
  ))
    return subject;
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function isKeyEvent(event) {
  return ["keydown", "keyup"].includes(event);
}
function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
  let keyModifiers = modifiers.filter((i) => {
    return !["window", "document", "prevent", "stop", "once", "capture"].includes(i);
  });
  if (keyModifiers.includes("debounce")) {
    let debounceIndex = keyModifiers.indexOf("debounce");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.includes("throttle")) {
    let debounceIndex = keyModifiers.indexOf("throttle");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.length === 0)
    return false;
  if (keyModifiers.length === 1 && keyToModifiers(e.key).includes(keyModifiers[0]))
    return false;
  const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
  const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
  keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));
  if (selectedSystemKeyModifiers.length > 0) {
    const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
      if (modifier === "cmd" || modifier === "super")
        modifier = "meta";
      return e[`${modifier}Key`];
    });
    if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
      if (keyToModifiers(e.key).includes(keyModifiers[0]))
        return false;
    }
  }
  return true;
}
function keyToModifiers(key) {
  if (!key)
    return [];
  key = kebabCase2(key);
  let modifierToKeyMap = {
    "ctrl": "control",
    "slash": "/",
    "space": " ",
    "spacebar": " ",
    "cmd": "meta",
    "esc": "escape",
    "up": "arrow-up",
    "down": "arrow-down",
    "left": "arrow-left",
    "right": "arrow-right",
    "period": ".",
    "equal": "=",
    "minus": "-",
    "underscore": "_"
  };
  modifierToKeyMap[key] = key;
  return Object.keys(modifierToKeyMap).map((modifier) => {
    if (modifierToKeyMap[modifier] === key)
      return modifier;
  }).filter((modifier) => modifier);
}
directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let scopeTarget = el;
  if (modifiers.includes("parent")) {
    scopeTarget = el.parentNode;
  }
  let evaluateGet = evaluateLater(scopeTarget, expression);
  let evaluateSet;
  if (typeof expression === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
  } else if (typeof expression === "function" && typeof expression() === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
  } else {
    evaluateSet = () => {
    };
  }
  let getValue = () => {
    let result;
    evaluateGet((value) => result = value);
    return isGetterSetter(result) ? result.get() : result;
  };
  let setValue = (value) => {
    let result;
    evaluateGet((value2) => result = value2);
    if (isGetterSetter(result)) {
      result.set(value);
    } else {
      evaluateSet(() => {
      }, {
        scope: { "__placeholder": value }
      });
    }
  };
  if (typeof expression === "string" && el.type === "radio") {
    mutateDom(() => {
      if (!el.hasAttribute("name"))
        el.setAttribute("name", expression);
    });
  }
  var event = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
  let removeListener = isCloning ? () => {
  } : on(el, event, modifiers, (e) => {
    setValue(getInputValue(el, modifiers, e, getValue()));
  });
  if (modifiers.includes("fill")) {
    if ([void 0, null, ""].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) {
      setValue(
        getInputValue(el, modifiers, { target: el }, getValue())
      );
    }
  }
  if (!el._x_removeModelListeners)
    el._x_removeModelListeners = {};
  el._x_removeModelListeners["default"] = removeListener;
  cleanup2(() => el._x_removeModelListeners["default"]());
  if (el.form) {
    let removeResetListener = on(el.form, "reset", [], (e) => {
      nextTick(() => el._x_model && el._x_model.set(el.value));
    });
    cleanup2(() => removeResetListener());
  }
  el._x_model = {
    get() {
      return getValue();
    },
    set(value) {
      setValue(value);
    }
  };
  el._x_forceModelUpdate = (value) => {
    if (value === void 0 && typeof expression === "string" && expression.match(/\./))
      value = "";
    window.fromModel = true;
    mutateDom(() => bind(el, "value", value));
    delete window.fromModel;
  };
  effect3(() => {
    let value = getValue();
    if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
      return;
    el._x_forceModelUpdate(value);
  });
});
function getInputValue(el, modifiers, event, currentValue) {
  return mutateDom(() => {
    if (event instanceof CustomEvent && event.detail !== void 0)
      return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
    else if (el.type === "checkbox") {
      if (Array.isArray(currentValue)) {
        let newValue = null;
        if (modifiers.includes("number")) {
          newValue = safeParseNumber(event.target.value);
        } else if (modifiers.includes("boolean")) {
          newValue = safeParseBoolean(event.target.value);
        } else {
          newValue = event.target.value;
        }
        return event.target.checked ? currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
      } else {
        return event.target.checked;
      }
    } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
      if (modifiers.includes("number")) {
        return Array.from(event.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseNumber(rawValue);
        });
      } else if (modifiers.includes("boolean")) {
        return Array.from(event.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseBoolean(rawValue);
        });
      }
      return Array.from(event.target.selectedOptions).map((option) => {
        return option.value || option.text;
      });
    } else {
      let newValue;
      if (el.type === "radio") {
        if (event.target.checked) {
          newValue = event.target.value;
        } else {
          newValue = currentValue;
        }
      } else {
        newValue = event.target.value;
      }
      if (modifiers.includes("number")) {
        return safeParseNumber(newValue);
      } else if (modifiers.includes("boolean")) {
        return safeParseBoolean(newValue);
      } else if (modifiers.includes("trim")) {
        return newValue.trim();
      } else {
        return newValue;
      }
    }
  });
}
function safeParseNumber(rawValue) {
  let number = rawValue ? parseFloat(rawValue) : null;
  return isNumeric2(number) ? number : rawValue;
}
function checkedAttrLooseCompare2(valueA, valueB) {
  return valueA == valueB;
}
function isNumeric2(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function isGetterSetter(value) {
  return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
addInitSelector(() => `[${prefix("init")}]`);
directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "string") {
    return !!expression.trim() && evaluate2(expression, {}, false);
  }
  return evaluate2(expression, {}, false);
}));
directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.textContent = value;
      });
    });
  });
});
directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.innerHTML = value;
        el._x_ignoreSelf = true;
        initTree(el);
        delete el._x_ignoreSelf;
      });
    });
  });
});
mapAttributes(startingWith(":", into(prefix("bind:"))));
var handler2 = (el, { value, modifiers, expression, original }, { effect: effect3, cleanup: cleanup2 }) => {
  if (!value) {
    let bindingProviders = {};
    injectBindingProviders(bindingProviders);
    let getBindings = evaluateLater(el, expression);
    getBindings((bindings) => {
      applyBindingsObject(el, bindings, original);
    }, { scope: bindingProviders });
    return;
  }
  if (value === "key")
    return storeKeyForXFor(el, expression);
  if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) {
    return;
  }
  let evaluate2 = evaluateLater(el, expression);
  effect3(() => evaluate2((result) => {
    if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
      result = "";
    }
    mutateDom(() => bind(el, value, result, modifiers));
  }));
  cleanup2(() => {
    el._x_undoAddedClasses && el._x_undoAddedClasses();
    el._x_undoAddedStyles && el._x_undoAddedStyles();
  });
};
handler2.inline = (el, { value, modifiers, expression }) => {
  if (!value)
    return;
  if (!el._x_inlineBindings)
    el._x_inlineBindings = {};
  el._x_inlineBindings[value] = { expression, extract: false };
};
directive("bind", handler2);
function storeKeyForXFor(el, expression) {
  el._x_keyExpression = expression;
}
addRootSelector(() => `[${prefix("data")}]`);
directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
  if (shouldSkipRegisteringDataDuringClone(el))
    return;
  expression = expression === "" ? "{}" : expression;
  let magicContext = {};
  injectMagics(magicContext, el);
  let dataProviderContext = {};
  injectDataProviders(dataProviderContext, magicContext);
  let data2 = evaluate(el, expression, { scope: dataProviderContext });
  if (data2 === void 0 || data2 === true)
    data2 = {};
  injectMagics(data2, el);
  let reactiveData = reactive(data2);
  initInterceptors2(reactiveData);
  let undo = addScopeToNode(el, reactiveData);
  reactiveData["init"] && evaluate(el, reactiveData["init"]);
  cleanup2(() => {
    reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
    undo();
  });
});
interceptClone((from, to) => {
  if (from._x_dataStack) {
    to._x_dataStack = from._x_dataStack;
    to.setAttribute("data-has-alpine-state", true);
  }
});
function shouldSkipRegisteringDataDuringClone(el) {
  if (!isCloning)
    return false;
  if (isCloningLegacy)
    return true;
  return el.hasAttribute("data-has-alpine-state");
}
directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
  let evaluate2 = evaluateLater(el, expression);
  if (!el._x_doHide)
    el._x_doHide = () => {
      mutateDom(() => {
        el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
      });
    };
  if (!el._x_doShow)
    el._x_doShow = () => {
      mutateDom(() => {
        if (el.style.length === 1 && el.style.display === "none") {
          el.removeAttribute("style");
        } else {
          el.style.removeProperty("display");
        }
      });
    };
  let hide = () => {
    el._x_doHide();
    el._x_isShown = false;
  };
  let show = () => {
    el._x_doShow();
    el._x_isShown = true;
  };
  let clickAwayCompatibleShow = () => setTimeout(show);
  let toggle = once(
    (value) => value ? show() : hide(),
    (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    }
  );
  let oldValue;
  let firstTime = true;
  effect3(() => evaluate2((value) => {
    if (!firstTime && value === oldValue)
      return;
    if (modifiers.includes("immediate"))
      value ? clickAwayCompatibleShow() : hide();
    toggle(value);
    oldValue = value;
    firstTime = false;
  }));
});
directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let iteratorNames = parseForExpression(expression);
  let evaluateItems = evaluateLater(el, iteratorNames.items);
  let evaluateKey = evaluateLater(
    el,
    // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index"
  );
  el._x_prevKeys = [];
  el._x_lookup = {};
  effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
  cleanup2(() => {
    Object.values(el._x_lookup).forEach((el2) => el2.remove());
    delete el._x_prevKeys;
    delete el._x_lookup;
  });
});
function loop(el, iteratorNames, evaluateItems, evaluateKey) {
  let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
  let templateEl = el;
  evaluateItems((items) => {
    if (isNumeric3(items) && items >= 0) {
      items = Array.from(Array(items).keys(), (i) => i + 1);
    }
    if (items === void 0)
      items = [];
    let lookup = el._x_lookup;
    let prevKeys = el._x_prevKeys;
    let scopes = [];
    let keys = [];
    if (isObject2(items)) {
      items = Object.entries(items).map(([key, value]) => {
        let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
        evaluateKey((value2) => {
          if (keys.includes(value2))
            warn("Duplicate key on x-for", el);
          keys.push(value2);
        }, { scope: { index: key, ...scope2 } });
        scopes.push(scope2);
      });
    } else {
      for (let i = 0; i < items.length; i++) {
        let scope2 = getIterationScopeVariables(iteratorNames, items[i], i, items);
        evaluateKey((value) => {
          if (keys.includes(value))
            warn("Duplicate key on x-for", el);
          keys.push(value);
        }, { scope: { index: i, ...scope2 } });
        scopes.push(scope2);
      }
    }
    let adds = [];
    let moves = [];
    let removes = [];
    let sames = [];
    for (let i = 0; i < prevKeys.length; i++) {
      let key = prevKeys[i];
      if (keys.indexOf(key) === -1)
        removes.push(key);
    }
    prevKeys = prevKeys.filter((key) => !removes.includes(key));
    let lastKey = "template";
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let prevIndex = prevKeys.indexOf(key);
      if (prevIndex === -1) {
        prevKeys.splice(i, 0, key);
        adds.push([lastKey, i]);
      } else if (prevIndex !== i) {
        let keyInSpot = prevKeys.splice(i, 1)[0];
        let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
        prevKeys.splice(i, 0, keyForSpot);
        prevKeys.splice(prevIndex, 0, keyInSpot);
        moves.push([keyInSpot, keyForSpot]);
      } else {
        sames.push(key);
      }
      lastKey = key;
    }
    for (let i = 0; i < removes.length; i++) {
      let key = removes[i];
      if (!!lookup[key]._x_effects) {
        lookup[key]._x_effects.forEach(dequeueJob);
      }
      lookup[key].remove();
      lookup[key] = null;
      delete lookup[key];
    }
    for (let i = 0; i < moves.length; i++) {
      let [keyInSpot, keyForSpot] = moves[i];
      let elInSpot = lookup[keyInSpot];
      let elForSpot = lookup[keyForSpot];
      let marker = document.createElement("div");
      mutateDom(() => {
        if (!elForSpot)
          warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
        elForSpot.after(marker);
        elInSpot.after(elForSpot);
        elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
        marker.before(elInSpot);
        elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
        marker.remove();
      });
      elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
    }
    for (let i = 0; i < adds.length; i++) {
      let [lastKey2, index] = adds[i];
      let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
      if (lastEl._x_currentIfEl)
        lastEl = lastEl._x_currentIfEl;
      let scope2 = scopes[index];
      let key = keys[index];
      let clone2 = document.importNode(templateEl.content, true).firstElementChild;
      let reactiveScope = reactive(scope2);
      addScopeToNode(clone2, reactiveScope, templateEl);
      clone2._x_refreshXForScope = (newScope) => {
        Object.entries(newScope).forEach(([key2, value]) => {
          reactiveScope[key2] = value;
        });
      };
      mutateDom(() => {
        lastEl.after(clone2);
        skipDuringClone(() => initTree(clone2))();
      });
      if (typeof key === "object") {
        warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
      }
      lookup[key] = clone2;
    }
    for (let i = 0; i < sames.length; i++) {
      lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
    }
    templateEl._x_prevKeys = keys;
  });
}
function parseForExpression(expression) {
  let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  let stripParensRE = /^\s*\(|\)\s*$/g;
  let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  let inMatch = expression.match(forAliasRE);
  if (!inMatch)
    return;
  let res = {};
  res.items = inMatch[2].trim();
  let item2 = inMatch[1].replace(stripParensRE, "").trim();
  let iteratorMatch = item2.match(forIteratorRE);
  if (iteratorMatch) {
    res.item = item2.replace(forIteratorRE, "").trim();
    res.index = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.collection = iteratorMatch[2].trim();
    }
  } else {
    res.item = item2;
  }
  return res;
}
function getIterationScopeVariables(iteratorNames, item2, index, items) {
  let scopeVariables = {};
  if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item2)) {
    let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i) => i.trim());
    names.forEach((name, i) => {
      scopeVariables[name] = item2[i];
    });
  } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item2) && typeof item2 === "object") {
    let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i) => i.trim());
    names.forEach((name) => {
      scopeVariables[name] = item2[name];
    });
  } else {
    scopeVariables[iteratorNames.item] = item2;
  }
  if (iteratorNames.index)
    scopeVariables[iteratorNames.index] = index;
  if (iteratorNames.collection)
    scopeVariables[iteratorNames.collection] = items;
  return scopeVariables;
}
function isNumeric3(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function handler3() {
}
handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
  let root = closestRoot(el);
  if (!root._x_refs)
    root._x_refs = {};
  root._x_refs[expression] = el;
  cleanup2(() => delete root._x_refs[expression]);
};
directive("ref", handler3);
directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-if can only be used on a <template> tag", el);
  let evaluate2 = evaluateLater(el, expression);
  let show = () => {
    if (el._x_currentIfEl)
      return el._x_currentIfEl;
    let clone2 = el.content.cloneNode(true).firstElementChild;
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      el.after(clone2);
      skipDuringClone(() => initTree(clone2))();
    });
    el._x_currentIfEl = clone2;
    el._x_undoIf = () => {
      walk(clone2, (node) => {
        if (!!node._x_effects) {
          node._x_effects.forEach(dequeueJob);
        }
      });
      clone2.remove();
      delete el._x_currentIfEl;
    };
    return clone2;
  };
  let hide = () => {
    if (!el._x_undoIf)
      return;
    el._x_undoIf();
    delete el._x_undoIf;
  };
  effect3(() => evaluate2((value) => {
    value ? show() : hide();
  }));
  cleanup2(() => el._x_undoIf && el._x_undoIf());
});
directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
  let names = evaluate2(expression);
  names.forEach((name) => setIdRoot(el, name));
});
interceptClone((from, to) => {
  if (from._x_ids) {
    to._x_ids = from._x_ids;
  }
});
mapAttributes(startingWith("@", into(prefix("on:"))));
directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
  let evaluate2 = expression ? evaluateLater(el, expression) : () => {
  };
  if (el.tagName.toLowerCase() === "template") {
    if (!el._x_forwardEvents)
      el._x_forwardEvents = [];
    if (!el._x_forwardEvents.includes(value))
      el._x_forwardEvents.push(value);
  }
  let removeListener = on(el, value, modifiers, (e) => {
    evaluate2(() => {
    }, { scope: { "$event": e }, params: [e] });
  });
  cleanup2(() => removeListener());
}));
warnMissingPluginDirective("Collapse", "collapse", "collapse");
warnMissingPluginDirective("Intersect", "intersect", "intersect");
warnMissingPluginDirective("Focus", "trap", "focus");
warnMissingPluginDirective("Mask", "mask", "mask");
function warnMissingPluginDirective(name, directiveName, slug) {
  directive(directiveName, (el) => warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
alpine_default.setEvaluator(normalEvaluator);
alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
var src_default$3 = alpine_default;
var module_default$3 = src_default$3;
const utils$1 = {
  // set query params
  setQuery: (query) => {
    if (query === "") {
      window.history.replaceState({}, "", window.location.pathname);
      return;
    } else {
      const path = window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      params.set("edit", query);
      window.history.replaceState(
        {},
        "",
        `${path}?${params.toString()}${hash}`
      );
    }
  },
  // Convert inches to cm
  inchesToCM: function(inches) {
    const cm = inches * 2.54;
    return parseFloat(cm.toFixed(2));
  },
  // Initiate header scrolling (unless in preview mode)
  initScroll: function() {
    if (!Shopify.visualPreviewMode) {
      const body = document.querySelector("body");
      body.setAttribute(
        "x-on:scroll.window",
        `() => {
        if (window.pageYOffset > 400) {
          is_scrolled = window.pageYOffset > prev_scroll_pos ? true : false;
          prev_scroll_pos = window.pageYOffset;
          $refs.header.style.transform = 'none'
        } else {
          is_scrolled = false;
          prev_scroll_pos = window.pageYOffset;
          $refs.header.style.transform = 'none'
        }
      }`
      );
      body.setAttribute("x-intersect.half:enter", "scroll_up = false");
      body.setAttribute("x-intersect.half:leave", "scroll_up = true");
    }
  },
  // Play sound
  playSound: function(audio) {
    if (!this.isMobileDevice()) {
      audio.play();
    }
  },
  // Check if device is mobile
  isMobileDevice: function(x2, track2) {
    const userAgentTest = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    if (x2 && track2) {
      x2.addEventListener("change", () => {
        if (x2.matches) {
          module_default$3.store("isMobileDevice", true);
        } else {
          module_default$3.store("isMobileDevice", false);
        }
      });
    }
    if ((x2 == null ? void 0 : x2.matches) || userAgentTest) {
      module_default$3.store("isMobileDevice", true);
      return true;
    } else {
      module_default$3.store("isMobileDevice", false);
      return false;
    }
  },
  // Copy value of input to clipboard and focus element
  copyToClipboard: function(id) {
    var copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  },
  // Check line items values
  checkLineItems(handle) {
    const inputs = document.querySelectorAll(
      `.custom-input_${handle}`
    );
    const inputsArr = Array.from(inputs);
    const requiredFields = inputsArr.filter((inp) => inp.required);
    if (requiredFields.some((field) => field.value === "")) {
      this.incomplete_fields = true;
    } else {
      this.incomplete_fields = false;
    }
  },
  // Quick Function to open olark chat
  openOlarkChat: function() {
    const olarkBtn = document.querySelector(
      "button.olark-launch-button"
    );
    if (olarkBtn) {
      olarkBtn.click();
    }
  },
  // Quick Function to verify atc disabled status
  atcDisabled: function() {
    const atcBtn = document.querySelector(
      'form.shopify-product-form button[type="submit"]'
    );
    if (atcBtn.disabled) {
      module_default$3.store("atcBtnDisabled", true);
      module_default$3.nextTick();
    } else {
      module_default$3.store("atcBtnDisabled", false);
      module_default$3.nextTick();
    }
  },
  // Quick Function to move olark for sticky atc
  toggleOlark: function(stickyAdd) {
    const olarkBtn = document.querySelector(
      "div.olark-launch-button-wrapper"
    );
    const olarkContainer = document.querySelector(
      "div#olark-wrapper"
    );
    if (olarkBtn) {
      stickyAdd ? olarkBtn == null ? void 0 : olarkBtn.classList.add("pdp-sticky-olark-override") : olarkBtn == null ? void 0 : olarkBtn.classList.remove("pdp-sticky-olark-override");
      stickyAdd ? olarkContainer == null ? void 0 : olarkContainer.classList.add("pdp-sticky-olark-toggle") : olarkContainer == null ? void 0 : olarkContainer.classList.remove("pdp-sticky-olark-toggle");
    }
  },
  // Quick Function to open olark chat
  disableBodyScroll: function(optionalBool) {
    const docBody = document.querySelector("body");
    const docHead = document.querySelector("header");
    const stickyAdd = document.querySelector(
      "div.pdp-stick-atc"
    );
    if (optionalBool != null) {
      if (optionalBool) {
        docBody == null ? void 0 : docBody.classList.add("no-scroll");
        docHead == null ? void 0 : docHead.classList.add("!z-10");
        stickyAdd == null ? void 0 : stickyAdd.classList.add("!z-10");
      } else if (!optionalBool) {
        docBody == null ? void 0 : docBody.classList.remove("no-scroll");
        docHead == null ? void 0 : docHead.classList.remove("!z-10");
        stickyAdd == null ? void 0 : stickyAdd.classList.remove("!z-10");
      }
    } else {
      docBody == null ? void 0 : docBody.classList.toggle("no-scroll");
      docHead == null ? void 0 : docHead.classList.toggle("!z-10");
      stickyAdd == null ? void 0 : stickyAdd.classList.toggle("!z-10");
    }
  },
  // Bing Add to Cart Event
  bingAtc: function() {
    window.uetq = window.uetq || [];
    window.uetq.push("event", "add_to_cart", {});
  },
  // Desktop Helper function to ensure search is focused correctly
  searchFocusDesktop: function() {
    const searchDesktop = document.getElementById(
      "search-desktop"
    );
    if (searchDesktop) {
      setTimeout(() => {
        searchDesktop.focus();
      }, 100);
    }
  },
  // Listener for Cart Ajax Requests to fire callbacks off of
  cartUpdates: function() {
    const updateAffirmCart = (totalPrice) => {
      const affirmCartElm = document.getElementById("affirm-msg_cart");
      if (affirmCartElm) {
        affirmCartElm.setAttribute("data-amount", totalPrice.toString());
        window.affirm.ui.refresh();
      }
    };
    const updateOlarkVisitor = (cart2) => {
      const formatMoney2 = (value) => {
        return value.substring(0, value.length - 2) + "." + value.substring(value.length - 2);
      };
      let payload = ["Updated Cart:"];
      if (cart2) {
        const totalValue = `Cart Total: $${formatMoney2(
          cart2.total_price.toString()
        )}`;
        payload.push(totalValue);
        const totalItems = `Total Items: ${cart2.item_count}`;
        payload.push(totalItems);
        cart2.items.forEach((item2) => {
          const itemString = `${item2.quantity}x ${item2.title}`;
          payload.push(itemString);
        });
        window.olark("api.chat.updateVisitorStatus", {
          snippet: payload
        });
      }
    };
    const initCart = async () => {
      const response = await fetch("/cart.js");
      const data2 = await response.json();
      const cart2 = data2;
      if (cart2) {
        updateOlarkVisitor(cart2);
      }
      if (cart2.total_price) {
        updateAffirmCart(cart2.total_price);
      }
    };
    initCart();
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach(async (entry2) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          entry2.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry2.name);
        if (isValidRequestType && isCartChangeRequest) {
          const response = await fetch("/cart.js");
          const data2 = await response.json();
          const cart2 = data2;
          if (cart2) {
            updateOlarkVisitor(cart2);
          }
          if (cart2.total_price) {
            updateAffirmCart(cart2.total_price);
          }
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  },
  // Observer to wait for element to load into the DOM
  waitForElement(container, element2, timeout) {
    return new Promise((resolve, reject) => {
      let timer;
      if (document.querySelector(element2))
        return resolve();
      const observer2 = new MutationObserver(() => {
        if (document.querySelector(element2)) {
          observer2.disconnect();
          if (timer)
            clearTimeout(timer);
          return resolve();
        }
      });
      if (document.querySelector(container)) {
        const targetElm = document.querySelector(container);
        console.log(targetElm);
        observer2.observe(targetElm, {
          childList: true,
          subtree: true
        });
      } else {
        observer2.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      if (timeout)
        timer = setTimeout(() => {
          observer2.disconnect();
          reject();
        }, timeout);
    });
  },
  // Override for infinite options issues
  infiniteOptionsInit: function() {
    this.waitForElement(
      "section.product-main-container #infiniteoptions-container",
      "#infiniteoptions-container .spb-label-tooltip label",
      1e4
    ).then(() => {
      console.log("Observer Done");
      const inOpsContainer = document.getElementById(
        "infiniteoptions-container"
      );
      if (inOpsContainer) {
        const toolTips = inOpsContainer.querySelectorAll(".spb-label-tooltip");
        if (toolTips) {
          toolTips.forEach((toolTip) => {
            var _a, _b, _c;
            const checkedOption = (_a = toolTip.parentNode) == null ? void 0 : _a.querySelector("input:checked");
            const allOptions = (_b = toolTip.parentNode) == null ? void 0 : _b.querySelectorAll("input");
            if (checkedOption) {
              const toolTipLabel = toolTip.querySelector("label");
              (_c = checkedOption.parentNode) == null ? void 0 : _c.classList.add(
                "io-embroidery__active"
              );
              if (toolTipLabel) {
                toolTipLabel.innerHTML = `${toolTipLabel.innerHTML.includes(":") ? toolTipLabel.innerHTML.split(":")[0] : toolTipLabel.innerHTML + ":"}<span style="color: var(--ll-deep-end); font-weight: 700; margin-left: 4px;">${checkedOption.value}</span>`;
              }
            }
            allOptions == null ? void 0 : allOptions.forEach((opElm) => {
              opElm.addEventListener("click", () => {
                var _a2;
                const chOption = (_a2 = toolTip.parentNode) == null ? void 0 : _a2.querySelector("input:checked");
                allOptions.forEach((op) => {
                  var _a3;
                  (_a3 = op.parentNode) == null ? void 0 : _a3.classList.remove(
                    "io-embroidery__active"
                  );
                });
                if (opElm.parentNode) {
                  opElm.parentNode.classList.add(
                    "io-embroidery__active"
                  );
                }
                if (chOption) {
                  const toolTipLabel = toolTip.querySelector("label");
                  if (toolTipLabel) {
                    toolTipLabel.innerHTML = `${toolTipLabel.innerHTML.includes(":") ? toolTipLabel.innerHTML.split(":")[0] + ":" : toolTipLabel.innerHTML + ":"}<span style="color: var(--ll-deep-end); font-weight: 700; margin-left: 4px;">${chOption.value}</span>`;
                  }
                }
              });
            });
          });
        }
      }
    }).catch(() => {
      console.log("Infinite Options Not Detected");
    });
  },
  // Initialize Water Depth
  waterDepthInitialize: function() {
    const atcBtn = document.querySelector(
      'form.shopify-product-form button[type="submit"]'
    );
    atcBtn.disabled = true;
    module_default$3.store("atcBtnDisabled", true);
    module_default$3.nextTick();
    ["mouseover", "click"].forEach((event) => {
      atcBtn.addEventListener(event, () => {
        const infiniteOptionChecked = document.querySelector(".water-depth-container").querySelector("fieldset > label > input:checked");
        if (atcBtn.disabled === true && !infiniteOptionChecked) {
          document.getElementById("water-depth-title").style.color = "rgb(239 68 68 / 1)";
          document.getElementById("water-depth-title__dynamic").innerText = "Please select a water depth option.";
        }
      });
    });
  },
  // Water Depth Component Functionality
  handleWaterDepth: function(name, isValid, e) {
    const infiniteOptionElms = [
      ...document.querySelector(".water-depth-container").querySelectorAll("fieldset > label")
    ];
    const waterDepthActive = document.getElementById("water-depth").querySelector(".water-depth-active");
    const infiniteOptionChecked = document.querySelector(".water-depth-container").querySelector("fieldset > label > input:checked");
    const validationContainer = document.getElementById(
      "water-depth-validation-dropdown"
    );
    const validationDropDownActive = validationContainer.querySelector(
      ".water-depth-validation-dropdown:not(.hidden)"
    );
    const atcBtn = document.querySelector(
      'form.shopify-product-form button[type="submit"]'
    );
    const targetElm = e.target;
    if (validationDropDownActive) {
      validationDropDownActive.classList.add("hidden");
    }
    if (waterDepthActive) {
      waterDepthActive.classList.remove("water-depth-active");
    }
    if (infiniteOptionChecked) {
      infiniteOptionChecked.click();
    }
    infiniteOptionElms.forEach((option) => {
      const optionElement = option;
      const infiniteOptionName = optionElement.innerText.replaceAll('"', "").replaceAll(",", "").toLowerCase();
      if (infiniteOptionName === name) {
        const nameMatchBack = name.replaceAll(" ", "-") + "-validation-dropdown__container";
        optionElement.click();
        document.getElementById("water-depth-title__dynamic").innerText = optionElement.innerText;
        document.getElementById(nameMatchBack).classList.remove("hidden");
        if (!isValid && atcBtn) {
          document.getElementById("water-depth-title") ? document.getElementById("water-depth-title").style.color = "" : "";
          atcBtn.disabled = true;
          module_default$3.store("atcBtnDisabled", true);
          module_default$3.nextTick();
        } else if (isValid && atcBtn) {
          document.getElementById("water-depth-title") ? document.getElementById("water-depth-title").style.color = "" : "";
          atcBtn.disabled = false;
          module_default$3.store("atcBtnDisabled", false);
          module_default$3.nextTick();
        }
      }
    });
    targetElm.classList.add("water-depth-active");
  },
  // Initialize Pairing With
  pairingWithInitialize: function() {
    const atcBtn = document.querySelector(
      'form.shopify-product-form button[type="submit"]'
    );
    atcBtn.disabled = true;
    ["mouseover", "click"].forEach((event) => {
      atcBtn.addEventListener(event, () => {
        const infiniteOptionChecked = document.querySelector(".pairing-with-container").querySelector("fieldset > label > input:checked");
        if (atcBtn.disabled === true && !infiniteOptionChecked) {
          document.getElementById("pairing-with-title").style.color = "rgb(239 68 68 / 1)";
          document.getElementById("pairing-with-title__dynamic").innerText = "Please select a pairing option.";
        }
      });
    });
  },
  // Water Depth Component Functionality
  handlePairingWith: function(name, isValid, e) {
    const infiniteOptionElms = [
      ...document.querySelector(".pairing-with-container").querySelectorAll("fieldset > label")
    ];
    const pairingWithActive = document.getElementById("pairing-with").querySelector(".pairing-with-active");
    const infiniteOptionChecked = document.querySelector(".pairing-with-container").querySelector("fieldset > label > input:checked");
    const validationContainer = document.getElementById(
      "pairing-with-validation-dropdown"
    );
    const validationDropDownActive = validationContainer.querySelector(
      ".pairing-with-validation-dropdown:not(.hidden)"
    );
    const atcBtn = document.querySelector(
      'form.shopify-product-form button[type="submit"]'
    );
    const targetElm = e.target;
    if (validationDropDownActive) {
      validationDropDownActive.classList.add("hidden");
    }
    if (pairingWithActive) {
      pairingWithActive.classList.remove("pairing-with-active");
    }
    if (infiniteOptionChecked) {
      infiniteOptionChecked.click();
    }
    infiniteOptionElms.forEach((option) => {
      const optionElement = option;
      const infiniteOptionName = optionElement.innerText.replace('"', "").toLowerCase();
      if (infiniteOptionName === name) {
        const nameMatchBack = name.replaceAll(" ", "-") + "-validation-dropdown__container";
        optionElement.click();
        document.getElementById("pairing-with-title__dynamic").innerText = optionElement.innerText;
        validationContainer.querySelector(`#${nameMatchBack}`).classList.remove("hidden");
        if (!isValid && atcBtn) {
          document.getElementById("pairing-with-title") ? document.getElementById("pairing-with-title").style.color = "" : "";
          atcBtn.disabled = true;
        } else if (isValid && atcBtn) {
          document.getElementById("pairing-with-title") ? document.getElementById("pairing-with-title").style.color = "" : "";
          atcBtn.disabled = false;
        }
      }
    });
    targetElm.classList.add("pairing-with-active");
  },
  /** Script to hide/show variant options on pdps
   *
   * @param logicalDependantOption OPTIONAL - logicalDependantOption (option "name") = if hide/show depends on another option being selected
   * @param optionsToHide Array of option names to hide
   */
  hideUnavailable: function(logicalDependantOption, optionsToHide, optionGroup) {
    var _a;
    let depOption = null;
    if (logicalDependantOption) {
      depOption = document.querySelector(
        `button[name="${logicalDependantOption}"`
      );
    }
    if (depOption) {
      (_a = depOption.closest("div")) == null ? void 0 : _a.addEventListener("click", (e) => {
        if (e.target == depOption) {
          optionsToHide.forEach((op) => {
            var _a2, _b, _c, _d;
            if ((_a2 = document.querySelector(`button[name="${op}"]`)) == null ? void 0 : _a2.classList.contains("outline")) {
              const optionContainer = (_b = document.querySelector(`button[name="${op}"]`)) == null ? void 0 : _b.closest("div");
              (_c = optionContainer == null ? void 0 : optionContainer.querySelector("button")) == null ? void 0 : _c.click();
            }
            (_d = document.querySelector(`button[name="${op}"]`)) == null ? void 0 : _d.classList.add("!hidden");
          });
        } else {
          optionsToHide.forEach((op) => {
            var _a2;
            (_a2 = document.querySelector(`button[name="${op}"]`)) == null ? void 0 : _a2.classList.remove("!hidden");
          });
        }
      });
    } else {
      optionsToHide.forEach((op) => {
        var _a2, _b;
        if (optionGroup) {
          const containerClass = "optionGroupContainer";
          const groupPrepend = "optionGroup-";
          const optionGroupCheck = document.getElementById(
            groupPrepend + optionGroup
          );
          if (optionGroupCheck) {
            const containerElm = optionGroupCheck.closest(
              `div.${containerClass}`
            );
            containerElm ? (_a2 = containerElm.querySelector(`button[name="${op}"]`)) == null ? void 0 : _a2.classList.add("!hidden") : "";
          }
        } else {
          (_b = [...document.querySelectorAll(`button[name="${op}"]`)]) == null ? void 0 : _b.forEach(
            (option) => option.classList.add("!hidden")
          );
        }
      });
    }
  },
  // DFC A/B Test Helper Function
  testingHelper: function(testId, setTo100, elementBool) {
    let dfcTestReturn;
    if (setTo100) {
      dfcTestReturn = 1;
    } else if (setTo100 === false) {
      dfcTestReturn = 0;
    } else {
      if (elementBool) {
        const elmCheck = document.querySelector(elementBool);
        if (elmCheck) {
          dfcTestReturn = window.dfc(testId);
        }
      } else {
        dfcTestReturn = window.dfc(testId);
      }
    }
    module_default$3.store(testId.replaceAll("-", ""), dfcTestReturn);
    module_default$3.nextTick();
  },
  testingHelperPrebucket: async function(testId, forceKill = false) {
    const waitForPrebucket = () => new Promise((resolve) => {
      const checkPrebucket = () => {
        if (typeof window.dfc.prebucket === "function") {
          resolve(void 0);
        } else {
          setTimeout(checkPrebucket, 100);
        }
      };
      checkPrebucket();
    });
    await waitForPrebucket();
    if (forceKill) {
      module_default$3.store(testId.replaceAll("-", ""), 0);
      await module_default$3.nextTick();
      return () => {
      };
    }
    const { idx, activate } = window.dfc.prebucket(testId);
    module_default$3.store(testId.replaceAll("-", ""), idx);
    await module_default$3.nextTick();
    return activate;
  },
  // testingHelperPrebucket: function (testId: string): any {
  //   const { idx, activate } = (window as any).dfc.prebucket(testId);
  //   Alpine.store(testId.replaceAll('-', ''), idx);
  //   Alpine.nextTick();
  //   return activate;
  // },
  // DFC A/B Test Helper Function for Splitbase Test
  splitbaseTest: function(testId) {
    let dfcTestReturn = 0;
    const queryString = window.location.search;
    if (queryString.includes("fbclid")) {
      dfcTestReturn = window.dfc(testId);
      if (dfcTestReturn) {
        window.location.href = "/pages/find-your-ledge-lounger";
      }
    }
  },
  // Splitbase Custom Event
  splitbaseEvent: function() {
    const atcBtn = document.querySelector(
      "button[data-replo-add-product-variant-to-cart]"
    );
    if (atcBtn) {
      atcBtn.addEventListener("click", () => {
        window.dfc.track("splitbase-add-to-cart");
      });
    }
  },
  // Validate if search items should be hidden or not
  searchValidation: function(items) {
    let valid = false;
    let validArray = [];
    items.forEach((item2) => {
      if (item2.title && item2.title.toLowerCase().includes("delete")) {
        validArray.push("false");
      } else if (item2.tags && item2.tags.includes("disable_search")) {
        validArray.push("false");
      } else {
        validArray.push("true");
      }
    });
    const allEqual = (arr) => arr.every((v) => v === "false");
    valid = allEqual(validArray);
    return !valid;
  },
  // Cloudflare Localization
  cloudFlareLoc: function() {
    async function getCloudflareIpData() {
      let data2 = await fetch("https://1.1.1.1/cdn-cgi/trace").then(
        (res) => res.text()
      );
      let arr = data2.trim().split("\n").map((e) => e.split("="));
      return Object.fromEntries(arr);
    }
    getCloudflareIpData().then(({ loc, colo }) => {
      module_default$3.store("colocation", colo);
      module_default$3.store("country", loc);
      module_default$3.nextTick();
    });
  },
  // Change Login/Register Routing
  loginRoutingInit: function() {
    const defaultRoutingElm = document.querySelector(
      'input[name="return_url"]'
    );
    if (defaultRoutingElm) {
      defaultRoutingElm.remove();
    }
  },
  // Google Analytics event tracking
  gtag: function(event, eventModel) {
    window.dataLayer.push({
      event,
      eventModel
    });
  },
  // Facebook Click ID (FBCLID) Handler
  fbclidHandler: function() {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get("fbclid");
    if (fbclid) {
      const timestamp = Date.now();
      const expirationTime = timestamp + 7 * 24 * 60 * 60 * 1e3;
      const fbcValue = "fb.1." + timestamp + "." + fbclid;
      const fbclidData = {
        value: fbcValue,
        expiration: expirationTime
      };
      localStorage.setItem("ledge_fbclid", JSON.stringify(fbclidData));
    }
    const storedFbclid = localStorage.getItem("ledge_fbclid");
    if (storedFbclid) {
      try {
        const fbclidData = JSON.parse(storedFbclid);
        const now = Date.now();
        if (fbclidData.expiration > now) {
          if (!window.dataLayer) {
            window.dataLayer = [];
          }
          window.dataLayer.push({
            ledge_marketing: {
              user_fbclid: fbclidData.value
            }
          });
        } else {
          localStorage.removeItem("ledge_fbclid");
        }
      } catch (error2) {
        localStorage.removeItem("ledge_fbclid");
      }
    }
  },
  salesBannerTimer: function(endDate, banner, pdp) {
    if (endDate) {
      const timerFunction = setInterval(() => {
        const localTime = /* @__PURE__ */ new Date();
        let cst = new Date(endDate);
        cst.toLocaleString("en-US", { timeZone: "America/Chicago" });
        const now = localTime.getTime();
        const then = cst.getTime();
        const diff = then - now;
        const days = Math.floor(diff / (1e3 * 60 * 60 * 24));
        const hours = Math.floor(diff % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
        const minutes = Math.floor(diff % (1e3 * 60 * 60) / (1e3 * 60));
        const seconds = Math.floor(diff % (1e3 * 60) / 1e3);
        if (diff > 0) {
          if (banner && sessionStorage.getItem("sale-banner") == "true") {
            const timerElm = document.getElementById("sales-banner-timer");
            if (timerElm) {
              const dayElm = document.getElementById("sales-banner-days");
              const hourElm = document.getElementById("sales-banner-hours");
              const minElm = document.getElementById("sales-banner-minutes");
              const secElm = document.getElementById("sales-banner-seconds");
              if (days > 0 && dayElm) {
                dayElm.querySelector(".js-text").innerHTML = `${days}`;
              } else if (dayElm) {
                dayElm.innerHTML = "";
              }
              if (hours >= 0 && hourElm) {
                hourElm.querySelector(".js-text").innerHTML = `${hours}`;
              } else if (hourElm) {
                hourElm.innerHTML = "";
              }
              if (minutes >= 0 && minElm) {
                minElm.querySelector(".js-text").innerHTML = `${minutes}`;
              } else if (minElm) {
                minElm.innerHTML = "";
              }
              if (seconds >= 0 && secElm) {
                secElm.querySelector(".js-text").innerHTML = `${seconds}`;
              } else if (secElm) {
                secElm.innerHTML = "";
              }
            }
          } else if (banner && sessionStorage.getItem("sale-banner") == "false") {
            const timerElm = document.getElementById("sales-banner-timer");
            if (timerElm) {
              timerElm.innerHTML = "";
            }
            clearInterval(timerFunction);
          } else if (pdp) {
            const pdpTimerElm = document.getElementById("pdp-sales-banner-timer");
            if (pdpTimerElm) {
              if (days > 0) {
                pdpTimerElm.innerHTML = `<strong>${days}</strong> days <strong>${hours}</strong> hours <strong>${minutes}</strong> mins <strong>${seconds}</strong> secs left`;
              } else if (hours > 0) {
                pdpTimerElm.innerHTML = `<strong>${hours}</strong> hours <strong>${minutes}</strong> mins <strong>${seconds}</strong> secs left`;
              } else {
                pdpTimerElm.innerHTML = `<strong>${minutes}</strong> mins <strong>${seconds}</strong> secs left`;
              }
            }
          } else {
            clearInterval(timerFunction);
          }
        } else {
          clearInterval(timerFunction);
          if (banner) {
            const timerElm = document.getElementById("sales-banner-timer");
            if (timerElm) {
              timerElm.innerHTML = "";
            }
          } else if (pdp) {
            const pdpTimerElm = document.getElementById("pdp-sales-banner-timer");
            if (pdpTimerElm) {
              pdpTimerElm.innerHTML = "";
            }
          }
        }
      }, 1e3);
    }
  },
  /**
   * @todo Make sure to define any new propertys in function and in GTM as variables. All properties need a fallback to default to undefined if property doesnt exist in eventParameters.
   * @todo Make sure to also update the customEventParameters interface in models.interface.ts
   *
   * @param eventTitle Human Readable Title for Event. Event title will populate in GA4.
   * @param eventParameters Object with key/values to pass as event parameters to GA4 via GTM.
   */
  ledgeEvent: function(eventTitle, eventParameters) {
    window.dataLayer = window.dataLayer || [];
    const event = `ledge_event_${eventTitle.replace(" ", "_")}`;
    window.dataLayer.push({
      "event": event,
      "eventTitle": eventTitle,
      // Make sure values have fallback if not defined as undefined!!
      "productName": eventParameters.productName ? eventParameters.productName : void 0,
      "productCategory": eventParameters.productCategory ? eventParameters.productCategory : void 0,
      "productPosition": eventParameters.position ? eventParameters.position : void 0
    });
  }
};
const cart = {
  // Update cart with note input
  updateCartNote(note) {
    this.cart_loading = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ note })
    }).then(async (response) => {
      let data2 = await response.json();
      if (response.status === 200) {
        this.cart.items = data2.items.map((item2) => {
          return {
            ...item2
          };
        });
        this.updateCart(false);
      } else {
        this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  // Update cart with fetched data
  updateCart(openCart, openModal = false, newProductId = null) {
    this.cart_loading = true;
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then((response) => response.json()).then((data2) => {
      this.cart.items = data2.items;
      if (newProductId) {
        this.cart.recently_added = data2.items.find(
          (item2) => item2.id == newProductId
        );
      }
      console.log(data2.items);
      this.cart.item_count = data2.item_count;
      this.cart.total_price = data2.total_price;
      this.cart.original_total_price = data2.original_total_price;
      this.cart.total_discount = data2.total_discount;
      this.cart.cart_level_discount_applications = data2.cart_level_discount_applications;
      this.cart.note = data2.note;
      let savings = 0;
      data2.items.forEach((item2) => {
        const compareAtPrice = item2.properties._variantSavings ? Number(item2.properties._variantSavings) : null;
        if (compareAtPrice) {
          const temp = (compareAtPrice - item2.price) * item2.quantity;
          savings = savings + temp;
        }
      });
      this.cart.savings = savings;
      this.cart.shipping_gap = this.progress_bar_threshold * (+window.Shopify.currency.rate || 1) - this.cart.total_price;
      this.cart.shipping_progress = this.cart.total_price / (this.progress_bar_threshold * (+window.Shopify.currency.rate || 1)) * 100 + "%";
      setTimeout(() => {
        this.cart_loading = false;
        this.button_loading = false;
      }, 300);
      if (openCart == true) {
        this.cart_delay_width = "0%";
        if (this.cart_behavior == "alert") {
          this.cart_alert = true;
          setTimeout(() => {
            this.cart_delay_width = "100%";
          }, 10);
          setTimeout(() => {
            this.cart_alert = false;
          }, this.cart_delay);
        }
        if (this.cart_behavior == "drawer") {
          this.cart_drawer = true;
        }
        if (this.cart_behavior == "redirect") {
          window.location.href = "/cart";
        }
      } else if (openModal) {
        if (this.cart.recently_added) {
          this.cart_modal = true;
        }
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  // Edit cart item
  editCartItem(oldKey, newKey, sellingPlanId, quantity, openCart, form) {
    if (this.enable_audio) {
      this.playSound(this.click_audio);
    }
    this.cart_loading = true;
    let formData = {
      id: oldKey.toString(),
      quantity: "0"
    };
    fetch("/cart/change.js", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json"
      }
    }).then((response) => response.json()).then(async (data2) => {
      let formData2;
      let newFormData;
      let propertiesArr = [];
      let propertiesObj;
      if (form) {
        newFormData = new FormData(form);
        for (const pair of newFormData.entries()) {
          if (pair[0].includes("properties")) {
            let name = pair[0].replace("properties[", "").replace("]", "");
            propertiesArr.push([name, pair[1]]);
          }
        }
        if (propertiesArr.length > 0) {
          propertiesObj = Object.fromEntries(propertiesArr);
        }
      }
      if (sellingPlanId == 0) {
        if (propertiesObj) {
          formData2 = {
            id: newKey.toString(),
            quantity: quantity.toString(),
            properties: { ...propertiesObj }
          };
        } else {
          formData2 = {
            id: newKey.toString(),
            quantity: quantity.toString()
          };
        }
      } else {
        if (propertiesObj) {
          formData2 = {
            id: newKey.toString(),
            quantity: quantity.toString(),
            properties: { ...propertiesObj },
            selling_plan: sellingPlanId.toString()
          };
        } else {
          formData2 = {
            id: newKey.toString(),
            quantity: quantity.toString(),
            selling_plan: sellingPlanId.toString()
          };
        }
      }
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(formData2),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(async (response) => {
        let data22 = await response.json();
        if (response.status === 200) {
          if (this.enable_audio) {
            this.playSound(this.success_audio);
          }
          this.updateCart(openCart);
        } else {
          this.error_title = data22.message, this.error_message = data22.description, this.show_alert = true;
        }
      }).catch((error2) => {
        console.error("Error:", error2);
        this.cart_loading = false;
      });
    });
  },
  // Call change.js to update cart item then use updateCart()
  changeCartItemQuantity(key, quantity, openCart, refresh) {
    if (this.enable_audio) {
      this.playSound(this.click_audio);
    }
    this.cart_loading = true;
    let formData = {
      id: key.toString(),
      quantity: quantity.toString()
    };
    fetch("/cart/change.js", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json"
      }
    }).then((response) => response.json()).then((data2) => {
      if (data2.status === 422) {
        this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
        this.cart_loading = false;
      }
      this.cart.items = data2.items.map((item2) => {
        return {
          ...item2
        };
      });
      if (refresh) {
        window.location.reload();
      } else {
        this.updateCart(openCart);
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  testFormData(form) {
    let formData = new FormData(form);
    formData.get("id");
    for (var i of formData.entries()) {
      console.log(`${i[0]} : ${i[1]}`);
    }
  },
  addCartItem(form, bundle = false, openModal = false, modalATC = false, upsell = false, quickAdd = false) {
    if (this.enable_audio) {
      this.playSound(this.click_audio);
    }
    this.button_loading = true;
    this.cart_loading = true;
    let formData = new FormData(form);
    let productArray = [];
    if (bundle == true) {
      for (var pair of formData.entries()) {
        if (pair[0].includes("bundle_option")) {
          productArray.push({ id: pair[1], quantity: 1 });
        }
      }
    }
    const variantUpsell = [
      ...document.querySelectorAll("div.buyflow-variant-upsell")
    ];
    if (variantUpsell && !upsell && !quickAdd) {
      upsell = true;
    }
    if (upsell == true) {
      const forms = [...document.querySelectorAll("form.shopify-product-form")];
      for (var upsellForm of forms) {
        let upsellFormData = new FormData(upsellForm);
        const prodId = upsellFormData.get("product-id");
        const upsellCheck = document.querySelector(
          `input#buyflow-upsell-${prodId}`
        );
        if (upsellCheck && !upsellCheck.checked) {
          continue;
        }
        let propertiesArr2 = [];
        let propertiesObj2;
        const quant = upsellFormData.get("quantity") ? upsellFormData.get("quantity") : "1";
        for (const pair2 of upsellFormData.entries()) {
          if (pair2[0].includes("properties")) {
            let name = pair2[0].replace("properties[", "").replace("]", "");
            propertiesArr2.push([name, pair2[1]]);
          }
        }
        if (propertiesArr2.length > 0) {
          propertiesObj2 = Object.fromEntries(propertiesArr2);
        }
        productArray.push({
          id: upsellFormData.get("id"),
          quantity: quant,
          properties: { ...propertiesObj2 }
        });
      }
      for (var upsellVar of variantUpsell) {
        const upsellCheck = upsellVar.querySelector(
          "input.buyflow-variant-checkbox"
        );
        if (upsellCheck && !upsellCheck.checked) {
          continue;
        }
        const varId = upsellVar.dataset.id;
        const nsMatchBack = upsellVar.dataset.nsMatchback;
        const varSavings = upsellVar.dataset.variantSavings;
        const processingTime = upsellVar.dataset.processing;
        const leadtimeMax = upsellVar.dataset.leadtimeMax;
        const quant = upsellVar.dataset.quantity;
        const propertiesObj2 = {
          _ns_matchback: nsMatchBack,
          _variantSavings: varSavings,
          Processing: processingTime,
          _leadtimeMax: leadtimeMax
        };
        productArray.push({
          id: varId,
          quantity: quant,
          properties: { ...propertiesObj2 }
        });
      }
    }
    let sellingPlanId = formData.get("selling_plan");
    let propertiesArr = [];
    let propertiesObj;
    for (const pair2 of formData.entries()) {
      if (pair2[0].includes("properties")) {
        let name = pair2[0].replace("properties[", "").replace("]", "");
        propertiesArr.push([name, pair2[1]]);
      }
    }
    if (propertiesArr.length > 0) {
      propertiesObj = Object.fromEntries(propertiesArr);
    }
    let recipientCheckbox = document.querySelector(
      `#recipient-checkbox`
    );
    let recipientObj;
    if (recipientCheckbox && recipientCheckbox.checked) {
      let recipientName = document.querySelector(
        `#recipient-name`
      );
      let recipientEmail = document.querySelector(
        `#recipient-email`
      );
      let recipientMessage = document.querySelector(
        `#recipient-message`
      );
      if (!recipientName.value || !recipientEmail.value) {
        this.error_title = "Error", this.error_message = "Please fill out name and email of gift card recepient", this.show_alert = true;
        this.cart_loading = false;
        return;
      }
      recipientObj = {
        "Recipient email": recipientEmail.value,
        "Recipient name": recipientName.value,
        Message: recipientMessage.value,
        __shopify_send_gift_card_to_recipient: "on"
      };
    }
    let reqBody;
    if (bundle) {
      reqBody = {
        items: [...productArray]
      };
    } else if (upsell) {
      reqBody = {
        items: [...productArray]
      };
    } else if (sellingPlanId == 0) {
      reqBody = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
            properties: {
              ...propertiesObj,
              ...recipientObj
            }
          }
        ]
      };
    } else {
      reqBody = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
            selling_plan: sellingPlanId,
            properties: {
              ...propertiesObj,
              ...recipientObj
            }
          }
        ]
      };
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(reqBody)
    }).then(async (response) => {
      let data2 = await response.json();
      if (response.status === 200) {
        if (this.enable_audio) {
          this.playSound(this.success_audio);
        }
        const upsellSelectors = [
          {
            selector: "input.buyflow-checkbox",
            attr: "id",
            matchKey: "product_id"
          },
          {
            selector: "input.buyflow-variant-checkbox",
            attr: "name",
            matchKey: "id"
          }
        ];
        const checkedUpsellProducts = [];
        upsellSelectors.forEach(({ selector, attr, matchKey }) => {
          const checkboxes = document.querySelectorAll(
            selector
          );
          checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
              const productId = checkbox[attr].replace("buyflow-upsell-", "");
              const product = data2.items.find(
                (item2) => item2[matchKey] === Number(productId)
              );
              const productName = product == null ? void 0 : product.title.toLowerCase().replace(/[-\s]+/g, "_").replace(/[^a-z0-9_]/g, "").replace(/__+/g, "_").replace(/^_|_$/g, "");
              const productSku = product == null ? void 0 : product.sku.toLowerCase().replace(/[\s]+/g, "-");
              checkedUpsellProducts.push(
                productName ? productName : productSku
              );
            }
          });
        });
        if (checkedUpsellProducts.length > 0) {
          checkedUpsellProducts.forEach((selectedAddOn) => {
            utils$1.gtag("add_on_atc", {
              add_on_atc_product: selectedAddOn
            });
          });
        }
        if (openModal && !modalATC) {
          this.updateCart(!openModal, openModal, reqBody.items[0].id);
        } else if (modalATC) {
          this.updateCart(false, false, reqBody.items[0].id);
        } else {
          this.updateCart(true);
        }
      } else {
        this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
        this.cart_loading = false;
        this.button_loading = false;
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  // Call add.js to add cart item then use updateCart()
  addWithId(variantID, sellingPlanId, quantity, openCart, giftCardRecipient, productHandle) {
    if (this.enable_audio) {
      this.playSound(this.click_audio);
    }
    this.cart_loading = true;
    let formData;
    let propertiesArr = [];
    let propertiesObj;
    let properties = document.getElementsByClassName(
      `custom-input_${productHandle}`
    );
    if (properties) {
      for (const property of properties) {
        propertiesArr.push([property.name, property.value]);
      }
      if (propertiesArr.length > 0) {
        propertiesObj = Object.fromEntries(propertiesArr);
      }
    }
    let recipientCheckbox = document.querySelector(
      `#recipient-checkbox`
    );
    let recipientObj;
    if (giftCardRecipient && recipientCheckbox.checked) {
      let recipientName = document.querySelector(
        `#recipient-name`
      );
      let recipientEmail = document.querySelector(
        `#recipient-email`
      );
      let recipientMessage = document.querySelector(
        `#recipient-message`
      );
      if (!recipientName.value || !recipientEmail.value) {
        this.error_title = "Error", this.error_message = "Please fill out name and email of gift card recepient", this.show_alert = true;
        this.cart_loading = false;
        return;
      }
      recipientObj = {
        "Recipient email": recipientEmail.value,
        "Recipient name": recipientName.value,
        Message: recipientMessage.value,
        __shopify_send_gift_card_to_recipient: "on"
      };
    }
    if (sellingPlanId == 0) {
      formData = {
        items: [
          {
            id: variantID,
            quantity,
            properties: {
              ...propertiesObj,
              ...recipientObj
            }
          }
        ]
      };
    } else {
      formData = {
        items: [
          {
            id: variantID,
            quantity,
            selling_plan: sellingPlanId,
            properties: propertiesObj
          }
        ]
      };
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    }).then(async (response) => {
      let data2 = await response.json();
      if (response.status === 200) {
        if (this.enable_audio) {
          this.playSound(this.success_audio);
        }
        this.updateCart(openCart);
      } else {
        this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  // Add multiple items to cart, used for cart sharing
  addCartItems(items, clear2 = false) {
    this.cart_loading = true;
    let formData = {
      items
    };
    if (clear2) {
      this.cart_loading = true;
      fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      }).then((response) => response.json()).then((data2) => {
        this.updateCart(true);
      }).then(() => {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }).then(async (response) => {
          let data2 = await response.json();
          if (response.status === 200) {
            this.updateCart(true);
          } else {
            this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
          }
        });
      }).catch((error2) => {
        console.error("Error:", error2);
        this.cart_loading = false;
      });
    } else {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then(async (response) => {
        let data2 = await response.json();
        if (response.status === 200) {
          this.cart.items = data2.items.map((item2) => {
            return {
              ...item2
            };
          });
          this.updateCart(true);
        } else {
          this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
        }
      }).catch((error2) => {
        console.error("Error:", error2);
        this.cart_loading = false;
      });
    }
  },
  // Add items to cart if cartshare url available
  handleSharedCart() {
    if (location.search.indexOf("cartshare") >= 0) {
      let query = location.search.substring(1);
      let qArray = query.split("&");
      let objArr = qArray.map((item2) => {
        if (item2 != "") {
          var properties = item2.split(",");
          var obj = {};
          properties.forEach(function(property) {
            var tup = property.split(":");
            obj[tup[0]] = tup[1];
          });
          return obj;
        }
      });
      this.addCartItems(objArr, true);
    }
  },
  // Generate url with query string based on cart contents
  generateUrl() {
    let queryString = "";
    const serialize = function(obj) {
      const str = [];
      for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
          str.push(
            `${encodeURIComponent(p)}:${encodeURIComponent(obj[p].toString())}`
          );
        }
      }
      return str.join(",") + "&";
    };
    const filteredCart = this.cart.items.map((item2) => {
      return {
        cartshare: true,
        id: item2.variant_id,
        quantity: item2.quantity
      };
    });
    filteredCart.forEach((item2) => {
      queryString = queryString.concat(serialize(item2));
    });
    return window.location.origin + "?" + queryString;
  },
  processVariantTitleStyle(variantTitle) {
    if (!variantTitle) {
      return "";
    }
    const processedTitle = variantTitle.replace(/ \/ In water,.*$/, "");
    return processedTitle.trim();
  },
  processVariantTitleWater(variantTitle) {
    if (!variantTitle) {
      return "";
    }
    const startPattern = "/ In water,";
    const endPattern = "/";
    const startIndex = variantTitle.indexOf(startPattern);
    if (startIndex !== -1) {
      const endIndex = variantTitle.indexOf(
        endPattern,
        startIndex + startPattern.length
      );
      if (endIndex !== -1) {
        return variantTitle.substring(startIndex, endIndex + 1).replace("/", "");
      } else {
        return variantTitle.substring(startIndex).replace("/", "");
      }
    } else {
      return "";
    }
  },
  closeModalOpenCart() {
    this.cart_modal = false;
    setTimeout(() => {
      this.cart_drawer = true;
    }, 300);
  },
  modalAddToCart(form) {
    this.addCartItem(form, false, false, true);
  },
  hideFirstImage(formId) {
    const cardForm = document.querySelector("#" + formId);
    const firstImage = cardForm == null ? void 0 : cardForm.querySelector('[data-slide="0"]');
    setTimeout(() => {
      firstImage == null ? void 0 : firstImage.classList.add("hidden");
    }, 1e3);
  },
  madeToOrder(cartItems, mtoThreshold) {
    let leadtimeMax = 0;
    cartItems.forEach((item2) => {
      if (Number(item2.properties._leadtimeMax) > leadtimeMax) {
        leadtimeMax = Number(item2.properties._leadtimeMax);
      }
    });
    if (leadtimeMax >= mtoThreshold) {
      return true;
    } else {
      return false;
    }
  }
};
const search = {
  // Fetch search suggestions and update alpine variables
  fetchAndUpdateSearch(event, params, resources) {
    const buildParams = () => {
      let paramsArr = [];
      for (const [key, value] of Object.entries(params)) {
        if (value) {
          paramsArr.push(key.toString());
        }
      }
      const paramsString = paramsArr.join();
      return paramsString;
    };
    const buildResources = () => {
      let resourceArr = [];
      for (const [key, value] of Object.entries(resources)) {
        if (value) {
          resourceArr.push(key.toString());
        }
      }
      const resourcesString = resourceArr.join();
      return resourcesString;
    };
    const searchTerm = event.target.value;
    this.search_loading = true;
    if (searchTerm.length === 0 || !searchTerm.replace(/\s/g, "").length) {
      this.search_loading = false;
      this.search_items = [];
      this.search_items_collections = [];
      this.search_items_pages = [];
      this.search_items_articles = [];
      this.search_items_queries = [];
      return;
    }
    fetch(
      `${window.Shopify.routes.root}search/suggest.json?q=${searchTerm}&resources[type]=${buildResources()}&resources[limit]=6&[options][fields]=${buildParams()}&section_id=predictive-search`
    ).then((response) => {
      if (!response.ok) {
        var error2 = new Error(response.status.toString());
        throw error2;
      }
      return response.json();
    }).then((data2) => {
      let collections2 = data2.resources.results.collections;
      let pages = data2.resources.results.pages;
      let products2 = data2.resources.results.products;
      let articles = data2.resources.results.articles;
      let queries = data2.resources.results.queries;
      this.search_items = products2 ? products2 : [];
      this.search_items_collections = collections2 ? collections2 : [];
      this.search_items_pages = pages ? pages : [];
      this.search_items_articles = articles ? articles : [];
      this.search_items_queries = queries ? queries : [];
      this.search_loading = false;
    }).catch((error2) => {
      this.error_title = error2.message, this.error_message = error2.description, this.show_alert = true;
      throw error2;
    });
  }
};
const collections = {
  // Load quick add with section render
  fetchAndRenderQuickAdd: function(product_handle, template, edit = false) {
    if (this.enable_audio) {
      this.playSound(this.click_audio);
    }
    fetch(
      window.Shopify.routes.root + "products/" + product_handle + "?section_id=quick-add"
    ).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      document.getElementById(
        "js:quickAdd-" + template + "-" + product_handle
      ).innerHTML = html;
    });
  },
  // Handle filter changes on max price
  handleMaxPriceFilter: function() {
    this.filter_max_price = Math.max(
      this.filter_max_price,
      this.filter_min_price
    );
    this.filter_max_thumb = 100 - (this.filter_max_price - this.filter_min) / (this.filter_max - this.filter_min) * 100;
  },
  // Handle filter changes on min price
  handleMinPriceFilter: function() {
    this.filter_min_price = Math.min(
      this.filter_min_price,
      this.filter_max_price
    );
    this.filter_min_thumb = (this.filter_min_price - this.filter_min) / (this.filter_max - this.filter_min) * 100;
  },
  // Handle filter change for multiple forms
  handleFilterChange(baseId) {
    this.collection_loading = true;
    this.pagination_current_page = 1;
    let filterData = new FormData();
    const filters = document.querySelectorAll(`[id="${baseId}"]`);
    filters.forEach((filter) => {
      if (filter instanceof HTMLFormElement) {
        const formData = new FormData(filter);
        for (let [key, value] of formData.entries()) {
          filterData.append(key, value);
        }
      }
    });
    if (filters.length === 0) {
      console.error("Filter elements not found.");
      return;
    }
    this.fetchAndRenderCollection(filterData);
  },
  // Handle deleting filters
  handleFilterDelete(filterToReset) {
    this.collection_loading = true;
    let combinedFilterData = new FormData();
    const filters = document.querySelectorAll("[id='js:desktopFilter']");
    filters.forEach((filter) => {
      if (filter instanceof HTMLFormElement) {
        const formData = new FormData(filter);
        formData.delete(filterToReset);
        if (filterToReset.indexOf("price") !== -1) {
          formData.delete("filter.v.price.gte");
          formData.delete("filter.v.price.lte");
          this.filter_min_price = this.filter_min;
          this.filter_max_price = this.filter_max;
        }
        for (let [key, value] of formData.entries()) {
          combinedFilterData.append(key, value);
        }
      }
    });
    if (filters.length === 0) {
      console.error("Filter elements not found.");
      return;
    }
    this.fetchAndRenderCollection(combinedFilterData);
  },
  // Handle deleting all filters
  handleFilterDeleteAll: function() {
    this.collection_loading = true;
    sessionStorage.removeItem("priceRanges");
    sessionStorage.removeItem("filter_min_price");
    sessionStorage.removeItem("filter_max_price");
    let filterData = new FormData();
    this.filter_min_price = this.filter_min;
    this.filter_max_price = this.filter_max;
    Object.keys(this.priceRanges).forEach((key) => {
      this.priceRanges[key].checked = false;
    });
    this.fetchAndRenderCollection(filterData);
    this.collection_loading = false;
  },
  // Build urlFilter
  buildUrlFilter: function(filterData) {
    let urlFilter = "";
    for (var pair of filterData.entries()) {
      if (pair[0].indexOf("price") !== -1) {
        if (pair[0] === "filter.v.price.lte") {
          if (pair[1] < this.filter_max) {
            urlFilter = urlFilter + "&" + pair[0] + "=" + encodeURIComponent(pair[1] instanceof File ? "" : pair[1]);
          }
        }
        if (pair[0] === "filter.v.price.gte") {
          if (pair[1] > this.filter_min) {
            urlFilter = urlFilter + "&" + pair[0] + "=" + encodeURIComponent(pair[1] instanceof File ? "" : pair[1]);
          }
        }
      } else {
        urlFilter = urlFilter + "&" + pair[0] + "=" + encodeURIComponent(pair[1] instanceof File ? "" : pair[1]);
      }
    }
    return urlFilter;
  },
  // Call section render API with data from filter
  fetchAndRenderCollection: function(filterData) {
    for (var pair of filterData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
    const collectionTopElem = document.getElementById("js:top");
    const activeFiltersElem = collectionTopElem == null ? void 0 : collectionTopElem.firstElementChild;
    (collectionTopElem == null ? void 0 : collectionTopElem.offsetTop) - (activeFiltersElem == null ? void 0 : activeFiltersElem.offsetHeight);
    window.scrollTo({
      top: collectionTopElem ? collectionTopElem.offsetTop - 150 : 0,
      behavior: "smooth"
    });
    this.filter_popup = false;
    let filterUrl = this.buildUrlFilter(filterData);
    let searchUrl = new URL(location.href).searchParams.get("q");
    searchUrl = "&q=" + searchUrl;
    history.replaceState(
      null,
      "",
      window.location.pathname + "?" + filterUrl + searchUrl
    );
    fetch(
      window.location.pathname + "?section_id=" + this.pagination_section + filterUrl + searchUrl
    ).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      document.getElementById(
        "shopify-section-" + this.pagination_section
      ).innerHTML = html;
      setTimeout(() => {
        this.collection_loading = false;
      }, 100);
    });
  },
  // Check if next page is avaible and inject more products
  fetchAndRenderNextPage: function() {
    if (this.pagination_current_page < this.pagination_total_pages) {
      this.collection_loading = true;
      let filterData = new FormData();
      let filters = document.querySelectorAll(`[id="js:desktopFilter"]`);
      filters.forEach((filter) => {
        if (filter instanceof HTMLFormElement) {
          const formData = new FormData(filter);
          for (let [key, value] of formData.entries()) {
            filterData.append(key, value);
          }
        }
      });
      let pageUrl = "&page=" + (this.pagination_current_page + 1);
      let searchUrl = new URL(location.href).searchParams.get("q");
      searchUrl = "&q=" + searchUrl;
      let fetchUrl = window.location.pathname + "?section_id=" + this.pagination_section + pageUrl + searchUrl;
      if (filters.length > 0) {
        let filterUrl = this.buildUrlFilter(filterData);
        fetchUrl += filterUrl;
      }
      fetch(fetchUrl).then((response) => response.text()).then((responseText) => {
        let html = document.createElement("div");
        html.innerHTML = responseText;
        let htmlCleaned = html.querySelector("#js\\:results").innerHTML;
        document.getElementById("js:results").insertAdjacentHTML("beforeend", htmlCleaned);
        setTimeout(() => {
          this.collection_loading = false;
        }, 100);
        this.pagination_current_page = this.pagination_current_page + 1;
      });
    } else {
      this.collection_loading = false;
    }
  }
};
const products = {
  /**
   * Helper Function to update the Hidden Netsuite Option to set line-item property for NS Matchback capability.
   * @param varID The currently selected Variant ID or Product ID if no variants exist.
   * @requires Use-Example: x-init="$watch('defaultVariantId', value => updateNSMatchback(value))"
   */
  updateNSMatchback: function(varID, containerID) {
    module_default$3.store("defaultVariantID", varID);
    const container = document.getElementById(containerID);
    if (container) {
      const elm = container == null ? void 0 : container.querySelector(`option[data-id="${varID}"]`);
      if (elm) {
        const elmValue = elm.value;
        if (elmValue) {
          container.value = elmValue;
        }
      } else {
        const defaultElm = container == null ? void 0 : container.querySelector(
          `option[data-id="default_option"]`
        );
        const defaultValue = defaultElm.value;
        if (defaultValue) {
          container.value = defaultValue;
        }
      }
    }
  },
  updateLeadtimeProperties: function(varID, containerID) {
    module_default$3.store("defaultVariantID", varID);
    const container = document.getElementById(containerID);
    if (container) {
      const elm = container == null ? void 0 : container.querySelector(`option[data-id="${varID}"]`);
      if (elm) {
        const elmValue = elm.value;
        if (elmValue) {
          container.value = elmValue;
        }
      } else {
        const defaultElm = container == null ? void 0 : container.querySelector(
          `option[data-id="default_option"]`
        );
        const defaultValue = defaultElm.value;
        if (defaultValue) {
          container.value = defaultValue;
        }
      }
    }
  },
  /**
   * Helper Function to update the Hidden Variant Compare Prices for use in cart.
   * @param varID The currently selected Variant ID or Product ID if no variants exist.
   * @requires Use-Example: x-init="$watch('defaultVariantId', value => updateNSMatchback(value))"
   */
  updateSavings: function(varID, containerID) {
    const container = document.getElementById(containerID);
    if (container) {
      const elm = container == null ? void 0 : container.querySelector(`option[data-id="${varID}"]`);
      if (elm) {
        const elmValue = elm.value;
        if (elmValue) {
          container.value = elmValue;
        }
      } else {
        const defaultElm = container == null ? void 0 : container.querySelector(
          `option[data-id="default_option"]`
        );
        const defaultValue = defaultElm.value;
        if (defaultValue) {
          container.value = defaultValue;
        }
      }
    }
  },
  /**
   * Small Helper Function to update and initialize PDP Marquee component "Featured In"
   *
   */
  marqueeInit: function() {
    const root = document.documentElement;
    const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue(
      "--marquee-elements-displayed"
    );
    const marqueeContent = document.querySelector("ul.marquee-content");
    if (marqueeContent) {
      const numberOfElements = marqueeContent.children.length.toString();
      root.style.setProperty("--marquee-elements", numberOfElements);
    }
    for (let i = 0; i < parseInt(marqueeElementsDisplayed); i++) {
      marqueeContent == null ? void 0 : marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
    }
  },
  initOptionDropDown: function(optionGroup) {
    if (optionGroup) {
      module_default$3.store(`optionGroup-${optionGroup}`, {
        open: false,
        toggle() {
          this.open = !this.open;
        }
      });
      module_default$3.store(`optionGroupModal-${optionGroup}`, {
        open: false,
        toggle() {
          this.open = !this.open;
        }
      });
    } else {
      module_default$3.store(`alternatebuyflowmodal`, {
        open: false,
        toggle() {
          this.open = !this.open;
        }
      });
    }
  },
  optionDropDownClick: function(container) {
    const containerElm = document.getElementById(container);
    if (containerElm) {
      const buttonElm = containerElm.querySelector("button");
      if (buttonElm) {
        buttonElm.dispatchEvent(new Event("click"));
      }
    }
  },
  stickyNavigationInit: function() {
    const stickyClass = "stickyNavData";
    const stickyNavElm = document.getElementById("stickyNavigation");
    const sections = [...document.querySelectorAll(`.${stickyClass}`)];
    let sectionIds = [];
    sections.forEach((item2) => {
      let itemTitle = item2.id.replace("_", " ");
      let sectionElm = document.createElement("a");
      let headingElm;
      if (item2.previousElementSibling) {
        const elm = item2.previousElementSibling;
        if (elm.classList.contains("stickyNavData-heading")) {
          headingElm = elm;
        }
      }
      if (headingElm) {
        sectionElm.setAttribute("href", `#${headingElm.id}`);
      } else {
        sectionElm.setAttribute("href", `#${item2.id}`);
      }
      sectionIds.push(`${item2.id}`);
      sectionElm.textContent = itemTitle;
      sectionElm.classList.add("stickyNavElm");
      stickyNavElm == null ? void 0 : stickyNavElm.appendChild(sectionElm);
    });
    module_default$3.store("stickyNav", sectionIds);
  },
  countdownTimer: function() {
    const timeStart = 600;
    const timeFormat = "10:00";
    return {
      time: timeStart,
      // 10 minutes in seconds
      countdownTimerText: timeFormat,
      interval: null,
      init() {
        this.$watch("cart_modal", (value) => {
          if (value) {
            this.resetTimer();
          }
        });
      },
      startTimer() {
        if (this.cart_modal) {
          this.interval = setInterval(() => {
            if (this.time <= 0) {
              clearInterval(this.interval);
              this.cart_modal = false;
            } else {
              this.time--;
              this.countdownTimerText = this.formatTime(this.time);
            }
          }, 1e3);
        }
      },
      resetTimer() {
        clearInterval(this.interval);
        this.time = timeStart;
        this.countdownTimerText = this.formatTime(this.time);
        this.startTimer();
      },
      formatTime(seconds) {
        if (this.cart_modal) {
          const minutes = Math.floor(seconds / 60);
          const remainingSeconds = seconds % 60;
          return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
        } else {
          return timeFormat;
        }
      }
    };
  },
  // Load quick add with section render
  fetchAndRenderUpsellItem: function(product_handle, template, edit = false) {
    fetch(
      window.Shopify.routes.root + "products/" + product_handle + "?section_id=modal-upsell"
    ).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      document.getElementById(
        "js:modalUpsell-" + template + "-" + product_handle
      ).innerHTML = html;
    });
  },
  /**
   * Handler function that takes input in buyflow upsells and handles change event on hidden form.
   * @param selectId
   */
  handleBuyflowUpsells: function(selectId) {
    const selectElm = document.getElementById(`${selectId}-upsell`);
    const selectedOp = selectElm.value;
    const selectElmTarget = document.getElementById(`${selectId}`);
    if (selectElmTarget) {
      selectElmTarget.value = selectedOp;
      selectElmTarget.dispatchEvent(new Event("change"));
      setTimeout(() => {
        this.setBuyflowUpsell(selectId);
        this.updateUpsellPrice();
      }, 100);
    }
  },
  /**
   * Helper function for "handleBuyflowUpsells()" - Updates Alpine.Store variable for additional logic in "product__prod-upsell.liquid"
   * @function handleBuyflowUpsells()
   * @param id
   */
  setBuyflowUpsell: function(id) {
    const elm = document.getElementById(id);
    const form = elm == null ? void 0 : elm.closest("form");
    const formData = new FormData(form);
    if (formData) {
      const prodId = formData == null ? void 0 : formData.get("product-id");
      const variantId = formData == null ? void 0 : formData.get("id");
      module_default$3.store(`upsell${prodId}var`, variantId);
    }
  },
  /**
   * Function to update Alpine store variable to calculate total upsell cost, variable read by atc buttons
   * @function updateUpsellPrice()
   */
  updateUpsellPrice: function() {
    let upsellPrice = 0;
    module_default$3.nextTick(() => {
      const variantUpsells = [
        ...document.querySelectorAll(".buyflow-variant-upsell")
      ];
      if (variantUpsells) {
        for (const upsell of variantUpsells) {
          const checkElm = upsell.querySelector(".buyflow-variant-checkbox");
          if (checkElm && checkElm.checked) {
            const varPrice = upsell.dataset.varPrice;
            upsellPrice = upsellPrice + Number(varPrice);
          } else {
            continue;
          }
        }
      }
      const prodUpsells = [...document.querySelectorAll(".buyflow-upsell")];
      if (prodUpsells) {
        for (const upsell of prodUpsells) {
          const checkElm = upsell.querySelector(".buyflow-checkbox");
          if (checkElm && checkElm.checked) {
            const priceElm = upsell.querySelector(
              ".buyflow-upsell-price.activePrice"
            );
            if (priceElm) {
              const varPrice = priceElm.dataset.buyflowPrice;
              upsellPrice = upsellPrice + Number(varPrice);
            }
          } else {
            continue;
          }
        }
      }
      if (upsellPrice !== null) {
        module_default$3.store(`buyflowupsellprice`, upsellPrice);
      }
    });
  },
  updateUpsellCustomProperties: function(selector, id) {
    const element2 = document.getElementById(selector);
    if (element2) {
      const elm = element2.querySelector(`option[data-id="${id}"]`);
      if (elm) {
        const newValue = elm.value;
        if (newValue) {
          element2.value = newValue;
        }
      } else {
        const defaultElm = element2.querySelector(
          `option[data-id="default_option"]`
        );
        const defaultValue = defaultElm.value;
        if (defaultValue) {
          element2.value = defaultValue;
        }
      }
    }
  },
  updateUpsellCheckboxes: function(groupClass) {
    const checkboxes = [...document.querySelectorAll(`.${groupClass}`)];
    let checked = false;
    if (checkboxes) {
      for (var check of checkboxes) {
        if (check.checked) {
          checked = true;
          break;
        }
      }
      for (var check of checkboxes) {
        check.checked = false;
      }
      if (checked === true) {
        module_default$3.nextTick(() => {
          const activeCheckbox = document.querySelector(
            `input.activeCheck.${groupClass}`
          );
          if (activeCheckbox) {
            activeCheckbox.checked = true;
          }
        });
      }
      this.updateUpsellPrice();
    }
  },
  initUpsellModal: function(id) {
    if (id) {
      module_default$3.store(`upsellModal-${id}`, {
        open: false,
        toggle() {
          this.open = !this.open;
        }
      });
    }
  },
  /**
   * Updates the same day shipping timer display based on leadtime and cutoff time
   * Shows a countdown timer if an order can be shipped same day (based on CST/CDT time)
   * @param el - The HTML element containing the timer display
   */
  updateSameDayTimer: function(el) {
    const selfData = this;
    const cutoffHour = selfData.sameDayShipHour || 12;
    let timerIntervalId;
    if (selfData.sameDayShipLeadtime <= 0 || selfData.sameDayShipLeadtime >= 2) {
      selfData.sameDayShipShowTimer = false;
      return;
    }
    const calculateCutoffTime = () => {
      var _a, _b, _c, _d;
      try {
        const now = /* @__PURE__ */ new Date();
        const dayOfWeek = now.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return null;
        }
        const cstFormatter = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/Chicago",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false
        });
        const cstParts = cstFormatter.formatToParts(now);
        const cstYear = ((_a = cstParts.find((part) => part.type === "year")) == null ? void 0 : _a.value) || "";
        const cstMonth = ((_b = cstParts.find((part) => part.type === "month")) == null ? void 0 : _b.value) || "";
        const cstDay = ((_c = cstParts.find((part) => part.type === "day")) == null ? void 0 : _c.value) || "";
        const cstHour = parseInt(
          ((_d = cstParts.find((part) => part.type === "hour")) == null ? void 0 : _d.value) || "0"
        );
        if (cstHour >= cutoffHour) {
          return null;
        }
        const timeZoneName = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/Chicago",
          timeZoneName: "short"
        }).format(now);
        const isDaylightSavings = timeZoneName.includes("CDT");
        const timezoneOffsetHours = isDaylightSavings ? 5 : 6;
        const cutoffTimeString = `${cstYear}-${cstMonth}-${cstDay}T${cutoffHour}:00:00`;
        const centralCutoffTime = new Date(cutoffTimeString);
        const localOffset = now.getTimezoneOffset() * 6e4;
        const chicagoOffset = timezoneOffsetHours * 60 * 6e4;
        const utcMillis = centralCutoffTime.getTime() + chicagoOffset;
        return new Date(utcMillis - localOffset);
      } catch (error2) {
        console.error("Error calculating cutoff time:", error2);
        return null;
      }
    };
    const localCutoffTime = calculateCutoffTime();
    if (!localCutoffTime) {
      selfData.sameDayShipShowTimer = false;
      return;
    }
    const updateTimerDisplay = () => {
      const now = /* @__PURE__ */ new Date();
      const diff = localCutoffTime.getTime() - now.getTime();
      if (diff <= 0) {
        selfData.sameDayShipShowTimer = false;
        return false;
      }
      const hours = Math.floor(diff / (1e3 * 60 * 60));
      const minutes = Math.floor(diff % (1e3 * 60 * 60) / (1e3 * 60));
      const seconds = Math.floor(diff % (1e3 * 60) / 1e3);
      const newText = `${selfData.sameDayShipTimeText} <span class="font-bold text-ll-red">${hours}h ${minutes}m ${seconds}s</span>`;
      if (selfData.sameDayShipText !== newText) {
        selfData.sameDayShipText = newText;
      }
      selfData.sameDayShipShowTimer = true;
      return true;
    };
    if (!updateTimerDisplay()) {
      return;
    }
    timerIntervalId = window.setInterval(() => {
      if (!updateTimerDisplay()) {
        clearInterval(timerIntervalId);
      }
    }, 1e3);
    selfData.timerIntervalId = timerIntervalId;
    const observer2 = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.removedNodes.length > 0 && Array.from(mutation.removedNodes).some(
          (node) => node === el || el.contains(node)
        )) {
          clearInterval(timerIntervalId);
          observer2.disconnect();
          break;
        }
      }
    });
    if (el.parentNode) {
      observer2.observe(el.parentNode, { childList: true, subtree: true });
    }
  },
  optionToggle: function(id) {
    const elm = document.getElementById(id);
    if (elm) {
      const options = [...elm.querySelectorAll("option")];
      if (options) {
        let breakFlag = false;
        options.forEach((op) => {
          if (breakFlag != true) {
            if (elm.value !== op.value) {
              breakFlag = true;
              elm.value = op.value;
              elm.dispatchEvent(new Event("change"));
            }
          }
        });
      }
    }
  }
};
class AlpineStateContext {
  // Sets or updates a value in the Alpine store.
  setStateValue(key, value, forceRenew = false) {
    if (forceRenew) {
      const newValue = Array.isArray(value) ? [...value] : { ...value };
      module_default$3.store(key, newValue);
      module_default$3.nextTick();
    } else {
      module_default$3.store(key, value);
    }
  }
  getStateValue(key) {
    return module_default$3.store(key);
  }
  // Resets the value for the given key in the Alpine store.
  resetState(key) {
  }
  // Logs an error in the Alpine store under a specific key.
  handleError(key, error2) {
  }
}
class Page {
  constructor(mobileMax = "1024") {
    this._pageTitle = "";
    this._template = "";
    this.stateContext = new AlpineStateContext();
    this.mobileQuery = window.matchMedia(`(max-width: ${mobileMax}px)`);
    this.stateContext.setStateValue("isMobile", this.mobileQuery.matches);
    this.mobileQuery.addEventListener(
      "change",
      this.handleMobileQueryChange.bind(this)
    );
  }
  get pageTitle() {
    return this._pageTitle;
  }
  set pageTitle(value) {
    this._pageTitle = value;
  }
  get pageTemplate() {
    return this._template;
  }
  set pageTemplate(value) {
    this._template = value;
  }
  // TODO: Return to assure there are no memory leaks.
  // NOTE: Don't forget to call destroy if at any point we don't end up using this page class.
  destroy() {
    this.mobileQuery.removeEventListener(
      "change",
      this.handleMobileQueryChange.bind(this)
    );
  }
  // Handles changes in the MediaQueryList
  handleMobileQueryChange(e) {
    this.stateContext.setStateValue("isMobile", e.matches);
  }
}
class ProductDescriptionPage extends Page {
  constructor() {
    super();
  }
  init() {
    console.log("Product Description Page initialized");
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var isotope = { exports: {} };
var outlayer = { exports: {} };
var evEmitter$1 = { exports: {} };
var hasRequiredEvEmitter$1;
function requireEvEmitter$1() {
  if (hasRequiredEvEmitter$1)
    return evEmitter$1.exports;
  hasRequiredEvEmitter$1 = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        global2.EvEmitter = factory();
      }
    })(typeof window != "undefined" ? window : commonjsGlobal, function() {
      function EvEmitter() {
      }
      var proto = EvEmitter.prototype;
      proto.on = function(eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        var events = this._events = this._events || {};
        var listeners = events[eventName] = events[eventName] || [];
        if (listeners.indexOf(listener) == -1) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function(eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        this.on(eventName, listener);
        var onceEvents = this._onceEvents = this._onceEvents || {};
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        var index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        listeners = listeners.slice(0);
        args = args || [];
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (var i = 0; i < listeners.length; i++) {
          var listener = listeners[i];
          var isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            this.off(eventName, listener);
            delete onceListeners[listener];
          }
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
      };
      return EvEmitter;
    });
  })(evEmitter$1);
  return evEmitter$1.exports;
}
var getSize = { exports: {} };
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */
var hasRequiredGetSize;
function requireGetSize() {
  if (hasRequiredGetSize)
    return getSize.exports;
  hasRequiredGetSize = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.getSize = factory();
      }
    })(window, function factory() {
      function getStyleSize(value) {
        var num = parseFloat(value);
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
      }
      function noop() {
      }
      var logError = typeof console == "undefined" ? noop : function(message) {
        console.error(message);
      };
      var measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
      ];
      var measurementsLength = measurements.length;
      function getZeroSize() {
        var size2 = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0
        };
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          size2[measurement] = 0;
        }
        return size2;
      }
      function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) {
          logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1");
        }
        return style;
      }
      var isSetup = false;
      var isBoxSizeOuter;
      function setup() {
        if (isSetup) {
          return;
        }
        isSetup = true;
        var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize2.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
      }
      function getSize2(elem) {
        setup();
        if (typeof elem == "string") {
          elem = document.querySelector(elem);
        }
        if (!elem || typeof elem != "object" || !elem.nodeType) {
          return;
        }
        var style = getStyle(elem);
        if (style.display == "none") {
          return getZeroSize();
        }
        var size2 = {};
        size2.width = elem.offsetWidth;
        size2.height = elem.offsetHeight;
        var isBorderBox = size2.isBorderBox = style.boxSizing == "border-box";
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          var value = style[measurement];
          var num = parseFloat(value);
          size2[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size2.paddingLeft + size2.paddingRight;
        var paddingHeight = size2.paddingTop + size2.paddingBottom;
        var marginWidth = size2.marginLeft + size2.marginRight;
        var marginHeight = size2.marginTop + size2.marginBottom;
        var borderWidth = size2.borderLeftWidth + size2.borderRightWidth;
        var borderHeight = size2.borderTopWidth + size2.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
          size2.width = styleWidth + // add padding and border unless it's already including it
          (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
          size2.height = styleHeight + // add padding and border unless it's already including it
          (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }
        size2.innerWidth = size2.width - (paddingWidth + borderWidth);
        size2.innerHeight = size2.height - (paddingHeight + borderHeight);
        size2.outerWidth = size2.width + marginWidth;
        size2.outerHeight = size2.height + marginHeight;
        return size2;
      }
      return getSize2;
    });
  })(getSize);
  return getSize.exports;
}
var utils = { exports: {} };
var matchesSelector = { exports: {} };
var hasRequiredMatchesSelector;
function requireMatchesSelector() {
  if (hasRequiredMatchesSelector)
    return matchesSelector.exports;
  hasRequiredMatchesSelector = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.matchesSelector = factory();
      }
    })(window, function factory() {
      var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        if (ElemProto.matches) {
          return "matches";
        }
        if (ElemProto.matchesSelector) {
          return "matchesSelector";
        }
        var prefixes = ["webkit", "moz", "ms", "o"];
        for (var i = 0; i < prefixes.length; i++) {
          var prefix2 = prefixes[i];
          var method = prefix2 + "MatchesSelector";
          if (ElemProto[method]) {
            return method;
          }
        }
      }();
      return function matchesSelector2(elem, selector) {
        return elem[matchesMethod](selector);
      };
    });
  })(matchesSelector);
  return matchesSelector.exports;
}
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils.exports;
  hasRequiredUtils = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireMatchesSelector()
        );
      } else {
        window2.fizzyUIUtils = factory(
          window2,
          window2.matchesSelector
        );
      }
    })(window, function factory(window2, matchesSelector2) {
      var utils2 = {};
      utils2.extend = function(a, b) {
        for (var prop in b) {
          a[prop] = b[prop];
        }
        return a;
      };
      utils2.modulo = function(num, div) {
        return (num % div + div) % div;
      };
      var arraySlice = Array.prototype.slice;
      utils2.makeArray = function(obj) {
        if (Array.isArray(obj)) {
          return obj;
        }
        if (obj === null || obj === void 0) {
          return [];
        }
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) {
          return arraySlice.call(obj);
        }
        return [obj];
      };
      utils2.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) {
          ary.splice(index, 1);
        }
      };
      utils2.getParent = function(elem, selector) {
        while (elem.parentNode && elem != document.body) {
          elem = elem.parentNode;
          if (matchesSelector2(elem, selector)) {
            return elem;
          }
        }
      };
      utils2.getQueryElement = function(elem) {
        if (typeof elem == "string") {
          return document.querySelector(elem);
        }
        return elem;
      };
      utils2.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      utils2.filterFindElements = function(elems, selector) {
        elems = utils2.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
          if (!(elem instanceof HTMLElement)) {
            return;
          }
          if (!selector) {
            ffElems.push(elem);
            return;
          }
          if (matchesSelector2(elem, selector)) {
            ffElems.push(elem);
          }
          var childElems = elem.querySelectorAll(selector);
          for (var i = 0; i < childElems.length; i++) {
            ffElems.push(childElems[i]);
          }
        });
        return ffElems;
      };
      utils2.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
          var timeout = this[timeoutName];
          clearTimeout(timeout);
          var args = arguments;
          var _this = this;
          this[timeoutName] = setTimeout(function() {
            method.apply(_this, args);
            delete _this[timeoutName];
          }, threshold);
        };
      };
      utils2.docReady = function(callback2) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          setTimeout(callback2);
        } else {
          document.addEventListener("DOMContentLoaded", callback2);
        }
      };
      utils2.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
          return $1 + "-" + $2;
        }).toLowerCase();
      };
      var console2 = window2.console;
      utils2.htmlInit = function(WidgetClass, namespace) {
        utils2.docReady(function() {
          var dashedNamespace = utils2.toDashed(namespace);
          var dataAttr = "data-" + dashedNamespace;
          var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
          var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
          var elems = utils2.makeArray(dataAttrElems).concat(utils2.makeArray(jsDashElems));
          var dataOptionsAttr = dataAttr + "-options";
          var jQuery = window2.jQuery;
          elems.forEach(function(elem) {
            var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
            var options;
            try {
              options = attr && JSON.parse(attr);
            } catch (error2) {
              if (console2) {
                console2.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error2);
              }
              return;
            }
            var instance = new WidgetClass(elem, options);
            if (jQuery) {
              jQuery.data(elem, namespace, instance);
            }
          });
        });
      };
      return utils2;
    });
  })(utils);
  return utils.exports;
}
var item$1 = { exports: {} };
var hasRequiredItem$1;
function requireItem$1() {
  if (hasRequiredItem$1)
    return item$1.exports;
  hasRequiredItem$1 = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireEvEmitter$1(),
          requireGetSize()
        );
      } else {
        window2.Outlayer = {};
        window2.Outlayer.Item = factory(
          window2.EvEmitter,
          window2.getSize
        );
      }
    })(window, function factory(EvEmitter, getSize2) {
      function isEmptyObj(obj) {
        for (var prop in obj) {
          return false;
        }
        prop = null;
        return true;
      }
      var docElemStyle = document.documentElement.style;
      var transitionProperty = typeof docElemStyle.transition == "string" ? "transition" : "WebkitTransition";
      var transformProperty = typeof docElemStyle.transform == "string" ? "transform" : "WebkitTransform";
      var transitionEndEvent = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
      }[transitionProperty];
      var vendorProperties = {
        transform: transformProperty,
        transition: transitionProperty,
        transitionDuration: transitionProperty + "Duration",
        transitionProperty: transitionProperty + "Property",
        transitionDelay: transitionProperty + "Delay"
      };
      function Item(element2, layout) {
        if (!element2) {
          return;
        }
        this.element = element2;
        this.layout = layout;
        this.position = {
          x: 0,
          y: 0
        };
        this._create();
      }
      var proto = Item.prototype = Object.create(EvEmitter.prototype);
      proto.constructor = Item;
      proto._create = function() {
        this._transn = {
          ingProperties: {},
          clean: {},
          onEnd: {}
        };
        this.css({
          position: "absolute"
        });
      };
      proto.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      proto.getSize = function() {
        this.size = getSize2(this.element);
      };
      proto.css = function(style) {
        var elemStyle = this.element.style;
        for (var prop in style) {
          var supportedProp = vendorProperties[prop] || prop;
          elemStyle[supportedProp] = style[prop];
        }
      };
      proto.getPosition = function() {
        var style = getComputedStyle(this.element);
        var isOriginLeft = this.layout._getOption("originLeft");
        var isOriginTop = this.layout._getOption("originTop");
        var xValue = style[isOriginLeft ? "left" : "right"];
        var yValue = style[isOriginTop ? "top" : "bottom"];
        var x2 = parseFloat(xValue);
        var y = parseFloat(yValue);
        var layoutSize = this.layout.size;
        if (xValue.indexOf("%") != -1) {
          x2 = x2 / 100 * layoutSize.width;
        }
        if (yValue.indexOf("%") != -1) {
          y = y / 100 * layoutSize.height;
        }
        x2 = isNaN(x2) ? 0 : x2;
        y = isNaN(y) ? 0 : y;
        x2 -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
        y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
        this.position.x = x2;
        this.position.y = y;
      };
      proto.layoutPosition = function() {
        var layoutSize = this.layout.size;
        var style = {};
        var isOriginLeft = this.layout._getOption("originLeft");
        var isOriginTop = this.layout._getOption("originTop");
        var xPadding = isOriginLeft ? "paddingLeft" : "paddingRight";
        var xProperty = isOriginLeft ? "left" : "right";
        var xResetProperty = isOriginLeft ? "right" : "left";
        var x2 = this.position.x + layoutSize[xPadding];
        style[xProperty] = this.getXValue(x2);
        style[xResetProperty] = "";
        var yPadding = isOriginTop ? "paddingTop" : "paddingBottom";
        var yProperty = isOriginTop ? "top" : "bottom";
        var yResetProperty = isOriginTop ? "bottom" : "top";
        var y = this.position.y + layoutSize[yPadding];
        style[yProperty] = this.getYValue(y);
        style[yResetProperty] = "";
        this.css(style);
        this.emitEvent("layout", [this]);
      };
      proto.getXValue = function(x2) {
        var isHorizontal = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !isHorizontal ? x2 / this.layout.size.width * 100 + "%" : x2 + "px";
      };
      proto.getYValue = function(y) {
        var isHorizontal = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + "%" : y + "px";
      };
      proto._transitionTo = function(x2, y) {
        this.getPosition();
        var curX = this.position.x;
        var curY = this.position.y;
        var didNotMove = x2 == this.position.x && y == this.position.y;
        this.setPosition(x2, y);
        if (didNotMove && !this.isTransitioning) {
          this.layoutPosition();
          return;
        }
        var transX = x2 - curX;
        var transY = y - curY;
        var transitionStyle = {};
        transitionStyle.transform = this.getTranslate(transX, transY);
        this.transition({
          to: transitionStyle,
          onTransitionEnd: {
            transform: this.layoutPosition
          },
          isCleaning: true
        });
      };
      proto.getTranslate = function(x2, y) {
        var isOriginLeft = this.layout._getOption("originLeft");
        var isOriginTop = this.layout._getOption("originTop");
        x2 = isOriginLeft ? x2 : -x2;
        y = isOriginTop ? y : -y;
        return "translate3d(" + x2 + "px, " + y + "px, 0)";
      };
      proto.goTo = function(x2, y) {
        this.setPosition(x2, y);
        this.layoutPosition();
      };
      proto.moveTo = proto._transitionTo;
      proto.setPosition = function(x2, y) {
        this.position.x = parseFloat(x2);
        this.position.y = parseFloat(y);
      };
      proto._nonTransition = function(args) {
        this.css(args.to);
        if (args.isCleaning) {
          this._removeStyles(args.to);
        }
        for (var prop in args.onTransitionEnd) {
          args.onTransitionEnd[prop].call(this);
        }
      };
      proto.transition = function(args) {
        if (!parseFloat(this.layout.options.transitionDuration)) {
          this._nonTransition(args);
          return;
        }
        var _transition = this._transn;
        for (var prop in args.onTransitionEnd) {
          _transition.onEnd[prop] = args.onTransitionEnd[prop];
        }
        for (prop in args.to) {
          _transition.ingProperties[prop] = true;
          if (args.isCleaning) {
            _transition.clean[prop] = true;
          }
        }
        if (args.from) {
          this.css(args.from);
          this.element.offsetHeight;
        }
        this.enableTransition(args.to);
        this.css(args.to);
        this.isTransitioning = true;
      };
      function toDashedAll(str) {
        return str.replace(/([A-Z])/g, function($1) {
          return "-" + $1.toLowerCase();
        });
      }
      var transitionProps = "opacity," + toDashedAll(transformProperty);
      proto.enableTransition = function() {
        if (this.isTransitioning) {
          return;
        }
        var duration = this.layout.options.transitionDuration;
        duration = typeof duration == "number" ? duration + "ms" : duration;
        this.css({
          transitionProperty: transitionProps,
          transitionDuration: duration,
          transitionDelay: this.staggerDelay || 0
        });
        this.element.addEventListener(transitionEndEvent, this, false);
      };
      proto.onwebkitTransitionEnd = function(event) {
        this.ontransitionend(event);
      };
      proto.onotransitionend = function(event) {
        this.ontransitionend(event);
      };
      var dashedVendorProperties = {
        "-webkit-transform": "transform"
      };
      proto.ontransitionend = function(event) {
        if (event.target !== this.element) {
          return;
        }
        var _transition = this._transn;
        var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;
        delete _transition.ingProperties[propertyName];
        if (isEmptyObj(_transition.ingProperties)) {
          this.disableTransition();
        }
        if (propertyName in _transition.clean) {
          this.element.style[event.propertyName] = "";
          delete _transition.clean[propertyName];
        }
        if (propertyName in _transition.onEnd) {
          var onTransitionEnd = _transition.onEnd[propertyName];
          onTransitionEnd.call(this);
          delete _transition.onEnd[propertyName];
        }
        this.emitEvent("transitionEnd", [this]);
      };
      proto.disableTransition = function() {
        this.removeTransitionStyles();
        this.element.removeEventListener(transitionEndEvent, this, false);
        this.isTransitioning = false;
      };
      proto._removeStyles = function(style) {
        var cleanStyle = {};
        for (var prop in style) {
          cleanStyle[prop] = "";
        }
        this.css(cleanStyle);
      };
      var cleanTransitionStyle = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
      };
      proto.removeTransitionStyles = function() {
        this.css(cleanTransitionStyle);
      };
      proto.stagger = function(delay3) {
        delay3 = isNaN(delay3) ? 0 : delay3;
        this.staggerDelay = delay3 + "ms";
      };
      proto.removeElem = function() {
        this.element.parentNode.removeChild(this.element);
        this.css({ display: "" });
        this.emitEvent("remove", [this]);
      };
      proto.remove = function() {
        if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
          this.removeElem();
          return;
        }
        this.once("transitionEnd", function() {
          this.removeElem();
        });
        this.hide();
      };
      proto.reveal = function() {
        delete this.isHidden;
        this.css({ display: "" });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty("visibleStyle");
        onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
        this.transition({
          from: options.hiddenStyle,
          to: options.visibleStyle,
          isCleaning: true,
          onTransitionEnd
        });
      };
      proto.onRevealTransitionEnd = function() {
        if (!this.isHidden) {
          this.emitEvent("reveal");
        }
      };
      proto.getHideRevealTransitionEndProperty = function(styleProperty) {
        var optionStyle = this.layout.options[styleProperty];
        if (optionStyle.opacity) {
          return "opacity";
        }
        for (var prop in optionStyle) {
          return prop;
        }
      };
      proto.hide = function() {
        this.isHidden = true;
        this.css({ display: "" });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty("hiddenStyle");
        onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
        this.transition({
          from: options.visibleStyle,
          to: options.hiddenStyle,
          // keep hidden stuff hidden
          isCleaning: true,
          onTransitionEnd
        });
      };
      proto.onHideTransitionEnd = function() {
        if (this.isHidden) {
          this.css({ display: "none" });
          this.emitEvent("hide");
        }
      };
      proto.destroy = function() {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: ""
        });
      };
      return Item;
    });
  })(item$1);
  return item$1.exports;
}
/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */
var hasRequiredOutlayer;
function requireOutlayer() {
  if (hasRequiredOutlayer)
    return outlayer.exports;
  hasRequiredOutlayer = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireEvEmitter$1(),
          requireGetSize(),
          requireUtils(),
          requireItem$1()
        );
      } else {
        window2.Outlayer = factory(
          window2,
          window2.EvEmitter,
          window2.getSize,
          window2.fizzyUIUtils,
          window2.Outlayer.Item
        );
      }
    })(window, function factory(window2, EvEmitter, getSize2, utils2, Item) {
      var console2 = window2.console;
      var jQuery = window2.jQuery;
      var noop = function() {
      };
      var GUID = 0;
      var instances = {};
      function Outlayer(element2, options) {
        var queryElement = utils2.getQueryElement(element2);
        if (!queryElement) {
          if (console2) {
            console2.error("Bad element for " + this.constructor.namespace + ": " + (queryElement || element2));
          }
          return;
        }
        this.element = queryElement;
        if (jQuery) {
          this.$element = jQuery(this.element);
        }
        this.options = utils2.extend({}, this.constructor.defaults);
        this.option(options);
        var id = ++GUID;
        this.element.outlayerGUID = id;
        instances[id] = this;
        this._create();
        var isInitLayout = this._getOption("initLayout");
        if (isInitLayout) {
          this.layout();
        }
      }
      Outlayer.namespace = "outlayer";
      Outlayer.Item = Item;
      Outlayer.defaults = {
        containerStyle: {
          position: "relative"
        },
        initLayout: true,
        originLeft: true,
        originTop: true,
        resize: true,
        resizeContainer: true,
        // item options
        transitionDuration: "0.4s",
        hiddenStyle: {
          opacity: 0,
          transform: "scale(0.001)"
        },
        visibleStyle: {
          opacity: 1,
          transform: "scale(1)"
        }
      };
      var proto = Outlayer.prototype;
      utils2.extend(proto, EvEmitter.prototype);
      proto.option = function(opts) {
        utils2.extend(this.options, opts);
      };
      proto._getOption = function(option) {
        var oldOption = this.constructor.compatOptions[option];
        return oldOption && this.options[oldOption] !== void 0 ? this.options[oldOption] : this.options[option];
      };
      Outlayer.compatOptions = {
        // currentName: oldName
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
      };
      proto._create = function() {
        this.reloadItems();
        this.stamps = [];
        this.stamp(this.options.stamp);
        utils2.extend(this.element.style, this.options.containerStyle);
        var canBindResize = this._getOption("resize");
        if (canBindResize) {
          this.bindResize();
        }
      };
      proto.reloadItems = function() {
        this.items = this._itemize(this.element.children);
      };
      proto._itemize = function(elems) {
        var itemElems = this._filterFindItemElements(elems);
        var Item2 = this.constructor.Item;
        var items = [];
        for (var i = 0; i < itemElems.length; i++) {
          var elem = itemElems[i];
          var item2 = new Item2(elem, this);
          items.push(item2);
        }
        return items;
      };
      proto._filterFindItemElements = function(elems) {
        return utils2.filterFindElements(elems, this.options.itemSelector);
      };
      proto.getItemElements = function() {
        return this.items.map(function(item2) {
          return item2.element;
        });
      };
      proto.layout = function() {
        this._resetLayout();
        this._manageStamps();
        var layoutInstant = this._getOption("layoutInstant");
        var isInstant = layoutInstant !== void 0 ? layoutInstant : !this._isLayoutInited;
        this.layoutItems(this.items, isInstant);
        this._isLayoutInited = true;
      };
      proto._init = proto.layout;
      proto._resetLayout = function() {
        this.getSize();
      };
      proto.getSize = function() {
        this.size = getSize2(this.element);
      };
      proto._getMeasurement = function(measurement, size2) {
        var option = this.options[measurement];
        var elem;
        if (!option) {
          this[measurement] = 0;
        } else {
          if (typeof option == "string") {
            elem = this.element.querySelector(option);
          } else if (option instanceof HTMLElement) {
            elem = option;
          }
          this[measurement] = elem ? getSize2(elem)[size2] : option;
        }
      };
      proto.layoutItems = function(items, isInstant) {
        items = this._getItemsForLayout(items);
        this._layoutItems(items, isInstant);
        this._postLayout();
      };
      proto._getItemsForLayout = function(items) {
        return items.filter(function(item2) {
          return !item2.isIgnored;
        });
      };
      proto._layoutItems = function(items, isInstant) {
        this._emitCompleteOnItems("layout", items);
        if (!items || !items.length) {
          return;
        }
        var queue2 = [];
        items.forEach(function(item2) {
          var position = this._getItemLayoutPosition(item2);
          position.item = item2;
          position.isInstant = isInstant || item2.isLayoutInstant;
          queue2.push(position);
        }, this);
        this._processLayoutQueue(queue2);
      };
      proto._getItemLayoutPosition = function() {
        return {
          x: 0,
          y: 0
        };
      };
      proto._processLayoutQueue = function(queue2) {
        this.updateStagger();
        queue2.forEach(function(obj, i) {
          this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
        }, this);
      };
      proto.updateStagger = function() {
        var stagger = this.options.stagger;
        if (stagger === null || stagger === void 0) {
          this.stagger = 0;
          return;
        }
        this.stagger = getMilliseconds(stagger);
        return this.stagger;
      };
      proto._positionItem = function(item2, x2, y, isInstant, i) {
        if (isInstant) {
          item2.goTo(x2, y);
        } else {
          item2.stagger(i * this.stagger);
          item2.moveTo(x2, y);
        }
      };
      proto._postLayout = function() {
        this.resizeContainer();
      };
      proto.resizeContainer = function() {
        var isResizingContainer = this._getOption("resizeContainer");
        if (!isResizingContainer) {
          return;
        }
        var size2 = this._getContainerSize();
        if (size2) {
          this._setContainerMeasure(size2.width, true);
          this._setContainerMeasure(size2.height, false);
        }
      };
      proto._getContainerSize = noop;
      proto._setContainerMeasure = function(measure, isWidth) {
        if (measure === void 0) {
          return;
        }
        var elemSize = this.size;
        if (elemSize.isBorderBox) {
          measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
        }
        measure = Math.max(measure, 0);
        this.element.style[isWidth ? "width" : "height"] = measure + "px";
      };
      proto._emitCompleteOnItems = function(eventName, items) {
        var _this = this;
        function onComplete() {
          _this.dispatchEvent(eventName + "Complete", null, [items]);
        }
        var count = items.length;
        if (!items || !count) {
          onComplete();
          return;
        }
        var doneCount = 0;
        function tick() {
          doneCount++;
          if (doneCount == count) {
            onComplete();
          }
        }
        items.forEach(function(item2) {
          item2.once(eventName, tick);
        });
      };
      proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [event].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery) {
          this.$element = this.$element || jQuery(this.element);
          if (event) {
            var $event = jQuery.Event(event);
            $event.type = type;
            this.$element.trigger($event, args);
          } else {
            this.$element.trigger(type, args);
          }
        }
      };
      proto.ignore = function(elem) {
        var item2 = this.getItem(elem);
        if (item2) {
          item2.isIgnored = true;
        }
      };
      proto.unignore = function(elem) {
        var item2 = this.getItem(elem);
        if (item2) {
          delete item2.isIgnored;
        }
      };
      proto.stamp = function(elems) {
        elems = this._find(elems);
        if (!elems) {
          return;
        }
        this.stamps = this.stamps.concat(elems);
        elems.forEach(this.ignore, this);
      };
      proto.unstamp = function(elems) {
        elems = this._find(elems);
        if (!elems) {
          return;
        }
        elems.forEach(function(elem) {
          utils2.removeFrom(this.stamps, elem);
          this.unignore(elem);
        }, this);
      };
      proto._find = function(elems) {
        if (!elems) {
          return;
        }
        if (typeof elems == "string") {
          elems = this.element.querySelectorAll(elems);
        }
        elems = utils2.makeArray(elems);
        return elems;
      };
      proto._manageStamps = function() {
        if (!this.stamps || !this.stamps.length) {
          return;
        }
        this._getBoundingRect();
        this.stamps.forEach(this._manageStamp, this);
      };
      proto._getBoundingRect = function() {
        var boundingRect = this.element.getBoundingClientRect();
        var size2 = this.size;
        this._boundingRect = {
          left: boundingRect.left + size2.paddingLeft + size2.borderLeftWidth,
          top: boundingRect.top + size2.paddingTop + size2.borderTopWidth,
          right: boundingRect.right - (size2.paddingRight + size2.borderRightWidth),
          bottom: boundingRect.bottom - (size2.paddingBottom + size2.borderBottomWidth)
        };
      };
      proto._manageStamp = noop;
      proto._getElementOffset = function(elem) {
        var boundingRect = elem.getBoundingClientRect();
        var thisRect = this._boundingRect;
        var size2 = getSize2(elem);
        var offset = {
          left: boundingRect.left - thisRect.left - size2.marginLeft,
          top: boundingRect.top - thisRect.top - size2.marginTop,
          right: thisRect.right - boundingRect.right - size2.marginRight,
          bottom: thisRect.bottom - boundingRect.bottom - size2.marginBottom
        };
        return offset;
      };
      proto.handleEvent = utils2.handleEvent;
      proto.bindResize = function() {
        window2.addEventListener("resize", this);
        this.isResizeBound = true;
      };
      proto.unbindResize = function() {
        window2.removeEventListener("resize", this);
        this.isResizeBound = false;
      };
      proto.onresize = function() {
        this.resize();
      };
      utils2.debounceMethod(Outlayer, "onresize", 100);
      proto.resize = function() {
        if (!this.isResizeBound || !this.needsResizeLayout()) {
          return;
        }
        this.layout();
      };
      proto.needsResizeLayout = function() {
        var size2 = getSize2(this.element);
        var hasSizes = this.size && size2;
        return hasSizes && size2.innerWidth !== this.size.innerWidth;
      };
      proto.addItems = function(elems) {
        var items = this._itemize(elems);
        if (items.length) {
          this.items = this.items.concat(items);
        }
        return items;
      };
      proto.appended = function(elems) {
        var items = this.addItems(elems);
        if (!items.length) {
          return;
        }
        this.layoutItems(items, true);
        this.reveal(items);
      };
      proto.prepended = function(elems) {
        var items = this._itemize(elems);
        if (!items.length) {
          return;
        }
        var previousItems = this.items.slice(0);
        this.items = items.concat(previousItems);
        this._resetLayout();
        this._manageStamps();
        this.layoutItems(items, true);
        this.reveal(items);
        this.layoutItems(previousItems);
      };
      proto.reveal = function(items) {
        this._emitCompleteOnItems("reveal", items);
        if (!items || !items.length) {
          return;
        }
        var stagger = this.updateStagger();
        items.forEach(function(item2, i) {
          item2.stagger(i * stagger);
          item2.reveal();
        });
      };
      proto.hide = function(items) {
        this._emitCompleteOnItems("hide", items);
        if (!items || !items.length) {
          return;
        }
        var stagger = this.updateStagger();
        items.forEach(function(item2, i) {
          item2.stagger(i * stagger);
          item2.hide();
        });
      };
      proto.revealItemElements = function(elems) {
        var items = this.getItems(elems);
        this.reveal(items);
      };
      proto.hideItemElements = function(elems) {
        var items = this.getItems(elems);
        this.hide(items);
      };
      proto.getItem = function(elem) {
        for (var i = 0; i < this.items.length; i++) {
          var item2 = this.items[i];
          if (item2.element == elem) {
            return item2;
          }
        }
      };
      proto.getItems = function(elems) {
        elems = utils2.makeArray(elems);
        var items = [];
        elems.forEach(function(elem) {
          var item2 = this.getItem(elem);
          if (item2) {
            items.push(item2);
          }
        }, this);
        return items;
      };
      proto.remove = function(elems) {
        var removeItems = this.getItems(elems);
        this._emitCompleteOnItems("remove", removeItems);
        if (!removeItems || !removeItems.length) {
          return;
        }
        removeItems.forEach(function(item2) {
          item2.remove();
          utils2.removeFrom(this.items, item2);
        }, this);
      };
      proto.destroy = function() {
        var style = this.element.style;
        style.height = "";
        style.position = "";
        style.width = "";
        this.items.forEach(function(item2) {
          item2.destroy();
        });
        this.unbindResize();
        var id = this.element.outlayerGUID;
        delete instances[id];
        delete this.element.outlayerGUID;
        if (jQuery) {
          jQuery.removeData(this.element, this.constructor.namespace);
        }
      };
      Outlayer.data = function(elem) {
        elem = utils2.getQueryElement(elem);
        var id = elem && elem.outlayerGUID;
        return id && instances[id];
      };
      Outlayer.create = function(namespace, options) {
        var Layout = subclass(Outlayer);
        Layout.defaults = utils2.extend({}, Outlayer.defaults);
        utils2.extend(Layout.defaults, options);
        Layout.compatOptions = utils2.extend({}, Outlayer.compatOptions);
        Layout.namespace = namespace;
        Layout.data = Outlayer.data;
        Layout.Item = subclass(Item);
        utils2.htmlInit(Layout, namespace);
        if (jQuery && jQuery.bridget) {
          jQuery.bridget(namespace, Layout);
        }
        return Layout;
      };
      function subclass(Parent) {
        function SubClass() {
          Parent.apply(this, arguments);
        }
        SubClass.prototype = Object.create(Parent.prototype);
        SubClass.prototype.constructor = SubClass;
        return SubClass;
      }
      var msUnits = {
        ms: 1,
        s: 1e3
      };
      function getMilliseconds(time) {
        if (typeof time == "number") {
          return time;
        }
        var matches2 = time.match(/(^\d*\.?\d*)(\w*)/);
        var num = matches2 && matches2[1];
        var unit = matches2 && matches2[2];
        if (!num.length) {
          return 0;
        }
        num = parseFloat(num);
        var mult = msUnits[unit] || 1;
        return num * mult;
      }
      Outlayer.Item = Item;
      return Outlayer;
    });
  })(outlayer);
  return outlayer.exports;
}
var item = { exports: {} };
var hasRequiredItem;
function requireItem() {
  if (hasRequiredItem)
    return item.exports;
  hasRequiredItem = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireOutlayer()
        );
      } else {
        window2.Isotope = window2.Isotope || {};
        window2.Isotope.Item = factory(
          window2.Outlayer
        );
      }
    })(window, function factory(Outlayer) {
      function Item() {
        Outlayer.Item.apply(this, arguments);
      }
      var proto = Item.prototype = Object.create(Outlayer.Item.prototype);
      var _create = proto._create;
      proto._create = function() {
        this.id = this.layout.itemGUID++;
        _create.call(this);
        this.sortData = {};
      };
      proto.updateSortData = function() {
        if (this.isIgnored) {
          return;
        }
        this.sortData.id = this.id;
        this.sortData["original-order"] = this.id;
        this.sortData.random = Math.random();
        var getSortData = this.layout.options.getSortData;
        var sorters = this.layout._sorters;
        for (var key in getSortData) {
          var sorter = sorters[key];
          this.sortData[key] = sorter(this.element, this);
        }
      };
      var _destroy = proto.destroy;
      proto.destroy = function() {
        _destroy.apply(this, arguments);
        this.css({
          display: ""
        });
      };
      return Item;
    });
  })(item);
  return item.exports;
}
var layoutMode = { exports: {} };
var hasRequiredLayoutMode;
function requireLayoutMode() {
  if (hasRequiredLayoutMode)
    return layoutMode.exports;
  hasRequiredLayoutMode = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireGetSize(),
          requireOutlayer()
        );
      } else {
        window2.Isotope = window2.Isotope || {};
        window2.Isotope.LayoutMode = factory(
          window2.getSize,
          window2.Outlayer
        );
      }
    })(window, function factory(getSize2, Outlayer) {
      function LayoutMode(isotope2) {
        this.isotope = isotope2;
        if (isotope2) {
          this.options = isotope2.options[this.namespace];
          this.element = isotope2.element;
          this.items = isotope2.filteredItems;
          this.size = isotope2.size;
        }
      }
      var proto = LayoutMode.prototype;
      var facadeMethods = [
        "_resetLayout",
        "_getItemLayoutPosition",
        "_manageStamp",
        "_getContainerSize",
        "_getElementOffset",
        "needsResizeLayout",
        "_getOption"
      ];
      facadeMethods.forEach(function(methodName) {
        proto[methodName] = function() {
          return Outlayer.prototype[methodName].apply(this.isotope, arguments);
        };
      });
      proto.needsVerticalResizeLayout = function() {
        var size2 = getSize2(this.isotope.element);
        var hasSizes = this.isotope.size && size2;
        return hasSizes && size2.innerHeight != this.isotope.size.innerHeight;
      };
      proto._getMeasurement = function() {
        this.isotope._getMeasurement.apply(this, arguments);
      };
      proto.getColumnWidth = function() {
        this.getSegmentSize("column", "Width");
      };
      proto.getRowHeight = function() {
        this.getSegmentSize("row", "Height");
      };
      proto.getSegmentSize = function(segment, size2) {
        var segmentName = segment + size2;
        var outerSize = "outer" + size2;
        this._getMeasurement(segmentName, outerSize);
        if (this[segmentName]) {
          return;
        }
        var firstItemSize = this.getFirstItemSize();
        this[segmentName] = firstItemSize && firstItemSize[outerSize] || // or size of container
        this.isotope.size["inner" + size2];
      };
      proto.getFirstItemSize = function() {
        var firstItem = this.isotope.filteredItems[0];
        return firstItem && firstItem.element && getSize2(firstItem.element);
      };
      proto.layout = function() {
        this.isotope.layout.apply(this.isotope, arguments);
      };
      proto.getSize = function() {
        this.isotope.getSize();
        this.size = this.isotope.size;
      };
      LayoutMode.modes = {};
      LayoutMode.create = function(namespace, options) {
        function Mode() {
          LayoutMode.apply(this, arguments);
        }
        Mode.prototype = Object.create(proto);
        Mode.prototype.constructor = Mode;
        if (options) {
          Mode.options = options;
        }
        Mode.prototype.namespace = namespace;
        LayoutMode.modes[namespace] = Mode;
        return Mode;
      };
      return LayoutMode;
    });
  })(layoutMode);
  return layoutMode.exports;
}
var masonry$1 = { exports: {} };
var masonry = { exports: {} };
/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */
var hasRequiredMasonry$1;
function requireMasonry$1() {
  if (hasRequiredMasonry$1)
    return masonry.exports;
  hasRequiredMasonry$1 = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireOutlayer(),
          requireGetSize()
        );
      } else {
        window2.Masonry = factory(
          window2.Outlayer,
          window2.getSize
        );
      }
    })(window, function factory(Outlayer, getSize2) {
      var Masonry = Outlayer.create("masonry");
      Masonry.compatOptions.fitWidth = "isFitWidth";
      var proto = Masonry.prototype;
      proto._resetLayout = function() {
        this.getSize();
        this._getMeasurement("columnWidth", "outerWidth");
        this._getMeasurement("gutter", "outerWidth");
        this.measureColumns();
        this.colYs = [];
        for (var i = 0; i < this.cols; i++) {
          this.colYs.push(0);
        }
        this.maxY = 0;
        this.horizontalColIndex = 0;
      };
      proto.measureColumns = function() {
        this.getContainerWidth();
        if (!this.columnWidth) {
          var firstItem = this.items[0];
          var firstItemElem = firstItem && firstItem.element;
          this.columnWidth = firstItemElem && getSize2(firstItemElem).outerWidth || // if first elem has no width, default to size of container
          this.containerWidth;
        }
        var columnWidth = this.columnWidth += this.gutter;
        var containerWidth = this.containerWidth + this.gutter;
        var cols = containerWidth / columnWidth;
        var excess = columnWidth - containerWidth % columnWidth;
        var mathMethod = excess && excess < 1 ? "round" : "floor";
        cols = Math[mathMethod](cols);
        this.cols = Math.max(cols, 1);
      };
      proto.getContainerWidth = function() {
        var isFitWidth = this._getOption("fitWidth");
        var container = isFitWidth ? this.element.parentNode : this.element;
        var size2 = getSize2(container);
        this.containerWidth = size2 && size2.innerWidth;
      };
      proto._getItemLayoutPosition = function(item2) {
        item2.getSize();
        var remainder = item2.size.outerWidth % this.columnWidth;
        var mathMethod = remainder && remainder < 1 ? "round" : "ceil";
        var colSpan = Math[mathMethod](item2.size.outerWidth / this.columnWidth);
        colSpan = Math.min(colSpan, this.cols);
        var colPosMethod = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition";
        var colPosition = this[colPosMethod](colSpan, item2);
        var position = {
          x: this.columnWidth * colPosition.col,
          y: colPosition.y
        };
        var setHeight = colPosition.y + item2.size.outerHeight;
        var setMax = colSpan + colPosition.col;
        for (var i = colPosition.col; i < setMax; i++) {
          this.colYs[i] = setHeight;
        }
        return position;
      };
      proto._getTopColPosition = function(colSpan) {
        var colGroup = this._getTopColGroup(colSpan);
        var minimumY = Math.min.apply(Math, colGroup);
        return {
          col: colGroup.indexOf(minimumY),
          y: minimumY
        };
      };
      proto._getTopColGroup = function(colSpan) {
        if (colSpan < 2) {
          return this.colYs;
        }
        var colGroup = [];
        var groupCount = this.cols + 1 - colSpan;
        for (var i = 0; i < groupCount; i++) {
          colGroup[i] = this._getColGroupY(i, colSpan);
        }
        return colGroup;
      };
      proto._getColGroupY = function(col, colSpan) {
        if (colSpan < 2) {
          return this.colYs[col];
        }
        var groupColYs = this.colYs.slice(col, col + colSpan);
        return Math.max.apply(Math, groupColYs);
      };
      proto._getHorizontalColPosition = function(colSpan, item2) {
        var col = this.horizontalColIndex % this.cols;
        var isOver = colSpan > 1 && col + colSpan > this.cols;
        col = isOver ? 0 : col;
        var hasSize = item2.size.outerWidth && item2.size.outerHeight;
        this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
        return {
          col,
          y: this._getColGroupY(col, colSpan)
        };
      };
      proto._manageStamp = function(stamp) {
        var stampSize = getSize2(stamp);
        var offset = this._getElementOffset(stamp);
        var isOriginLeft = this._getOption("originLeft");
        var firstX = isOriginLeft ? offset.left : offset.right;
        var lastX = firstX + stampSize.outerWidth;
        var firstCol = Math.floor(firstX / this.columnWidth);
        firstCol = Math.max(0, firstCol);
        var lastCol = Math.floor(lastX / this.columnWidth);
        lastCol -= lastX % this.columnWidth ? 0 : 1;
        lastCol = Math.min(this.cols - 1, lastCol);
        var isOriginTop = this._getOption("originTop");
        var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
        for (var i = firstCol; i <= lastCol; i++) {
          this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
        }
      };
      proto._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var size2 = {
          height: this.maxY
        };
        if (this._getOption("fitWidth")) {
          size2.width = this._getContainerFitWidth();
        }
        return size2;
      };
      proto._getContainerFitWidth = function() {
        var unusedCols = 0;
        var i = this.cols;
        while (--i) {
          if (this.colYs[i] !== 0) {
            break;
          }
          unusedCols++;
        }
        return (this.cols - unusedCols) * this.columnWidth - this.gutter;
      };
      proto.needsResizeLayout = function() {
        var previousWidth = this.containerWidth;
        this.getContainerWidth();
        return previousWidth != this.containerWidth;
      };
      return Masonry;
    });
  })(masonry);
  return masonry.exports;
}
/*!
 * Masonry layout mode
 * sub-classes Masonry
 * https://masonry.desandro.com
 */
var hasRequiredMasonry;
function requireMasonry() {
  if (hasRequiredMasonry)
    return masonry$1.exports;
  hasRequiredMasonry = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireLayoutMode(),
          requireMasonry$1()
        );
      } else {
        factory(
          window2.Isotope.LayoutMode,
          window2.Masonry
        );
      }
    })(window, function factory(LayoutMode, Masonry) {
      var MasonryMode = LayoutMode.create("masonry");
      var proto = MasonryMode.prototype;
      var keepModeMethods = {
        _getElementOffset: true,
        layout: true,
        _getMeasurement: true
      };
      for (var method in Masonry.prototype) {
        if (!keepModeMethods[method]) {
          proto[method] = Masonry.prototype[method];
        }
      }
      var measureColumns = proto.measureColumns;
      proto.measureColumns = function() {
        this.items = this.isotope.filteredItems;
        measureColumns.call(this);
      };
      var _getOption = proto._getOption;
      proto._getOption = function(option) {
        if (option == "fitWidth") {
          return this.options.isFitWidth !== void 0 ? this.options.isFitWidth : this.options.fitWidth;
        }
        return _getOption.apply(this.isotope, arguments);
      };
      return MasonryMode;
    });
  })(masonry$1);
  return masonry$1.exports;
}
var fitRows = { exports: {} };
var hasRequiredFitRows;
function requireFitRows() {
  if (hasRequiredFitRows)
    return fitRows.exports;
  hasRequiredFitRows = 1;
  (function(module, exports) {
    (function(window2, factory) {
      {
        module.exports = factory(
          requireLayoutMode()
        );
      }
    })(window, function factory(LayoutMode) {
      var FitRows = LayoutMode.create("fitRows");
      var proto = FitRows.prototype;
      proto._resetLayout = function() {
        this.x = 0;
        this.y = 0;
        this.maxY = 0;
        this._getMeasurement("gutter", "outerWidth");
      };
      proto._getItemLayoutPosition = function(item2) {
        item2.getSize();
        var itemWidth = item2.size.outerWidth + this.gutter;
        var containerWidth = this.isotope.size.innerWidth + this.gutter;
        if (this.x !== 0 && itemWidth + this.x > containerWidth) {
          this.x = 0;
          this.y = this.maxY;
        }
        var position = {
          x: this.x,
          y: this.y
        };
        this.maxY = Math.max(this.maxY, this.y + item2.size.outerHeight);
        this.x += itemWidth;
        return position;
      };
      proto._getContainerSize = function() {
        return { height: this.maxY };
      };
      return FitRows;
    });
  })(fitRows);
  return fitRows.exports;
}
var vertical = { exports: {} };
var hasRequiredVertical;
function requireVertical() {
  if (hasRequiredVertical)
    return vertical.exports;
  hasRequiredVertical = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireLayoutMode()
        );
      } else {
        factory(
          window2.Isotope.LayoutMode
        );
      }
    })(window, function factory(LayoutMode) {
      var Vertical = LayoutMode.create("vertical", {
        horizontalAlignment: 0
      });
      var proto = Vertical.prototype;
      proto._resetLayout = function() {
        this.y = 0;
      };
      proto._getItemLayoutPosition = function(item2) {
        item2.getSize();
        var x2 = (this.isotope.size.innerWidth - item2.size.outerWidth) * this.options.horizontalAlignment;
        var y = this.y;
        this.y += item2.size.outerHeight;
        return { x: x2, y };
      };
      proto._getContainerSize = function() {
        return { height: this.y };
      };
      return Vertical;
    });
  })(vertical);
  return vertical.exports;
}
/*!
 * Isotope v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */
(function(module) {
  (function(window2, factory) {
    if (module.exports) {
      module.exports = factory(
        window2,
        requireOutlayer(),
        requireGetSize(),
        requireMatchesSelector(),
        requireUtils(),
        requireItem(),
        requireLayoutMode(),
        // include default layout modes
        requireMasonry(),
        requireFitRows(),
        requireVertical()
      );
    } else {
      window2.Isotope = factory(
        window2,
        window2.Outlayer,
        window2.getSize,
        window2.matchesSelector,
        window2.fizzyUIUtils,
        window2.Isotope.Item,
        window2.Isotope.LayoutMode
      );
    }
  })(window, function factory(window2, Outlayer, getSize2, matchesSelector2, utils2, Item, LayoutMode) {
    var jQuery = window2.jQuery;
    var trim = String.prototype.trim ? function(str) {
      return str.trim();
    } : function(str) {
      return str.replace(/^\s+|\s+$/g, "");
    };
    var Isotope2 = Outlayer.create("isotope", {
      layoutMode: "masonry",
      isJQueryFiltering: true,
      sortAscending: true
    });
    Isotope2.Item = Item;
    Isotope2.LayoutMode = LayoutMode;
    var proto = Isotope2.prototype;
    proto._create = function() {
      this.itemGUID = 0;
      this._sorters = {};
      this._getSorters();
      Outlayer.prototype._create.call(this);
      this.modes = {};
      this.filteredItems = this.items;
      this.sortHistory = ["original-order"];
      for (var name in LayoutMode.modes) {
        this._initLayoutMode(name);
      }
    };
    proto.reloadItems = function() {
      this.itemGUID = 0;
      Outlayer.prototype.reloadItems.call(this);
    };
    proto._itemize = function() {
      var items = Outlayer.prototype._itemize.apply(this, arguments);
      for (var i = 0; i < items.length; i++) {
        var item2 = items[i];
        item2.id = this.itemGUID++;
      }
      this._updateItemsSortData(items);
      return items;
    };
    proto._initLayoutMode = function(name) {
      var Mode = LayoutMode.modes[name];
      var initialOpts = this.options[name] || {};
      this.options[name] = Mode.options ? utils2.extend(Mode.options, initialOpts) : initialOpts;
      this.modes[name] = new Mode(this);
    };
    proto.layout = function() {
      if (!this._isLayoutInited && this._getOption("initLayout")) {
        this.arrange();
        return;
      }
      this._layout();
    };
    proto._layout = function() {
      var isInstant = this._getIsInstant();
      this._resetLayout();
      this._manageStamps();
      this.layoutItems(this.filteredItems, isInstant);
      this._isLayoutInited = true;
    };
    proto.arrange = function(opts) {
      this.option(opts);
      this._getIsInstant();
      var filtered = this._filter(this.items);
      this.filteredItems = filtered.matches;
      this._bindArrangeComplete();
      if (this._isInstant) {
        this._noTransition(this._hideReveal, [filtered]);
      } else {
        this._hideReveal(filtered);
      }
      this._sort();
      this._layout();
    };
    proto._init = proto.arrange;
    proto._hideReveal = function(filtered) {
      this.reveal(filtered.needReveal);
      this.hide(filtered.needHide);
    };
    proto._getIsInstant = function() {
      var isLayoutInstant = this._getOption("layoutInstant");
      var isInstant = isLayoutInstant !== void 0 ? isLayoutInstant : !this._isLayoutInited;
      this._isInstant = isInstant;
      return isInstant;
    };
    proto._bindArrangeComplete = function() {
      var isLayoutComplete, isHideComplete, isRevealComplete;
      var _this = this;
      function arrangeParallelCallback() {
        if (isLayoutComplete && isHideComplete && isRevealComplete) {
          _this.dispatchEvent("arrangeComplete", null, [_this.filteredItems]);
        }
      }
      this.once("layoutComplete", function() {
        isLayoutComplete = true;
        arrangeParallelCallback();
      });
      this.once("hideComplete", function() {
        isHideComplete = true;
        arrangeParallelCallback();
      });
      this.once("revealComplete", function() {
        isRevealComplete = true;
        arrangeParallelCallback();
      });
    };
    proto._filter = function(items) {
      var filter = this.options.filter;
      filter = filter || "*";
      var matches2 = [];
      var hiddenMatched = [];
      var visibleUnmatched = [];
      var test = this._getFilterTest(filter);
      for (var i = 0; i < items.length; i++) {
        var item2 = items[i];
        if (item2.isIgnored) {
          continue;
        }
        var isMatched = test(item2);
        if (isMatched) {
          matches2.push(item2);
        }
        if (isMatched && item2.isHidden) {
          hiddenMatched.push(item2);
        } else if (!isMatched && !item2.isHidden) {
          visibleUnmatched.push(item2);
        }
      }
      return {
        matches: matches2,
        needReveal: hiddenMatched,
        needHide: visibleUnmatched
      };
    };
    proto._getFilterTest = function(filter) {
      if (jQuery && this.options.isJQueryFiltering) {
        return function(item2) {
          return jQuery(item2.element).is(filter);
        };
      }
      if (typeof filter == "function") {
        return function(item2) {
          return filter(item2.element);
        };
      }
      return function(item2) {
        return matchesSelector2(item2.element, filter);
      };
    };
    proto.updateSortData = function(elems) {
      var items;
      if (elems) {
        elems = utils2.makeArray(elems);
        items = this.getItems(elems);
      } else {
        items = this.items;
      }
      this._getSorters();
      this._updateItemsSortData(items);
    };
    proto._getSorters = function() {
      var getSortData = this.options.getSortData;
      for (var key in getSortData) {
        var sorter = getSortData[key];
        this._sorters[key] = mungeSorter(sorter);
      }
    };
    proto._updateItemsSortData = function(items) {
      var len = items && items.length;
      for (var i = 0; len && i < len; i++) {
        var item2 = items[i];
        item2.updateSortData();
      }
    };
    var mungeSorter = function() {
      function mungeSorter2(sorter) {
        if (typeof sorter != "string") {
          return sorter;
        }
        var args = trim(sorter).split(" ");
        var query = args[0];
        var attrMatch = query.match(/^\[(.+)\]$/);
        var attr = attrMatch && attrMatch[1];
        var getValue = getValueGetter(attr, query);
        var parser = Isotope2.sortDataParsers[args[1]];
        sorter = parser ? function(elem) {
          return elem && parser(getValue(elem));
        } : (
          // otherwise just return value
          function(elem) {
            return elem && getValue(elem);
          }
        );
        return sorter;
      }
      function getValueGetter(attr, query) {
        if (attr) {
          return function getAttribute(elem) {
            return elem.getAttribute(attr);
          };
        }
        return function getChildText(elem) {
          var child = elem.querySelector(query);
          return child && child.textContent;
        };
      }
      return mungeSorter2;
    }();
    Isotope2.sortDataParsers = {
      "parseInt": function(val) {
        return parseInt(val, 10);
      },
      "parseFloat": function(val) {
        return parseFloat(val);
      }
    };
    proto._sort = function() {
      if (!this.options.sortBy) {
        return;
      }
      var sortBys = utils2.makeArray(this.options.sortBy);
      if (!this._getIsSameSortBy(sortBys)) {
        this.sortHistory = sortBys.concat(this.sortHistory);
      }
      var itemSorter = getItemSorter(this.sortHistory, this.options.sortAscending);
      this.filteredItems.sort(itemSorter);
    };
    proto._getIsSameSortBy = function(sortBys) {
      for (var i = 0; i < sortBys.length; i++) {
        if (sortBys[i] != this.sortHistory[i]) {
          return false;
        }
      }
      return true;
    };
    function getItemSorter(sortBys, sortAsc) {
      return function sorter(itemA, itemB) {
        for (var i = 0; i < sortBys.length; i++) {
          var sortBy = sortBys[i];
          var a = itemA.sortData[sortBy];
          var b = itemB.sortData[sortBy];
          if (a > b || a < b) {
            var isAscending = sortAsc[sortBy] !== void 0 ? sortAsc[sortBy] : sortAsc;
            var direction = isAscending ? 1 : -1;
            return (a > b ? 1 : -1) * direction;
          }
        }
        return 0;
      };
    }
    proto._mode = function() {
      var layoutMode2 = this.options.layoutMode;
      var mode = this.modes[layoutMode2];
      if (!mode) {
        throw new Error("No layout mode: " + layoutMode2);
      }
      mode.options = this.options[layoutMode2];
      return mode;
    };
    proto._resetLayout = function() {
      Outlayer.prototype._resetLayout.call(this);
      this._mode()._resetLayout();
    };
    proto._getItemLayoutPosition = function(item2) {
      return this._mode()._getItemLayoutPosition(item2);
    };
    proto._manageStamp = function(stamp) {
      this._mode()._manageStamp(stamp);
    };
    proto._getContainerSize = function() {
      return this._mode()._getContainerSize();
    };
    proto.needsResizeLayout = function() {
      return this._mode().needsResizeLayout();
    };
    proto.appended = function(elems) {
      var items = this.addItems(elems);
      if (!items.length) {
        return;
      }
      var filteredItems = this._filterRevealAdded(items);
      this.filteredItems = this.filteredItems.concat(filteredItems);
    };
    proto.prepended = function(elems) {
      var items = this._itemize(elems);
      if (!items.length) {
        return;
      }
      this._resetLayout();
      this._manageStamps();
      var filteredItems = this._filterRevealAdded(items);
      this.layoutItems(this.filteredItems);
      this.filteredItems = filteredItems.concat(this.filteredItems);
      this.items = items.concat(this.items);
    };
    proto._filterRevealAdded = function(items) {
      var filtered = this._filter(items);
      this.hide(filtered.needHide);
      this.reveal(filtered.matches);
      this.layoutItems(filtered.matches, true);
      return filtered.matches;
    };
    proto.insert = function(elems) {
      var items = this.addItems(elems);
      if (!items.length) {
        return;
      }
      var i, item2;
      var len = items.length;
      for (i = 0; i < len; i++) {
        item2 = items[i];
        this.element.appendChild(item2.element);
      }
      var filteredInsertItems = this._filter(items).matches;
      for (i = 0; i < len; i++) {
        items[i].isLayoutInstant = true;
      }
      this.arrange();
      for (i = 0; i < len; i++) {
        delete items[i].isLayoutInstant;
      }
      this.reveal(filteredInsertItems);
    };
    var _remove = proto.remove;
    proto.remove = function(elems) {
      elems = utils2.makeArray(elems);
      var removeItems = this.getItems(elems);
      _remove.call(this, elems);
      var len = removeItems && removeItems.length;
      for (var i = 0; len && i < len; i++) {
        var item2 = removeItems[i];
        utils2.removeFrom(this.filteredItems, item2);
      }
    };
    proto.shuffle = function() {
      for (var i = 0; i < this.items.length; i++) {
        var item2 = this.items[i];
        item2.sortData.random = Math.random();
      }
      this.options.sortBy = "random";
      this._sort();
      this._layout();
    };
    proto._noTransition = function(fn, args) {
      var transitionDuration = this.options.transitionDuration;
      this.options.transitionDuration = 0;
      var returnValue = fn.apply(this, args);
      this.options.transitionDuration = transitionDuration;
      return returnValue;
    };
    proto.getFilteredItemElements = function() {
      return this.filteredItems.map(function(item2) {
        return item2.element;
      });
    };
    return Isotope2;
  });
})(isotope);
var isotopeExports = isotope.exports;
const Isotope = /* @__PURE__ */ getDefaultExportFromCjs(isotopeExports);
var imagesloaded = { exports: {} };
var evEmitter = { exports: {} };
var hasRequiredEvEmitter;
function requireEvEmitter() {
  if (hasRequiredEvEmitter)
    return evEmitter.exports;
  hasRequiredEvEmitter = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        global2.EvEmitter = factory();
      }
    })(typeof window != "undefined" ? window : commonjsGlobal, function() {
      function EvEmitter() {
      }
      let proto = EvEmitter.prototype;
      proto.on = function(eventName, listener) {
        if (!eventName || !listener)
          return this;
        let events = this._events = this._events || {};
        let listeners = events[eventName] = events[eventName] || [];
        if (!listeners.includes(listener)) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function(eventName, listener) {
        if (!eventName || !listener)
          return this;
        this.on(eventName, listener);
        let onceEvents = this._onceEvents = this._onceEvents || {};
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length)
          return this;
        let index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length)
          return this;
        listeners = listeners.slice(0);
        args = args || [];
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners) {
          let isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            this.off(eventName, listener);
            delete onceListeners[listener];
          }
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
      };
      return EvEmitter;
    });
  })(evEmitter);
  return evEmitter.exports;
}
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
(function(module) {
  (function(window2, factory) {
    if (module.exports) {
      module.exports = factory(window2, requireEvEmitter());
    } else {
      window2.imagesLoaded = factory(window2, window2.EvEmitter);
    }
  })(
    typeof window !== "undefined" ? window : commonjsGlobal,
    function factory(window2, EvEmitter) {
      let $ = window2.jQuery;
      let console2 = window2.console;
      function makeArray(obj) {
        if (Array.isArray(obj))
          return obj;
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike)
          return [...obj];
        return [obj];
      }
      function ImagesLoaded(elem, options, onAlways) {
        if (!(this instanceof ImagesLoaded)) {
          return new ImagesLoaded(elem, options, onAlways);
        }
        let queryElem = elem;
        if (typeof elem == "string") {
          queryElem = document.querySelectorAll(elem);
        }
        if (!queryElem) {
          console2.error(`Bad element for imagesLoaded ${queryElem || elem}`);
          return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        if (typeof options == "function") {
          onAlways = options;
        } else {
          Object.assign(this.options, options);
        }
        if (onAlways)
          this.on("always", onAlways);
        this.getImages();
        if ($)
          this.jqDeferred = new $.Deferred();
        setTimeout(this.check.bind(this));
      }
      ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
      ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        this.elements.forEach(this.addElementImages, this);
      };
      const elementNodeTypes = [1, 9, 11];
      ImagesLoaded.prototype.addElementImages = function(elem) {
        if (elem.nodeName === "IMG") {
          this.addImage(elem);
        }
        if (this.options.background === true) {
          this.addElementBackgroundImages(elem);
        }
        let { nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType))
          return;
        let childImgs = elem.querySelectorAll("img");
        for (let img of childImgs) {
          this.addImage(img);
        }
        if (typeof this.options.background == "string") {
          let children = elem.querySelectorAll(this.options.background);
          for (let child of children) {
            this.addElementBackgroundImages(child);
          }
        }
      };
      const reURL = /url\((['"])?(.*?)\1\)/gi;
      ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        if (!style)
          return;
        let matches2 = reURL.exec(style.backgroundImage);
        while (matches2 !== null) {
          let url = matches2 && matches2[2];
          if (url) {
            this.addBackground(url, elem);
          }
          matches2 = reURL.exec(style.backgroundImage);
        }
      };
      ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
      };
      ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
      };
      ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        if (!this.images.length) {
          this.complete();
          return;
        }
        let onProgress = (image, elem, message) => {
          setTimeout(() => {
            this.progress(image, elem, message);
          });
        };
        this.images.forEach(function(loadingImage) {
          loadingImage.once("progress", onProgress);
          loadingImage.check();
        });
      };
      ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        this.emitEvent("progress", [this, image, elem]);
        if (this.jqDeferred && this.jqDeferred.notify) {
          this.jqDeferred.notify(this, image);
        }
        if (this.progressedCount === this.images.length) {
          this.complete();
        }
        if (this.options.debug && console2) {
          console2.log(`progress: ${message}`, image, elem);
        }
      };
      ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [this]);
        this.emitEvent("always", [this]);
        if (this.jqDeferred) {
          let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[jqMethod](this);
        }
      };
      function LoadingImage(img) {
        this.img = img;
      }
      LoadingImage.prototype = Object.create(EvEmitter.prototype);
      LoadingImage.prototype.check = function() {
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
          this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
          return;
        }
        this.proxyImage = new Image();
        if (this.img.crossOrigin) {
          this.proxyImage.crossOrigin = this.img.crossOrigin;
        }
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
      };
      LoadingImage.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth;
      };
      LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode } = this.img;
        let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
        this.emitEvent("progress", [this, elem, message]);
      };
      LoadingImage.prototype.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      LoadingImage.prototype.onload = function() {
        this.confirm(true, "onload");
        this.unbindEvents();
      };
      LoadingImage.prototype.onerror = function() {
        this.confirm(false, "onerror");
        this.unbindEvents();
      };
      LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
      };
      function Background(url, element2) {
        this.url = url;
        this.element = element2;
        this.img = new Image();
      }
      Background.prototype = Object.create(LoadingImage.prototype);
      Background.prototype.check = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
          this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
          this.unbindEvents();
        }
      };
      Background.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
      };
      Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [this, this.element, message]);
      };
      ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window2.jQuery;
        if (!jQuery)
          return;
        $ = jQuery;
        $.fn.imagesLoaded = function(options, onAlways) {
          let instance = new ImagesLoaded(this, options, onAlways);
          return instance.jqDeferred.promise($(this));
        };
      };
      ImagesLoaded.makeJQueryPlugin();
      return ImagesLoaded;
    }
  );
})(imagesloaded);
var imagesloadedExports = imagesloaded.exports;
const imagesLoaded = /* @__PURE__ */ getDefaultExportFromCjs(imagesloadedExports);
class Filter {
  /**
   * Constructs the Filter class, binding event handlers for filter changes.
   * @param {HTMLElement} filterContainer - The container element that includes the filter controls.
   * @param {HTMLElement} container - The container element that holds the items to be filtered.
   */
  constructor(filterContainer, container, resultCountContainerClass = "filter-count") {
    this.filterContainer = filterContainer;
    this.container = container;
    this.filters = {};
    this.filterCountElement = null;
    this.resultCountContainerClass = "filter-count";
    this.layout = () => {
      imagesLoaded(this.container, () => {
        var _a;
        (_a = this.isotopeInstance) == null ? void 0 : _a.layout();
      });
    };
    this.handleFilterChange = (event) => {
      const target = event.target;
      const filterGroup = target.name;
      const filterValue = target.value;
      if (target.checked) {
        if (!this.filters[filterGroup]) {
          this.filters[filterGroup] = [];
        }
        this.filters[filterGroup].push(filterValue);
        this.updateURL();
      } else {
        this.filters[filterGroup] = this.filters[filterGroup].filter(
          (value) => value !== filterValue
        );
        this.updateURL();
        if (this.filters[filterGroup].length === 0) {
          delete this.filters[filterGroup];
        }
      }
      this.applyFilters();
      this.onFilterChangeCallback();
    };
    this.applyFilters = () => {
      var _a;
      const filterString = this.buildFilterString();
      (_a = this.isotopeInstance) == null ? void 0 : _a.arrange({ filter: filterString });
    };
    this.buildFilterString = () => {
      const filters = Object.values(this.filters).map((filterGroup) => {
        return filterGroup.map((value) => `.${value}`).join("");
      }).join("");
      return filters;
    };
    this.updateURL = () => {
      const url = new URL(window.location.href);
      const queryParams = new URLSearchParams(url.search);
      const filterKeys = Array.from(queryParams.keys()).filter(
        (key) => this.isFilterParameter(key)
      );
      if (Object.keys(this.filters).length === 0) {
        filterKeys.forEach((key) => queryParams.delete(key));
      } else {
        Object.keys(this.filters).forEach((key) => {
          if (this.filters[key].length > 0) {
            queryParams.set(key, this.filters[key].join(","));
          } else {
            if (filterKeys.includes(key)) {
              queryParams.delete(key);
            }
          }
        });
      }
      const newUrl = `${url.pathname}?${queryParams}`;
      window.history.replaceState({ path: newUrl }, "", newUrl);
    };
    this.updateCheckboxStates = () => {
      var _a, _b;
      const filterValueVisibility = {};
      const allCheckboxes = this.filterContainer.querySelectorAll(
        "input[type=checkbox]"
      );
      allCheckboxes.forEach((checkbox) => {
        filterValueVisibility[checkbox.value] = false;
      });
      (_a = this.isotopeInstance) == null ? void 0 : _a.filteredItems.forEach((item2) => {
        item2.element.classList.forEach((cls) => {
          if (Object.hasOwnProperty.call(filterValueVisibility, cls)) {
            filterValueVisibility[cls] = true;
          }
        });
      });
      for (const [value, isVisible] of Object.entries(filterValueVisibility)) {
        const checkbox = this.filterContainer.querySelector(
          `input[type="checkbox"][value="${value}"]`
        );
        if (checkbox) {
          checkbox.disabled = !isVisible;
          (_b = checkbox.parentElement) == null ? void 0 : _b.classList.toggle("grayed-out", !isVisible);
        }
      }
    };
    this.updateFilterCount = () => {
      const filterCountElements = document.querySelectorAll(
        `.${this.resultCountContainerClass}`
      );
      if (this.isotopeInstance) {
        const count = this.isotopeInstance.filteredItems.length;
        filterCountElements.forEach((element2) => {
          element2.textContent = count.toString();
        });
      }
    };
    this.resultCountContainerClass = resultCountContainerClass;
    this.bindEvents();
  }
  /**
   * Initializes the Isotope layout and parses the URL to apply any filters on page load.
   */
  init() {
    var _a;
    (_a = this.isotopeInstance) == null ? void 0 : _a.on("arrangeComplete", () => {
      this.updateFilterCount();
      this.updateCheckboxStates();
    });
    this.updateFilterCount();
  }
  /**
   * Resets all filters to their default state and updates the Isotope layout accordingly.
   */
  resetFilters() {
    var _a;
    this.filters = {};
    (_a = this.isotopeInstance) == null ? void 0 : _a.arrange({ filter: "*" });
    this.clearFilterInputs();
    this.updateURL();
  }
  // TODO: Refactor: Model this return type.
  getActiveFilters() {
    return this.filters;
  }
  uncheckFilterCheckbox(value) {
    const checkbox = this.filterContainer.querySelector(
      `input[type="checkbox"][value="${value}"]`
    );
    if (checkbox) {
      checkbox.checked = false;
    }
  }
  /**
   * Binds change event listeners to the checkboxes within the filterContainer.
   */
  bindEvents() {
    const checkboxes = this.filterContainer.querySelectorAll(
      "input[type=checkbox]"
    );
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleFilterChange);
    });
  }
  /**
   * Clears filter inputs when resetting filters.
   */
  clearFilterInputs() {
    const checkboxes = this.filterContainer.querySelectorAll(
      "input[type=checkbox]"
    );
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
class MaterialsGuideStateContext extends AlpineStateContext {
  /**
   *
   */
  constructor() {
    super();
    this.activeFilters = [];
    this.setStateValue("activeFilters", this.activeFilters);
  }
  openDrawer() {
    throw new Error("Method not implemented.");
  }
  closeDrawer() {
    throw new Error("Method not implemented.");
  }
  setSelectedMaterial(material) {
    throw new Error("Method not implemented.");
  }
  static getInstance() {
    if (!MaterialsGuideStateContext.instance) {
      MaterialsGuideStateContext.instance = new MaterialsGuideStateContext();
    }
    return MaterialsGuideStateContext.instance;
  }
}
class MaterialsGuideFilter extends Filter {
  /**
   * Constructs the Filter class, binding event handlers for filter changes
   * and provides additional filter configuration specific to materials guide.
   *
   * @param {HTMLElement} filterContainer - The container element that includes the filter controls.
   * @param {HTMLElement} container - The container element that holds the items to be filtered.
   */
  constructor(filterContainer, container) {
    super(filterContainer, container);
    this.filterParameters = [
      "material-type",
      "color",
      "features",
      "grade",
      "tier"
    ];
    this.activeFilters = {};
    this.activeFilterValues = [];
    this.stateContext = MaterialsGuideStateContext.getInstance();
    this.onFilterChangeCallback = () => this.updateActiveFilters();
  }
  init() {
    this.isotopeInstance = new Isotope(this.container, {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      resize: true,
      masonry: {
        columnWidth: ".filter-item"
      }
    });
    super.init();
    this.parseURLAndApplyFilters();
  }
  // TODO: Add to interface
  getIsotopeInstance() {
    return this.isotopeInstance;
  }
  /**
   * Overrides the base class resetFilters method to perform page specific operations.
   */
  resetFilters() {
    super.resetFilters();
    this.updateActiveFilters();
  }
  /**
   * Tracks and updates active filters based on user interaction.
   */
  updateActiveFilters() {
    this.activeFilterValues = this.getActiveFiltersValues() || [];
    this.stateContext.setStateValue("activeFilters", this.activeFilterValues);
  }
  removeFilterValue(value) {
    const group = Object.keys(this.filters).find(
      (key) => this.filters[key].includes(value)
    );
    if (group) {
      this.filters[group] = this.filters[group].filter((v) => v !== value);
      this.updateURL();
      if (this.filters[group].length === 0) {
        delete this.filters[group];
      }
    }
    super.uncheckFilterCheckbox(value);
    this.updateActiveFilters();
    this.applyFilters();
  }
  parseURLAndApplyFilters() {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.forEach((value, key) => {
      if (this.isFilterParameter(key)) {
        const filterValues = value.split(",");
        this.filters[key] = filterValues;
        this.filterContainer.querySelectorAll(`input[name="${key}"][type="checkbox"]`).forEach((input) => {
          const checkbox = input;
          checkbox.checked = filterValues.includes(checkbox.value);
        });
      }
    });
    this.updateActiveFilters();
    this.applyFilters();
  }
  isFilterParameter(parameterName) {
    return this.filterParameters.includes(parameterName);
  }
  getActiveFiltersValues() {
    return Object.values(this.filters).flat();
  }
  // Other methods can be overridden or extended as necessary for the Materials Guide context
}
class Material {
  constructor(id, name, material_type, color, features, grade, image, tier) {
    this.__id = id;
    this._name = name;
    this._material_type = material_type;
    this._color = color;
    this._features = features;
    this._grade = grade;
    this._image = image;
    this._tier = tier;
  }
  set _id(value) {
    this.__id = value;
  }
  get _id() {
    return this.__id;
  }
  get name() {
    return this._name;
  }
  get material_type() {
    return this._material_type;
  }
  get color() {
    return this._color;
  }
  get features() {
    return this._features;
  }
  get grade() {
    return this._grade;
  }
  get image() {
    return this._image;
  }
  set image(value) {
    this._image = value;
  }
  get tier() {
    return this._tier;
  }
  // Other methods related to a material...
}
function getOffsetTop(elm) {
  let offsetTopTemp = 0;
  while (elm) {
    offsetTopTemp += elm.offsetTop;
    elm = elm.offsetParent;
  }
  return offsetTopTemp;
}
function getOffsetLeft(elm) {
  let offsetLeftTemp = 0;
  while (elm) {
    offsetLeftTemp += elm.offsetLeft;
    elm = elm.offsetParent;
  }
  return offsetLeftTemp;
}
function magnify(imgClass) {
  const images = Array.from(
    document.querySelectorAll(`.${imgClass}`)
  );
  images.forEach((img) => {
    const magnified = document.querySelector(
      "div.ll-matguide-img_zoom-lrg"
    );
    img.addEventListener("mouseenter", () => {
      magnified.style.opacity = "1";
    });
    img.addEventListener("mouseleave", () => {
      magnified.style.opacity = "0";
    });
    img.addEventListener(
      "mousemove",
      (e) => {
        const original = document.querySelector(
          "img.ll-matguide-img_zoom"
        );
        const style = magnified.style;
        const x2 = e.pageX - getOffsetLeft(img);
        const y = e.pageY - getOffsetTop(img);
        const imgWidth = original.width;
        const imgHeight = original.height;
        let xperc = x2 / imgWidth * 100;
        let yperc = y / imgHeight * 100;
        if (x2 > 0.01 * imgWidth) {
          xperc += 0.15 * xperc;
        }
        if (y >= 0.01 * imgHeight) {
          yperc += 0.15 * yperc;
        }
        style.backgroundPositionX = `${xperc - 9}%`;
        style.backgroundPositionY = `${yperc - 9}%`;
        style.left = `${x2 - 50}px`;
        style.top = `${y - 50}px`;
      },
      false
    );
  });
}
class MaterialsGuidePage extends Page {
  constructor() {
    super();
    this._filter = null;
    this._showMaterialDrawer = false;
    this._materials = [];
    this.closeDrawer = () => {
      this.selectedMaterial = void 0;
      this.showMaterialDrawer = false;
    };
    this.stateContext = MaterialsGuideStateContext.getInstance();
  }
  get filter() {
    return this._filter;
  }
  set filter(value) {
    this._filter = value;
  }
  set selectedMaterial(value) {
    this._selectedMaterial = value;
    this.updateSelectedmaterialState();
  }
  get selectedMaterial() {
    return this._selectedMaterial;
  }
  set showMaterialDrawer(value) {
    this._showMaterialDrawer = value;
    this.updateAlpineDrawerState();
  }
  get showMaterialDrawer() {
    return this._showMaterialDrawer;
  }
  set materials(materials) {
    this._materials = materials;
  }
  get materials() {
    return this._materials;
  }
  /**
   * Initializes the Materials Guide page, creating the Alpine store to track the drawer state.
   */
  init() {
    console.log("Initializing the Materials Guide page...");
    this.updateAlpineDrawerState();
  }
  initScrollEvent() {
    window.addEventListener(
      "scroll",
      this.debounce(() => {
        this.initImageMagnifier("ll-matguide-img_zoom");
      }, 250)
    );
  }
  resetFilters() {
    var _a;
    (_a = this.filter) == null ? void 0 : _a.resetFilters();
  }
  /**
   * Initializes states specific to mobile devices, like the filter drawer visibility.
   */
  mobileStateInit() {
    this.stateContext.setStateValue("showFilterDrawer", false);
  }
  /**
   * Toggles the visibility of the filter drawer.
   */
  toggleFilterDrawer() {
    const currState = this.stateContext.getStateValue("showFilterDrawer");
    this.stateContext.setStateValue("showFilterDrawer", !currState);
  }
  /**
   * Opens the filter drawer by setting its state to true.
   */
  openFilterDrawer() {
    this.stateContext.setStateValue("showFilterDrawer", true);
  }
  /**
   * Closes the filter drawer by setting its state to false.
   */
  closeFilterDrawer() {
    this.stateContext.setStateValue("showFilterDrawer", false);
  }
  /**
   * Adds a new material to the materials array, assigning a unique ID if necessary.
   * @param {Material} materialData - The data for the new material to add.
   */
  addMaterial(materialData) {
    var _a;
    if (!materialData._id) {
      materialData._id = materialData.name.replace(" ", "_").toLowerCase();
    }
    const material = new Material(
      materialData._id,
      materialData.name,
      materialData.material_type,
      materialData.color,
      materialData.features,
      materialData.grade,
      materialData.image,
      materialData.tier
    );
    this._materials.push(material);
    (_a = this.filter) == null ? void 0 : _a.layout();
  }
  /**
   * Initializes or re-initializes the Isotope instance for the filter functionality.
   */
  initiateIsotope() {
    var _a, _b;
    const isotopeInstance = (_a = this.filter) == null ? void 0 : _a.getIsotopeInstance();
    const filterContainer = document.getElementById(
      "filter-sidebar"
    );
    const container = document.getElementById(
      "ll-matguide-filter-container"
    );
    if (isotopeInstance) {
      isotopeInstance.destroy();
    }
    this.filter = new MaterialsGuideFilter(filterContainer, container);
    this.filter.init();
    (_b = this.filter) == null ? void 0 : _b.layout();
  }
  /**
   * Handles the click event on a material card, setting the selected material and toggling the drawer state.
   * @param {Event} event - The click event from the material card.
   */
  materialClicked(event) {
    const element2 = event.currentTarget;
    const id = element2.getAttribute("id");
    const material = this.getMaterialById(id);
    material.image = element2.dataset.image;
    this.selectedMaterial = material;
    this.showMaterialDrawer = this.showMaterialDrawer === false ? true : this.showMaterialDrawer;
    this.updateAlpineDrawerState();
    setTimeout(() => {
      if (this.stateContext.getStateValue("isMobile") === false) {
        window.scrollTo(0, 0);
      }
    }, 500);
  }
  /**
   * Initializes the image magnifier functionality on the specified selector.
   * @param {string} selector - The CSS selector for the element to apply the magnifier.
   */
  initImageMagnifier(selector) {
    magnify(selector);
  }
  /**
   * Updates the selected material state in the Alpine store.
   * This method should be called whenever the selected material changes.
   */
  updateSelectedmaterialState() {
    this.stateContext.setStateValue("selectedMaterial", this._selectedMaterial);
  }
  /**
   * Updates the Alpine store to reflect the current state of the material drawer.
   * This includes whether the drawer is open or closed.
   */
  updateAlpineDrawerState() {
    var _a, _b;
    this.stateContext.setStateValue("drawerState", {
      open: this.showMaterialDrawer
    });
    if ((_a = this.filter) == null ? void 0 : _a.getIsotopeInstance()) {
      (_b = this.filter) == null ? void 0 : _b.layout();
    }
  }
  /**
   * Retrieves a material by its ID.
   * @param {string | null} id - The ID of the material to retrieve.
   * @returns {Material | undefined} - The found material or undefined if no material matches the ID.
   */
  getMaterialById(id) {
    return this._materials.find((material) => material._id === id);
  }
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
class BasicPage extends Page {
  /**
   *
   */
  constructor() {
    super();
    this._showHeader = true;
  }
  init(title) {
    this.pageTitle = title;
    this.stateContext.setStateValue("showPageHeader", this._showHeader);
    this.showHideHeader();
  }
  showHideHeader() {
    switch (this.pageTitle) {
      case "Affirm":
        this.hideHeader();
        break;
      case "Warranty Information":
        this.hideHeader();
        break;
    }
  }
  hideHeader() {
    console.log("Hiding the header");
    this.stateContext.setStateValue("showPageHeader", false);
  }
}
class CareersPage extends Page {
  init(args) {
    console.log("Careers Page Initiated");
    this.initIsotope();
  }
  initIsotope() {
    console.log("Initiating isotope");
    imagesLoaded("#gallery .iso-grid", () => {
      this.isotopeInstance = new Isotope("#gallery .iso-grid", {
        itemSelector: ".gallery-item",
        percentPosition: true,
        masonry: {
          columnWidth: ".gallery-item"
        }
      });
    });
  }
}
class Pagination {
  constructor(items, pageSize = 5) {
    this.items = items;
    this.pageSize = pageSize;
    this._currentPage = 1;
    this.totalItems = items == null ? void 0 : items.length;
    this._totalPages = Math.ceil(this.totalItems / this.pageSize);
  }
  /**
   * Moves to a specified page.
   * @param pageNumber the number which to go to
   * @returns
   */
  goToPage(pageNumber) {
    if (pageNumber < 1 || pageNumber > this.totalPages) {
      console.error("Page number out of range.");
      return;
    }
    this.currentPage = pageNumber;
    this.renderPage();
  }
  get currentPage() {
    return this._currentPage;
  }
  set currentPage(value) {
    this._currentPage = value;
  }
  /**
   * Grabs the total number of pages.
   */
  get totalPages() {
    return this._totalPages;
  }
  /**
   * Renders the articles on the page
   */
  renderPage() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.totalItems);
    const itemsToDisplay = this.items.slice(startIndex, endIndex);
    const articlesContainer = document.getElementById("articles-container");
    if (articlesContainer) {
      articlesContainer.innerHTML = "";
      itemsToDisplay.forEach((article) => {
        const articleHtml = this.renderArticle(article);
        const articleElement = document.createElement("div");
        articleElement.className = "article-container flex w-full max-w-[320px] md:w-1/2 lg:w-1/3 lg:max-w-[460px] lg:max-h-[488px] relative";
        articleElement.innerHTML = articleHtml;
        articlesContainer.appendChild(articleElement);
      });
    }
  }
  // TODO: Make this class more generic, right now this is specific to the blogs page.
  /**
   * Takes the collection of article data and renders the article element on the page.
   * @param article the article in which to render
   * @returns
   */
  renderArticle(article) {
    return `
    <div class="flex flex-col bg-white rounded-[4px] overflow-hidden h-auto lg:w-[460px]">
        <div class="flex bg-gray-300 border--radius--lg overflow-hidden w-[320px] h-[200px] lg:w-[460px] lg:h-[368px]">
            <img src="${article.image}" alt="${article.imageAlt}" class="object-cover" />
        </div>
        <div class="flex flex-col w-full h-auto">
            <div>
                <div class="absolute top-[16px] left-[16px] px-2 py-[6px] body-2 color__bg-mid-day rounded-[4px]">
                    <span class="font-semibold uppercase tracking-widest px-2 py-1">
                        ${article.handle}
                    </span>
                </div>
                <h4 class="mt-4 mb-2 font-bold text-lg leading-tight">
                    <a href="${article.url}" class="">
                        ${article.title}
                    </a>
                </h4>
            </div>
            <a href="${article.url}" class="font-semibold text-ll-deep-end mt-4">
                Learn More →
            </a>
        </div>
    </div>

        `;
  }
  /**
   * Moves to the next page.
   */
  next() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }
  /**
   * Moves to the previous page.
   */
  previous() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }
}
class BlogsPageStateContext extends AlpineStateContext {
  /**
   *
   */
  constructor() {
    super();
  }
  // TODO: Refactor to base class
  static getInstance() {
    if (!BlogsPageStateContext.instance) {
      BlogsPageStateContext.instance = new BlogsPageStateContext();
    }
    return BlogsPageStateContext.instance;
  }
}
class BlogsPage extends Page {
  /**
   *
   */
  constructor() {
    super();
    this.articlesPerPage = 6;
    this.stateContext = BlogsPageStateContext.getInstance();
  }
  init(articlesData) {
    this.setupPagination(articlesData);
    this.updatePageState();
    this.stateContext.setStateValue("totalPages", this.getTotalPages());
    this.setupBrowserHistoryHandling();
  }
  getPagesToDisplay() {
    const windowSize = 5;
    const pages = [];
    const halfWindowSize = Math.floor(windowSize / 2);
    this.stateContext.setStateValue("halfWindowSize", halfWindowSize);
    let start2 = Math.max(this.pagination.currentPage - halfWindowSize, 1);
    let end = Math.min(start2 + windowSize - 1, this.pagination.totalPages);
    if (end === this.pagination.totalPages) {
      start2 = Math.max(this.pagination.totalPages - windowSize + 1, 1);
    }
    for (let i = start2; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
  // public updatePaginationControls(): void {
  //   const paginationContainer = document.getElementById('pagination-buttons');
  //   if (!paginationContainer) return;
  //   paginationContainer.innerHTML = '';
  //   // Page number links
  //   for (let i = 1; i <= this.pagination.totalPages; i++) {
  //     const pageLink = document.createElement('a');
  //     pageLink.href = `?page=${i}`;
  //     pageLink.textContent = i.toString();
  //     pageLink.className = i === this.pagination.currentPage ? 'font-black text-ll-deep-end' : 'text-ll-deep-end underline font-semibold';
  //     pageLink.onclick = (e) => {
  //       e.preventDefault();
  //       this.goToPageNumber(i);
  //     };
  //     paginationContainer.appendChild(pageLink);
  //   }
  // }
  getTotalPages() {
    return this.pagination.totalPages;
  }
  next() {
    if (this.pagination.currentPage === this.getTotalPages()) {
      return;
    }
    const nextPage = this.pagination.currentPage + 1;
    this.goToPage(nextPage);
    this.updatePageState();
  }
  previous() {
    if (this.pagination.currentPage === 1) {
      return;
    }
    const prevPage = this.pagination.currentPage - 1;
    this.goToPage(prevPage);
    this.updatePageState();
  }
  // public goToFirstPage(): void {
  //   this.goToPage(1);
  //   this.updatePaginationControls();
  //   this.updatePageState();
  // }
  // public goToLastPage(): void {
  //   this.goToPage(this.pagination.totalPages);
  //   this.updatePaginationControls();
  //   this.updatePageState();
  // }
  goToPage(pageNumber) {
    this.pagination.goToPage(pageNumber);
    this.updateBrowserHistory(pageNumber);
    this.updatePageState();
  }
  goToPageNumber(pageNumber) {
    if (pageNumber >= 1 && pageNumber <= this.pagination.totalPages) {
      this.goToPage(pageNumber);
      this.updatePageState();
    }
  }
  updatePageState() {
    this.stateContext.setStateValue("currentPage", this.pagination.currentPage);
  }
  setupPagination(articles) {
    this.pagination = new Pagination(articles, this.articlesPerPage);
    const startPage = this.getCurrentPageFromUrl() || 1;
    this.pagination.goToPage(startPage);
    if (startPage === 1 && !window.location.search.includes("page=")) {
      this.updateBrowserHistory(startPage);
    }
  }
  setupBrowserHistoryHandling() {
    window.onpopstate = (event) => {
      if (event.state && event.state.page) {
        this.pagination.goToPage(event.state.page);
      }
    };
  }
  updateBrowserHistory(pageNumber) {
    const newUrl = this.updateQueryStringParameter(
      window.location.href,
      "page",
      pageNumber
    );
    history.pushState({ page: pageNumber }, "", newUrl);
  }
  updateQueryStringParameter(uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      return uri + separator + key + "=" + value;
    }
  }
  getCurrentPageFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page");
    return page ? parseInt(page, 10) : null;
  }
}
class BasePage extends Page {
  init(args) {
    super.pageTemplate = args.template;
    console.log(`In the base class for template: ${super.pageTemplate}`);
  }
  dfcClickEvent() {
    window.dfc.track("CRO-1167-des-svcs-cta-clicked");
  }
}
class AccountRegister extends Page {
  constructor() {
    super(...arguments);
    this.signupForm = void 0;
    this.referralField = void 0;
    this.referralValid = false;
  }
  init(args) {
    window.addEventListener("load", () => {
      var _a;
      console.log("Accounts page initiated");
      this.signupForm = (_a = document.querySelector(".globo-form-app")) == null ? void 0 : _a.querySelector("form");
      this.addFormSubmitEventListener();
      this.addReferralEventListener();
    });
  }
  addFormSubmitEventListener() {
    var _a;
    (_a = this.signupForm) == null ? void 0 : _a.addEventListener("submit", () => {
      if (this.referralValid == false)
        ;
      return true;
    });
  }
  addReferralEventListener() {
    var _a;
    this.referralField = document.getElementById("30644-text-1");
    const errorField = (_a = this.referralField.closest("div.globo-form-control")) == null ? void 0 : _a.querySelector(".messages");
    if (this.referralField) {
      this.referralField.addEventListener("change", async (e) => {
        const element2 = e.currentTarget;
        element2.value = element2.value.trim();
        this.referralValid = await this.validateReferralCode(element2.value);
        if (this.referralValid) {
          this.clearHiddenFields();
          this.clearReferralError(errorField);
          this.populateHiddenFields();
        } else {
          this.clearHiddenFields();
          this.populateHiddenFields(false);
          this.setReferralError(errorField);
        }
      });
    }
  }
  setReferralError(errorField) {
    if (errorField) {
      errorField.innerHTML = "Referral code is invalid";
    }
    document.addEventListener("globo.formbuilder.form.onsubmit", () => {
      console.log("Testing");
    });
  }
  clearReferralError(errorField) {
    if (errorField) {
      errorField.innerHTML = "";
    }
  }
  clearReferralField() {
    if (this.referralField) {
      this.referralField.value = "";
    }
  }
  clearHiddenFields() {
    const builderField = document.querySelector("input#hidden-1");
    const LOCMemberField = document.querySelector("input#hidden-2");
    const LOCReviewFIeld = document.querySelector("input#hidden-3");
    if (builderField && builderField.value !== "") {
      builderField.value = "";
    }
    if (LOCMemberField && LOCMemberField.value !== "") {
      LOCMemberField.value = "";
    }
    if (LOCReviewFIeld && LOCReviewFIeld.value !== "") {
      LOCReviewFIeld.value = "";
    }
  }
  populateHiddenFields(referralValid = true) {
    var _a;
    if (referralValid) {
      const builderField = document.querySelector("input#hidden-1");
      const LOCMemberField = document.querySelector("input#hidden-2");
      const match = (_a = this.referralField) == null ? void 0 : _a.value.match(/^([a-zA-Z0-9]+)-/);
      if (builderField && match) {
        builderField.value = "Builder-" + match[1];
      }
      LOCMemberField.value = "LOCMember";
    } else {
      const reviewField = document.querySelector("input#hidden-3");
      reviewField.value = "LOCReview";
    }
  }
  async validateReferralCode(code) {
    console.log("log for finding file in staging");
    const bodyObj = {
      acode: code
    };
    const url = "https://ledgeloungers.com/apps/felix/api/v2/public/ns/check-referral";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(bodyObj)
      });
      if (!response.ok) {
        throw new Error(`Server responded with status ${response.status}`);
      }
      const responseData = await response.json();
      return responseData;
    } catch (error2) {
      console.error("Error validating referral code:", error2);
      return false;
    }
  }
}
const locLandingPage = {
  // Hidden for for Customer Service on LOC Signup Page
  hiddenContactFormLoc: function() {
    window.addEventListener("load", () => {
      console.log("Initialized Contact Form");
      const formContainer = document.getElementById("ledge-owners__form-container");
      let errorElm = null;
      if (formContainer) {
        errorElm = formContainer == null ? void 0 : formContainer.querySelector("div.message.error");
        const options = {
          subtree: true,
          childList: true
        };
        if (errorElm !== null) {
          const logCallback = (mutations) => {
            console.log("mutation running");
            mutations.forEach((mutation) => {
              const contactUsElm = document.getElementById("loc-activation-contact-form");
              if (contactUsElm) {
                const errorMessageElm = document.querySelector("span.err");
                const errorMessage = errorMessageElm ? errorMessageElm.innerText : null;
                let errorFlag = false;
                if ((errorMessage == null ? void 0 : errorMessage.toLowerCase().includes("phone has already")) || (errorMessage == null ? void 0 : errorMessage.toLowerCase().includes("customer already exists"))) {
                  errorFlag = true;
                }
                errorFlag ? contactUsElm.classList.remove("hidden") : "";
              }
            });
          };
          const observer2 = new MutationObserver(logCallback);
          observer2.observe(errorElm, options);
        }
      }
    });
  },
  // one click contact form logic
  oneClickContact: function() {
    const registrationFormContainer = document.querySelector('form[data-id="30644"]');
    const hiddenFormContainer = document.querySelector('form[data-id="40548"]');
    if (registrationFormContainer && hiddenFormContainer) {
      const hiddenSubmitBtn = hiddenFormContainer.querySelector('button[type="submit"]');
      const contactBtn = document.querySelector("button#loc-activation-contact-contact-button");
      const successMessage = document.querySelector("#loc-activation-contact-success");
      const registrationFormInputs = [...registrationFormContainer.querySelectorAll("input")];
      const hiddenFormInputs = [...hiddenFormContainer.querySelectorAll("input")];
      let referralCode = "";
      let firstName = "";
      let lastName = "";
      let email = "";
      let phoneNumber = "";
      let address1 = "";
      let address2 = "";
      let city = "";
      let state = "";
      let zip = "";
      const inputSwitch = (input) => {
        switch (input.name) {
          case "text-1":
            if (input.id.includes("30644")) {
              referralCode = input.value;
            } else {
              input.value = referralCode;
            }
            break;
          case "name-1":
            if (input.id.includes("30644")) {
              firstName = input.value;
            } else {
              input.value = firstName;
            }
            break;
          case "name-2":
            if (input.id.includes("30644")) {
              lastName = input.value;
            } else {
              input.value = lastName;
            }
            break;
          case "email-1":
            if (input.id.includes("30644")) {
              email = input.value;
            } else {
              input.value = email;
            }
            break;
          case "text-2":
            if (input.id.includes("30644")) {
              phoneNumber = input.value;
            } else {
              input.value = phoneNumber;
            }
            break;
          case "text-3":
            if (input.id.includes("30644")) {
              address1 = input.value;
            } else {
              input.value = address1;
            }
            break;
          case "text-4":
            if (input.id.includes("30644")) {
              address2 = input.value;
            } else {
              input.value = address2;
            }
            break;
          case "text-5":
            if (input.id.includes("30644")) {
              city = input.value;
            } else {
              input.value = city;
            }
            break;
          case "text-6":
            if (input.id.includes("30644")) {
              state = input.value;
            } else {
              input.value = state;
            }
            break;
          case "text-7":
            if (input.id.includes("30644")) {
              zip = input.value;
            } else {
              input.value = zip;
            }
            break;
        }
      };
      if (registrationFormInputs && hiddenFormInputs) {
        registrationFormInputs.forEach((input) => {
          inputSwitch(input);
        });
        hiddenFormInputs.forEach((input) => {
          inputSwitch(input);
        });
        if (hiddenSubmitBtn) {
          setTimeout(() => {
            hiddenSubmitBtn.click();
            contactBtn.disabled = true;
            contactBtn.innerText = "Success";
            successMessage ? successMessage.classList.remove("hidden") : console.log("Success Message Error");
          }, 1e3);
        }
      }
    }
  }
};
let pdpInstance = new ProductDescriptionPage();
let matGuideInstance = new MaterialsGuidePage();
let carrersPageInstance = new CareersPage();
let basicPageInstance = new BasicPage();
let blogsPageInstance = new BlogsPage();
let basePageInstance = new BasePage();
let accountRegisterPageInstance = new AccountRegister();
let Shopify$1 = window.Shopify || {};
Shopify$1.formatMoney = formatMoney;
initAnimationObserver();
window.app = function() {
  return {
    // Spread globals
    ...globals,
    ...cart,
    pdp: pdpInstance,
    matPage: matGuideInstance,
    basicPage: basicPageInstance,
    blogsPage: blogsPageInstance,
    carrsPage: carrersPageInstance,
    actRegPage: accountRegisterPageInstance,
    basePage: basePageInstance,
    ...search,
    ...collections,
    ...products,
    ...utils$1,
    ...locLandingPage
  };
};
/*! instant.page v5.1.1 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
let mouseoverTimer;
let lastTouchTimestamp;
const prefetches = /* @__PURE__ */ new Set();
const prefetchElement = document.createElement("link");
const isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports("prefetch") && window.IntersectionObserver && "isIntersecting" in IntersectionObserverEntry.prototype;
const allowQueryString = "instantAllowQueryString" in document.body.dataset;
const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
const useWhitelist = "instantWhitelist" in document.body.dataset;
const mousedownShortcut = "instantMousedownShortcut" in document.body.dataset;
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
let delayOnHover = 65;
let useMousedown = false;
let useMousedownOnly = false;
let useViewport = false;
if ("instantIntensity" in document.body.dataset) {
  const intensity = document.body.dataset.instantIntensity;
  if (intensity.substr(0, "mousedown".length) == "mousedown") {
    useMousedown = true;
    if (intensity == "mousedown-only") {
      useMousedownOnly = true;
    }
  } else if (intensity.substr(0, "viewport".length) == "viewport") {
    if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g")))) {
      if (intensity == "viewport") {
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4) {
          useViewport = true;
        }
      } else if (intensity == "viewport-all") {
        useViewport = true;
      }
    }
  } else {
    const milliseconds = parseInt(intensity);
    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds;
    }
  }
}
if (isSupported) {
  const eventListenersOptions = {
    capture: true,
    passive: true
  };
  if (!useMousedownOnly) {
    document.addEventListener("touchstart", touchstartListener, eventListenersOptions);
  }
  if (!useMousedown) {
    document.addEventListener("mouseover", mouseoverListener, eventListenersOptions);
  } else if (!mousedownShortcut) {
    document.addEventListener("mousedown", mousedownListener, eventListenersOptions);
  }
  if (mousedownShortcut) {
    document.addEventListener("mousedown", mousedownShortcutListener, eventListenersOptions);
  }
  if (useViewport) {
    let triggeringFunction;
    if (window.requestIdleCallback) {
      triggeringFunction = (callback2) => {
        requestIdleCallback(callback2, {
          timeout: 1500
        });
      };
    } else {
      triggeringFunction = (callback2) => {
        callback2();
      };
    }
    triggeringFunction(() => {
      const intersectionObserver = new IntersectionObserver((entries2) => {
        entries2.forEach((entry2) => {
          if (entry2.isIntersecting) {
            const linkElement = entry2.target;
            intersectionObserver.unobserve(linkElement);
            preload(linkElement.href);
          }
        });
      });
      document.querySelectorAll("a").forEach((linkElement) => {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement);
        }
      });
    });
  }
}
function touchstartListener(event) {
  lastTouchTimestamp = performance.now();
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  preload(linkElement.href);
}
function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }
  if (!("closest" in event.target)) {
    return;
  }
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  linkElement.addEventListener("mouseout", mouseoutListener, { passive: true });
  mouseoverTimer = setTimeout(() => {
    preload(linkElement.href);
    mouseoverTimer = void 0;
  }, delayOnHover);
}
function mousedownListener(event) {
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  preload(linkElement.href);
}
function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest("a") == event.relatedTarget.closest("a")) {
    return;
  }
  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = void 0;
  }
}
function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }
  const linkElement = event.target.closest("a");
  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }
  if (!linkElement) {
    return;
  }
  linkElement.addEventListener("click", function(event2) {
    if (event2.detail == 1337) {
      return;
    }
    event2.preventDefault();
  }, { capture: true, passive: false, once: true });
  const customEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: false, detail: 1337 });
  linkElement.dispatchEvent(customEvent);
}
function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return;
  }
  if (useWhitelist && !("instant" in linkElement.dataset)) {
    return;
  }
  if (!allowExternalLinks && linkElement.origin != location.origin && !("instant" in linkElement.dataset)) {
    return;
  }
  if (!["http:", "https:"].includes(linkElement.protocol)) {
    return;
  }
  if (linkElement.protocol == "http:" && location.protocol == "https:") {
    return;
  }
  if (!allowQueryString && linkElement.search && !("instant" in linkElement.dataset)) {
    return;
  }
  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return;
  }
  if ("noInstant" in linkElement.dataset) {
    return;
  }
  return true;
}
function preload(url) {
  if (prefetches.has(url)) {
    return;
  }
  const prefetcher = document.createElement("link");
  prefetcher.rel = "prefetch";
  prefetcher.href = url;
  document.head.appendChild(prefetcher);
  prefetches.add(url);
}
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element2) {
  return element2.getRootNode();
} : function(element2) {
  return element2.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element2 = elementsToCheck.shift();
    if (element2.tagName === "SLOT") {
      var assigned = element2.assignedElements();
      var content = assigned.length ? assigned : element2.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element2,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element2, candidateSelector);
      if (validCandidate && options.filter(element2) && (includeContainer || !elements.includes(element2))) {
        candidates.push(element2);
      }
      var shadowRoot = element2.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element2);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element2);
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element2.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element2,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element2.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
  if (node.tabIndex < 0) {
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  var nodeRootHost = getRootNode(node).host;
  var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
  if (!displayCheck || displayCheck === "full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (nodeIsAttached) {
      return !node.getClientRects().length;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item2, i) {
    var isScope = !!item2.scope;
    var element2 = isScope ? item2.scope : item2;
    var candidateTabindex = getTabindex(element2, isScope);
    var elements = isScope ? sortByOrder2(item2.candidates) : element2;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element2);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item2,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = function() {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element2) {
    return state.containerGroups.findIndex(function(_ref) {
      var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
      return container.contains(element2) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function(node) {
        return node === element2;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container,
        tabbableNodes,
        focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = focusableNodes.findIndex(function(n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return void 0;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function(n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element2) {
        return typeof element2 === "string" ? doc.querySelector(element2) : element2;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
function src_default$2(Alpine2) {
  let lastFocused;
  let currentFocused;
  window.addEventListener("focusin", () => {
    lastFocused = currentFocused;
    currentFocused = document.activeElement;
  });
  Alpine2.magic("focus", (el) => {
    let within = el;
    return {
      __noscroll: false,
      __wrapAround: false,
      within(el2) {
        within = el2;
        return this;
      },
      withoutScrolling() {
        this.__noscroll = true;
        return this;
      },
      noscroll() {
        this.__noscroll = true;
        return this;
      },
      withWrapAround() {
        this.__wrapAround = true;
        return this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(el2) {
        return isFocusable(el2);
      },
      previouslyFocused() {
        return lastFocused;
      },
      lastFocused() {
        return lastFocused;
      },
      focused() {
        return currentFocused;
      },
      focusables() {
        if (Array.isArray(within))
          return within;
        return focusable(within, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(el2) {
        let els = this.all();
        return els[0] && els[0].isSameNode(el2);
      },
      isLast(el2) {
        let els = this.all();
        return els.length && els.slice(-1)[0].isSameNode(el2);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === list.length - 1) {
          return list[0];
        }
        return list[list.indexOf(current) + 1];
      },
      getPrevious() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === 0) {
          return list.slice(-1)[0];
        }
        return list[list.indexOf(current) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(el2) {
        if (!el2)
          return;
        setTimeout(() => {
          if (!el2.hasAttribute("tabindex"))
            el2.setAttribute("tabindex", "0");
          el2.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  });
  Alpine2.directive("trap", Alpine2.skipDuringClone(
    (el, { expression, modifiers }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let evaluator = evaluateLater2(expression);
      let oldValue = false;
      let options = {
        escapeDeactivates: false,
        allowOutsideClick: true,
        fallbackFocus: () => el
      };
      if (modifiers.includes("noautofocus")) {
        options.initialFocus = false;
      } else {
        let autofocusEl = el.querySelector("[autofocus]");
        if (autofocusEl)
          options.initialFocus = autofocusEl;
      }
      let trap = createFocusTrap(el, options);
      let undoInert = () => {
      };
      let undoDisableScrolling = () => {
      };
      const releaseFocus = () => {
        undoInert();
        undoInert = () => {
        };
        undoDisableScrolling();
        undoDisableScrolling = () => {
        };
        trap.deactivate({
          returnFocus: !modifiers.includes("noreturn")
        });
      };
      effect3(() => evaluator((value) => {
        if (oldValue === value)
          return;
        if (value && !oldValue) {
          if (modifiers.includes("noscroll"))
            undoDisableScrolling = disableScrolling();
          if (modifiers.includes("inert"))
            undoInert = setInert(el);
          setTimeout(() => {
            trap.activate();
          }, 15);
        }
        if (!value && oldValue) {
          releaseFocus();
        }
        oldValue = !!value;
      }));
      cleanup2(releaseFocus);
    },
    // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate: evaluate2 }) => {
      if (modifiers.includes("inert") && evaluate2(expression))
        setInert(el);
    }
  ));
}
function setInert(el) {
  let undos = [];
  crawlSiblingsUp(el, (sibling) => {
    let cache = sibling.hasAttribute("aria-hidden");
    sibling.setAttribute("aria-hidden", "true");
    undos.push(() => cache || sibling.removeAttribute("aria-hidden"));
  });
  return () => {
    while (undos.length)
      undos.pop()();
  };
}
function crawlSiblingsUp(el, callback2) {
  if (el.isSameNode(document.body) || !el.parentNode)
    return;
  Array.from(el.parentNode.children).forEach((sibling) => {
    if (sibling.isSameNode(el)) {
      crawlSiblingsUp(el.parentNode, callback2);
    } else {
      callback2(sibling);
    }
  });
}
function disableScrolling() {
  let overflow = document.documentElement.style.overflow;
  let paddingRight = document.documentElement.style.paddingRight;
  let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  return () => {
    document.documentElement.style.overflow = overflow;
    document.documentElement.style.paddingRight = paddingRight;
  };
}
var module_default$2 = src_default$2;
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/
function src_default$1(Alpine2) {
  Alpine2.directive("intersect", Alpine2.skipDuringClone((el, { value, expression, modifiers }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater2(expression);
    let options = {
      rootMargin: getRootMargin(modifiers),
      threshold: getThreshold(modifiers)
    };
    let observer2 = new IntersectionObserver((entries2) => {
      entries2.forEach((entry2) => {
        if (entry2.isIntersecting === (value === "leave"))
          return;
        evaluate2();
        modifiers.includes("once") && observer2.disconnect();
      });
    }, options);
    observer2.observe(el);
    cleanup2(() => {
      observer2.disconnect();
    });
  }));
}
function getThreshold(modifiers) {
  if (modifiers.includes("full"))
    return 0.99;
  if (modifiers.includes("half"))
    return 0.5;
  if (!modifiers.includes("threshold"))
    return 0;
  let threshold = modifiers[modifiers.indexOf("threshold") + 1];
  if (threshold === "100")
    return 1;
  if (threshold === "0")
    return 0;
  return Number(`.${threshold}`);
}
function getLengthValue(rawValue) {
  let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
  return match ? match[1] + (match[2] || "px") : void 0;
}
function getRootMargin(modifiers) {
  const key = "margin";
  const fallback = "0px 0px 0px 0px";
  const index = modifiers.indexOf(key);
  if (index === -1)
    return fallback;
  let values = [];
  for (let i = 1; i < 5; i++) {
    values.push(getLengthValue(modifiers[index + i] || ""));
  }
  values = values.filter((v) => v !== void 0);
  return values.length ? values.join(" ").trim() : fallback;
}
var module_default$1 = src_default$1;
function src_default(Alpine2) {
  let persist = () => {
    let alias;
    let storage;
    try {
      storage = localStorage;
    } catch (e) {
      console.error(e);
      console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
      let dummy = /* @__PURE__ */ new Map();
      storage = {
        getItem: dummy.get.bind(dummy),
        setItem: dummy.set.bind(dummy)
      };
    }
    return Alpine2.interceptor((initialValue, getter, setter, path, key) => {
      let lookup = alias || `_x_${path}`;
      let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
      setter(initial);
      Alpine2.effect(() => {
        let value = getter();
        storageSet(lookup, value, storage);
        setter(value);
      });
      return initial;
    }, (func) => {
      func.as = (key) => {
        alias = key;
        return func;
      }, func.using = (target) => {
        storage = target;
        return func;
      };
    });
  };
  Object.defineProperty(Alpine2, "$persist", { get: () => persist() });
  Alpine2.magic("persist", persist);
  Alpine2.persist = (key, { get: get3, set: set3 }, storage = localStorage) => {
    let initial = storageHas(key, storage) ? storageGet(key, storage) : get3();
    set3(initial);
    Alpine2.effect(() => {
      let value = get3();
      storageSet(key, value, storage);
      set3(value);
    });
  };
}
function storageHas(key, storage) {
  return storage.getItem(key) !== null;
}
function storageGet(key, storage) {
  let value = storage.getItem(key, storage);
  if (value === void 0)
    return;
  return JSON.parse(value);
}
function storageSet(key, value, storage) {
  storage.setItem(key, JSON.stringify(value));
}
var module_default = src_default;
const doubleRequestAnimationFrame = (callback2) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback2);
  });
};
function $forceNextTick(callback2 = () => {
}) {
  if (callback2 && typeof callback2 === "function") {
    doubleRequestAnimationFrame(callback2);
  } else {
    return new Promise((resolve) => {
      doubleRequestAnimationFrame(resolve);
    });
  }
}
module_default$3.plugin(module_default);
module_default$3.plugin(module_default$2);
module_default$3.plugin(module_default$1);
module_default$3.magic("forceNextTick", () => $forceNextTick);
window.Alpine = module_default$3;
module_default$3.start();
